import { useState, useEffect, useCallback, useRef, useMemo, useLayoutEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReloadOnRouteEnter } from "../hooks/useReloadOnRouteEnter";
import { useTheme } from "../components/ThemeProvider";
import { useAuth } from "../context/AuthContext";
import usePermiso from "../hooks/usePermiso";
import api from "../services/api";
import { dialogs } from "../context/DialogContext";
import ModalCita from "../components/ModalCita";
import ModalWhatsApp from "../components/ModalWhatsApp";
import ModalEmail from "../components/ModalEmail";
import ModalNota from "../components/ModalNota";
import ModalPortales from "../components/ModalPortales";
import ModalImprimirPropiedades from "../components/propiedades/ModalImprimirPropiedades";
import ModalDetallePropiedad from "../components/ModalDetallePropiedad";
import AddressAutocompleteInput from "../components/AddressAutocompleteInput";
import LeadArchivoMenu from "../components/LeadArchivoActions";
import TaskCurrentCard from "../components/TaskCurrentCard";
import ModalResultadoCualificacion from "../components/ModalResultadoCualificacion";
import { taskNeedsM1Modal, taskNeedsM2Modal, taskIsM1Type, taskIsM2Type, isWhatsappWaitingTask, isWhatsappFlowTask, hasWhatsappReplyPending, parseTaskMetadata, isT4bObjecionesDescarteTask, isSinPropiedadesBuscarTask, isT4b1AutoContactTask, isT4b1Task, isT4b1PendingContact, isAnaManagedLeadTask, isAnaQualificationTask, isVisitFeedbackTask, getVisitAgendaId, isT4PostVisitaEspera } from "../constants/leadFlowOutcomes";
import ModalResultadoVisita from "../components/ModalResultadoVisita";
import ModalResultadoTareaAgente, { isAgenteResultTask } from "../components/ModalResultadoTareaAgente";
import ModalNuevoLead from "../components/ModalNuevoLead";
import { colorHexProcedencia, fuenteVisibleEnLead, textOnSolidColor } from "../utils/procedenciaColor";
import { abrirVistaClientePresentacion } from "../utils/abrirVistaClientePresentacion";
import { FichaResumenGaleria, FichaResumenVistaSecciones } from "../components/propiedades/FichaResumenVistaSecciones";
import { cargarDatosFichaResumen } from "../components/propiedades/cargarDatosFichaResumen";
import VistaPreviaRefPrecio from "../components/propiedades/VistaPreviaRefPrecio";
import { formatPrecioVentaEntero, parsePrecioVentaEntero } from "../utils/moneyParse";
import { dedupePoblacionNombres } from "../utils/poblacionesFavoritas";
import { joinPoblacionesQueryParam } from "../utils/poblacionesQueryParam";
import { FICHA_RESUMEN_ROOT_CLASS, fichaResumenFontSize } from "../components/propiedades/fichaResumenTypography";
import "../components/propiedades/fichaResumenTypography.css";
import BadgeNoDisponible, { esNoDisponibleTemporal, topDebajoBadgeNoDisponible } from "../components/propiedades/BadgeNoDisponible";
import ModalDemandaZonaMapa from "../components/demandas/ModalDemandaZonaMapa";
import { coordsEnMarinaAlta } from "../utils/geoMarinaAlta";
import { loadCitaModalFromAgenda, loadSegundaVisitaModalContext, fetchPropiedadPorRef, buildCitaDateTimeISO, addMinutosHora, isoToFechaHoraLocal } from "../utils/citaAgenda";
import { useCitaModalOverlayOptional } from "../context/CitaModalOverlayContext";
import ModalEleccionCitaExistente from "../components/cita/ModalEleccionCitaExistente";
import { PuntoWaHistorial } from "../components/historial/PuntoWaHistorial";
import { notifyTareasChanged } from "../utils/tareasLiveRefresh";
import { tileWhatsAppHistorialFicha, WA_VERDE_OFICIAL } from "../components/historial/IconoWhatsAppHistorial";
import { tileLlamadaHistorialFicha, LLAMADA_AMARILLO } from "../components/historial/IconoLlamadaHistorial";
import {
  etiquetaWhatsAppEnviadoHistorial,
  etiquetaHistorialConAutor,
  historialPasaFiltros,
  parseHistorialMetadata,
} from "../utils/historialFiltros";
import { textoCompletoHistorialWa } from "../utils/waPlantillasTexto";
import { useContactoSoftWarnings } from "../hooks/useContactoSoftWarnings";
import { resolverPropiedadIdPorReferencia } from "../utils/resolverPropiedadIdPorReferencia";

// ============================================================
// CONSTANTES
// ============================================================
const PROVINCIAS_ES = [
  { id: "01", nombre: "Álava" },{ id: "02", nombre: "Albacete" },{ id: "03", nombre: "Alicante" },
  { id: "04", nombre: "Almería" },{ id: "05", nombre: "Ávila" },{ id: "06", nombre: "Badajoz" },
  { id: "07", nombre: "Baleares" },{ id: "08", nombre: "Barcelona" },{ id: "09", nombre: "Burgos" },
  { id: "10", nombre: "Cáceres" },{ id: "11", nombre: "Cádiz" },{ id: "12", nombre: "Castellón" },
  { id: "13", nombre: "Ciudad Real" },{ id: "14", nombre: "Córdoba" },{ id: "15", nombre: "A Coruña" },
  { id: "16", nombre: "Cuenca" },{ id: "17", nombre: "Girona" },{ id: "18", nombre: "Granada" },
  { id: "19", nombre: "Guadalajara" },{ id: "20", nombre: "Guipúzcoa" },{ id: "21", nombre: "Huelva" },
  { id: "22", nombre: "Huesca" },{ id: "23", nombre: "Jaén" },{ id: "24", nombre: "León" },
  { id: "25", nombre: "Lleida" },{ id: "26", nombre: "La Rioja" },{ id: "27", nombre: "Lugo" },
  { id: "28", nombre: "Madrid" },{ id: "29", nombre: "Málaga" },{ id: "30", nombre: "Murcia" },
  { id: "31", nombre: "Navarra" },{ id: "32", nombre: "Ourense" },{ id: "33", nombre: "Asturias" },
  { id: "34", nombre: "Palencia" },{ id: "35", nombre: "Las Palmas" },{ id: "36", nombre: "Pontevedra" },
  { id: "37", nombre: "Salamanca" },{ id: "38", nombre: "S.C. Tenerife" },{ id: "39", nombre: "Cantabria" },
  { id: "40", nombre: "Segovia" },{ id: "41", nombre: "Sevilla" },{ id: "42", nombre: "Soria" },
  { id: "43", nombre: "Tarragona" },{ id: "44", nombre: "Teruel" },{ id: "45", nombre: "Toledo" },
  { id: "46", nombre: "Valencia" },{ id: "47", nombre: "Valladolid" },{ id: "48", nombre: "Vizcaya" },
  { id: "49", nombre: "Zamora" },{ id: "50", nombre: "Zaragoza" },{ id: "51", nombre: "Ceuta" },
  { id: "52", nombre: "Melilla" },
];
const PAISES_COMUNES = [
  "España","Alemania","Reino Unido","Francia","Países Bajos","Bélgica","Suecia","Noruega",
  "Dinamarca","Suiza","Austria","Italia","Portugal","Irlanda","Finlandia","Rusia","Ucrania",
  "Polonia","Estados Unidos","Canadá","Australia","Marruecos","Argelia","China","Japón","Otro",
];

const ETAPAS = [
  { key: "leads",      label: "Leads" },
  { key: "atendidos",  label: "Atendidos" },
  { key: "visitantes", label: "Visitantes" },
  { key: "calientes",  label: "Calientes" },
  { key: "ventas",     label: "Ventas" },
  { key: "frios",      label: "Fríos" },
  { key: "eliminados", label: "Eliminados" },
];
const TIPOS_PRINCIPALES = ["Piso","Apartamento","Ático","Casa","Chalet","Bungalow","Pareado"];
const OPS = ["Venta","Alquiler"];
const HABS = ["1","2","3","4","5+"];
const BANOS = ["1","2","3","4+"];
const POBLS_PRINCIPALES = ["Dénia","La Xara","El Verger","Els Poblets","Ondara","Pedreguer","Pego"];
const normNombrePobl = (s) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
const normZonaKey = (s) => normNombrePobl(s).replace(/\./g, "");
/** Alias de población para emparejar aux_zona.poblacion ↔ chip (ampliar, no sustituir). */
const POBL_ZONA_ALIAS_GROUPS = [
  ["benitachell", "benitatxell", "el poble nou de benitatxell", "poble nou de benitatxell"],
];
/** Zona sin población en catálogo = legacy Dénia. */
const zonaPoblacionEfectiva = (poblacionRaw) => {
  const t = String(poblacionRaw || "").trim();
  return t || "Dénia";
};
const poblsZonaCoinciden = (poblSeleccionada, poblZona) => {
  const a = normNombrePobl(poblSeleccionada);
  const b = normNombrePobl(zonaPoblacionEfectiva(poblZona));
  if (!a || !b) return false;
  if (a === b) return true;
  for (const group of POBL_ZONA_ALIAS_GROUPS) {
    const set = new Set(group.map(normNombrePobl));
    if (set.has(a) && set.has(b)) return true;
  }
  return false;
};
/** Orden de la primera fila de zonas (coincidencia flexible con nombres del catálogo). */
const ZONAS_PRINCIPAL_PATRONES = [
  ["las marinas hasta km 3", "las marinas km 3"],
  ["las marinas km 3 al 5"],
  ["las marinas km 7 al 9", "las marinas km 7 al 13"],
  ["ciudad"],
  ["montgo bajo"],
  ["las rotas"],
];
const HISTORIAL_EXCL_TIPOS = [
  "criterios_ana", "ana_busqueda", "lead_eliminado", "ana_primer_contacto", "ana_busqueda_v2",
  "cliente_desactivado", "tareas_archivadas", "lead_etapa_manual", "agenda_archivada",
  "lead_vinculado_cliente_nuevo", "cambio_etapa", "demanda_creada", "cliente_creado",
];
const HISTORIAL_FILTRO_IDS = ["whatsapp", "mail", "llamadas", "citas", "notas", "sistema"];

const ETAPAS_LEAD_TERMINAL = new Set(["eliminados", "eliminado", "frios", "fríos", "ventas"]);

function mergeHistorialRows(...lists) {
  const map = new Map();
  for (const list of lists) {
    for (const row of list || []) {
      if (row?.id != null) map.set(row.id, row);
    }
  }
  return [...map.values()].sort(
    (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
  );
}

const ETAPA_LEAD_ORDEN = { leads: 0, atendidos: 1, visitantes: 2, calientes: 3, ventas: 4 };
function rankEtapaLead(etapa) {
  const r = ETAPA_LEAD_ORDEN[String(etapa || "").trim().toLowerCase()];
  return r === undefined ? -1 : r;
}

/** Lista determinista de leads en embudo (activos, no terminales), del más avanzado al más inicial. */
function leadsEmbudoActivos(leadsV = []) {
  return (leadsV || [])
    .filter((l) => l?.activo !== false && !ETAPAS_LEAD_TERMINAL.has(String(l.etapa || "").toLowerCase()))
    .sort((a, b) => {
      const ra = rankEtapaLead(a.etapa);
      const rb = rankEtapaLead(b.etapa);
      if (rb !== ra) return rb - ra; // más avanzado primero
      const ta = new Date(a.updated_at || a.created_at || 0).getTime();
      const tb = new Date(b.updated_at || b.created_at || 0).getTime();
      return tb - ta; // más reciente primero
    });
}

function pickLeadEmbudoActivo(leadsV = []) {
  const ordenados = leadsEmbudoActivos(leadsV);
  return ordenados[0] || leadsV[0] || null;
}

/** Lead del embudo ligado a una demanda (1 demanda ↔ 1 lead de flujo). */
function pickLeadParaDemanda(leadsV = [], demandaId, { preferLeadId = null } = {}) {
  if (!demandaId) return null;
  const candidates = (leadsV || []).filter(
    (l) => l?.demanda_id && String(l.demanda_id) === String(demandaId)
  );
  if (!candidates.length) return null;
  if (preferLeadId) {
    const pref = candidates.find((l) => String(l.id) === String(preferLeadId));
    if (pref) return pref;
  }
  const activos = candidates.filter(
    (l) => l?.activo !== false && !ETAPAS_LEAD_TERMINAL.has(String(l.etapa || "").toLowerCase())
  );
  const pool = activos.length ? activos : candidates;
  return pickLeadEmbudoActivo(pool) || pool[0] || null;
}

/** Puntuación de demanda con criterios guardados (evita elegir demanda vacía recién creada). */
function scoreDemandaFicha(d = {}) {
  let s = 0;
  if (Array.isArray(d.tipos) && d.tipos.length) s += 3;
  if (d.poblacion) s += 3;
  if (d.precio_min != null || d.precio_max != null) s += 2;
  if (d.habitaciones_min != null) s += 1;
  if (d.geo_centro_lat != null && d.geo_centro_lng != null) s += 2;
  return s;
}

/**
 * Demanda visible al abrir ficha.
 * - Si venimos de Pipeline/Tareas con leadId/demandaId → esa demanda del lead clicado.
 * - Si no hay contexto: la última trabajada (no cancelada).
 */
function esDemandaCancelada(d) {
  const e = String(d?.estado || "").trim().toLowerCase();
  // cancelada (nuevo) o cerrada (legado check DB)
  return e === "cancelada" || e === "cancelado" || e === "cerrada" || e === "cerrado";
}

function pickDemandaActiva(demandas = [], ctx = {}) {
  if (!demandas?.length) return null;
  const byId = (id) => {
    if (!id) return null;
    return demandas.find((d) => String(d.id) === String(id)) || null;
  };

  // 1) Demanda forzada por navegación (tarea / pipeline / lead).
  const forced = byId(ctx.demandaId);
  if (forced) return forced;

  // 2) Demanda del lead clicado (o del lead de la ruta /leads/:id).
  let leadCtx = ctx.lead || null;
  if (!leadCtx && ctx.leadId) {
    leadCtx = (ctx.leadsV || []).find((l) => String(l.id) === String(ctx.leadId)) || null;
  }
  const fromLead = byId(leadCtx?.demanda_id);
  if (fromLead && !esDemandaCancelada(fromLead)) return fromLead;
  if (fromLead) return fromLead;

  // 3) Fallback: última trabajada no cancelada.
  const sorted = [...demandas].sort((a, b) => {
    const ca = esDemandaCancelada(a) ? 1 : 0;
    const cb = esDemandaCancelada(b) ? 1 : 0;
    if (ca !== cb) return ca - cb;
    const tb = new Date(b.updated_at || b.created_at || 0).getTime();
    const ta = new Date(a.updated_at || a.created_at || 0).getTime();
    if (tb !== ta) return tb - ta;
    return (
      scoreDemandaFicha(b) - scoreDemandaFicha(a) ||
      new Date(b.created_at || 0) - new Date(a.created_at || 0)
    );
  });
  return sorted[0];
}

/** Fallos típicos al abrir ficha durante un deploy/reinicio Railway. */
function esErrorCargaTransitorio(e) {
  const st = e?.response?.status;
  if (!e?.response) return true;
  return st === 502 || st === 503 || st === 504 || st === 408;
}

async function getConReintento(fn, { intentos = 3, baseMs = 700 } = {}) {
  let last;
  for (let i = 0; i < intentos; i += 1) {
    try {
      return await fn();
    } catch (e) {
      last = e;
      if (i >= intentos - 1 || !esErrorCargaTransitorio(e)) throw e;
      await new Promise((r) => setTimeout(r, baseMs * (i + 1)));
    }
  }
  throw last;
}

function mensajeErrorCargaFicha(e) {
  const st = e?.response?.status;
  if (st === 404) return "No se encontró este cliente o lead.";
  if (st === 403) return "No tienes permiso para ver esta ficha.";
  if (esErrorCargaTransitorio(e)) {
    return "El servidor no respondió (posible reinicio). Prueba de nuevo en unos segundos.";
  }
  if (st >= 500) return "Error del servidor al cargar la ficha.";
  return "Error cargando datos";
}

function formatFechaEnvio(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Madrid",
  });
}

function normalizarEnviosInfo(info) {
  if (Array.isArray(info?.envios) && info.envios.length) {
    return [...info.envios].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  }
  const out = [];
  if (info?.enviada_whatsapp && info.fecha_envio_whatsapp) {
    out.push({ canal: "whatsapp", fecha: info.fecha_envio_whatsapp });
  }
  if (info?.enviada_email && info.fecha_envio_email) {
    out.push({ canal: "email", fecha: info.fecha_envio_email });
  }
  return out.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
}

function buildEnviadaTooltip(info) {
  const envios = normalizarEnviosInfo(info);
  if (!envios.length) return "Enviada al cliente";
  return envios
    .map((e) => {
      const label = e.canal === "email" ? "Email" : "WhatsApp";
      const f = formatFechaEnvio(e.fecha);
      return f ? `${label} (${f})` : label;
    })
    .join("\n");
}

/** Estilo del badge «Enviada» según canal del envío más reciente. */
function estiloBadgeEnviada(info) {
  const envios = normalizarEnviosInfo(info);
  const ultimo = envios[0];
  const verde = {
    background: "linear-gradient(135deg, #16a34a, #15803d)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(22,163,74,0.55), 0 0 0 1px rgba(22,163,74,0.25)",
  };
  // Naranja de mails (TASK_UI.email #f59e0b), no el verde WA.
  const naranja = {
    background: "linear-gradient(135deg, #d97706, #f59e0b)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(245,158,11,0.55), 0 0 0 1px rgba(217,119,6,0.25)",
  };
  if (ultimo?.canal === "email") return naranja;
  if (ultimo?.canal === "whatsapp") return verde;
  if (info?.enviada_email && !info?.enviada_whatsapp) return naranja;
  return verde;
}

const estiloBadgePropiedadBase = {
  padding: "5px 14px",
  borderRadius: 8,
  fontSize: 12,
  fontWeight: 800,
  color: "#fff",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

function estiloBadgeVisitada() {
  return {
    background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(37,99,235,0.55), 0 0 0 1px rgba(37,99,235,0.25)",
  };
}

function estiloBadgeEnCita() {
  return {
    background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(37,99,235,0.55), 0 0 0 1px rgba(37,99,235,0.25)",
  };
}

function estiloBadgeLead() {
  return {
    background: "linear-gradient(135deg, #7c3aed, #6d28d9)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(124,58,237,0.55), 0 0 0 1px rgba(124,58,237,0.25)",
  };
}

function normalizarRefLead(ref) {
  return String(ref || "").trim().toUpperCase();
}

function esPropiedadEntradaLead(propiedad, { refs = new Set(), ids = new Set() } = {}) {
  if (!propiedad) return false;
  const ref = normalizarRefLead(propiedad.referencia);
  if (ref && refs.has(ref)) return true;
  const pid = propiedad.id != null ? String(propiedad.id) : "";
  return Boolean(pid && ids.has(pid));
}

function estiloBadgePasaOferta() {
  return {
    background: "linear-gradient(135deg, #ca8a04, #a16207)",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(202,138,4,0.55), 0 0 0 1px rgba(202,138,4,0.25)",
  };
}

function estiloBadgeVendida() {
  return {
    background: "#f472b6",
    border: "2px solid rgba(255,255,255,0.85)",
    boxShadow: "0 3px 12px rgba(244,114,182,0.55), 0 0 0 1px rgba(244,114,182,0.25)",
    color: "#000",
  };
}

function buildVendidaTooltip(info) {
  if (!info) return "Vendida";
  const parts = [];
  if (info.fecha_reserva) parts.push(formatFechaEnvio(info.fecha_reserva));
  if (info.observaciones) parts.push(String(info.observaciones).trim());
  return parts.length ? `Vivienda reservada:\n${parts.join("\n")}` : "Vendida";
}

function buildPasaOfertaTooltip(info) {
  if (!info) return "Pasa oferta";
  const parts = [];
  if (info.importe != null && Number.isFinite(Number(info.importe))) {
    parts.push(`${Number(info.importe).toLocaleString("es-ES")} €`);
  }
  if (info.ultima_oferta) {
    parts.push(formatFechaEnvio(info.ultima_oferta));
  }
  if (info.texto) parts.push(String(info.texto).trim());
  return parts.length ? `Oferta registrada:\n${parts.join("\n")}` : "Pasa oferta";
}

function normalizarVisitasPropiedad(info) {
  if (!info) return [];
  let visitas = info.visitas;
  if (typeof visitas === "string") {
    try { visitas = JSON.parse(visitas); } catch { visitas = []; }
  }
  if (!Array.isArray(visitas)) visitas = [];
  return [...visitas].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
}

function labelBadgeEnCita(numeroCita) {
  const n = Number(numeroCita) || 1;
  if (n <= 1) return "En Cita";
  return `En ${n}ª cita`;
}

function lineaVisitaTooltip(v, indice) {
  const n = indice + 1;
  const f = v?.fecha ? formatFechaEnvio(v.fecha) : "?";
  const cal = v?.cualificacion ? String(v.cualificacion).trim() : "";
  const descCliente =
    v?.descartada_por_cliente === true ||
    v?.descartada_por_cliente === "true";
  if (descCliente && cal) {
    return `${n}.ª visita: ${f} — Descartada por el cliente: ${cal}`;
  }
  return cal ? `${n}.ª visita: ${f} — ${cal}` : `${n}.ª visita: ${f}`;
}

/** Descarte cualificado en M2 (visita) aunque aún no esté en demanda_propiedades de esta pestaña. */
function propDescartadaPorClienteEnVisitas(propId, visitadasInfo = {}) {
  const visitas = normalizarVisitasPropiedad(visitadasInfo?.[String(propId)]);
  return visitas.some(
    (v) => v?.descartada_por_cliente === true || v?.descartada_por_cliente === "true"
  );
}

function buildVisitadaTooltip(info) {
  const visitas = normalizarVisitasPropiedad(info);
  if (visitas.length === 0) {
    const f = info?.ultima_visita ? formatFechaEnvio(info.ultima_visita) : "";
    return f ? `Visita realizada (${f})` : "Visita realizada";
  }
  const lines = visitas.map((v, i) => lineaVisitaTooltip(v, i));
  return `Visitas realizadas:\n${lines.join("\n")}`;
}

function buildEnCitaTooltip(info, visitadaInfo) {
  const num = Number(info?.numero_cita) || 1;
  const f = info?.cita_fecha ? formatFechaEnvio(info.cita_fecha) : "";
  const previas = normalizarVisitasPropiedad(visitadaInfo);
  let tip = f
    ? `${num}.ª visita programada (${f})`
    : `${num}.ª visita pendiente`;
  if (previas.length > 0) {
    tip += `\n\nVisitas anteriores:\n${previas.map((v, i) => lineaVisitaTooltip(v, i)).join("\n")}`;
  }
  return tip;
}

/** Prioridad en el grid: arriba oferta / enviadas / visitadas / en cita; abajo descartadas. */
function prioridadPropiedadResultado(propId, { descartadas, enviadasInfo, visitadasInfo, enCitaInfo, ofertasInfo, vendidasInfo }) {
  const id = String(propId);
  if ((descartadas || []).some((d) => String(d) === id)) return 1000;

  const vendida = Boolean(vendidasInfo?.[id]);
  const oferta = Boolean(ofertasInfo?.[id]);
  const enviada = Boolean(enviadasInfo[id]);
  const visitada = Boolean(visitadasInfo[id]);
  const enCita = Boolean(enCitaInfo[id]);
  if (!vendida && !oferta && !enviada && !visitada && !enCita) return 500;

  let score = 0;
  if (enCita) score += 1;
  if (visitada) score += 2;
  if (enviada) score += 4;
  if (oferta) score += 8;
  if (vendida) score += 16;
  return 100 - score;
}

const REF_PROPIEDAD_RE = /\b(\d{3,6}-[A-Za-z0-9]+)\b/g;
const FICHAS_LINE_RE = /^Fichas\s*\(\d+\):\s*(.+)$/i;

const VISOR_HISTORIAL_TITULOS = {
  whatsapp_enviado: "WhatsApp enviado",
  whatsapp_recibido: "WhatsApp recibido",
  whatsapp_respuesta: "WhatsApp recibido",
  email_enviado: "Email enviado",
  llamada_ana: "Llamada Ana (IA)",
  llamada: "Llamada",
  nota: "Nota",
  cita_creada: "Cita programada",
};

function extraerRefsDeContenidoHistorial(contenido) {
  const refs = [];
  const seen = new Set();
  const add = (ref) => {
    const t = String(ref || "").trim();
    if (!t) return;
    const key = t.toUpperCase();
    if (seen.has(key)) return;
    seen.add(key);
    refs.push(t);
  };
  const txt = String(contenido || "");
  const lineaFichas = txt.split("\n").find((l) => FICHAS_LINE_RE.test(l.trim()));
  if (lineaFichas) {
    const m = lineaFichas.trim().match(FICHAS_LINE_RE);
    if (m?.[1]) m[1].split(/,\s*/).forEach(add);
  }
  const re = new RegExp(REF_PROPIEDAD_RE.source, "g");
  let rm;
  while ((rm = re.exec(txt)) !== null) add(rm[1]);
  return refs;
}

function contenidoHistorialSinLineaFichas(contenido) {
  return String(contenido || "")
    .split("\n")
    .filter((l) => !FICHAS_LINE_RE.test(l.trim()))
    .join("\n")
    .trim();
}

function refsVisorHistorial(visor, props) {
  const chips = [...(visor?.chipsRefs || [])];
  const seen = new Set(
    chips.map((c) => String(c.ref || c.id || "").toUpperCase()).filter(Boolean)
  );
  for (const ref of extraerRefsDeContenidoHistorial(visor?.contenido)) {
    const key = String(ref || "").toUpperCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    const p = props.find((x) => String(x.referencia || "").toUpperCase() === key);
    chips.push({ ref: p?.referencia || ref, id: p?.id || null, titulo: p?.titulo || null });
  }
  return chips;
}

function parsePropiedadesIds(h) {
  let ids = h?.propiedades_ids;
  if (typeof ids === "string") {
    try {
      ids = JSON.parse(ids);
    } catch {
      ids = [];
    }
  }
  if (Array.isArray(ids) && ids.length) return ids.filter(Boolean);
  const meta = parseHistorialMetadata(h);
  const metaIds = meta.propiedad_ids || meta.propiedades_ids;
  if (Array.isArray(metaIds)) return metaIds.filter(Boolean);
  if (typeof metaIds === "string") {
    try {
      const parsed = JSON.parse(metaIds);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch { /* ignore */ }
  }
  // Ana plantilla: metadata.propiedad_id singular
  if (meta.propiedad_id) return [meta.propiedad_id].filter(Boolean);
  return [];
}

function buscarPropiedadHistorial(props, propMetaById, pid) {
  const p = props.find((x) => String(x.id) === String(pid));
  if (p) return p;
  return propMetaById?.[pid] || propMetaById?.[String(pid)] || null;
}

function chipsReferenciasHistorial(h, props, propMetaById = {}) {
  const chips = [];
  const seen = new Set();
  const add = (ref, id, titulo) => {
    const refKey = ref ? String(ref).toUpperCase() : "";
    const idKey = id ? `id:${String(id)}` : "";
    if (refKey && seen.has(refKey)) return;
    if (idKey && seen.has(idKey)) return;
    if (!refKey && !idKey && !titulo) return;
    if (refKey) seen.add(refKey);
    if (idKey) seen.add(idKey);
    if (!refKey && !idKey) seen.add(`t:${titulo}`);
    chips.push({ id: id || null, ref: ref || null, titulo: titulo || null });
  };
  const findByRef = (ref) =>
    props.find((x) => String(x.referencia || "").toUpperCase() === String(ref || "").toUpperCase())
    || Object.values(propMetaById || {}).find(
      (x) => String(x?.referencia || "").toUpperCase() === String(ref || "").toUpperCase()
    );
  const idsFromRow = parsePropiedadesIds(h);
  for (const pid of idsFromRow) {
    const p = buscarPropiedadHistorial(props, propMetaById, pid);
    add(p?.referencia, p?.id || pid, p?.titulo);
  }
  if (h.tipo === "cita_creada" && h.contenido && idsFromRow.length === 0) {
    const re = new RegExp(REF_PROPIEDAD_RE.source, "g");
    let m;
    while ((m = re.exec(h.contenido)) !== null) {
      const ref = m[1];
      const p = findByRef(ref);
      add(p?.referencia || ref, p?.id, p?.titulo);
    }
  }
  if ((h.tipo === "whatsapp_enviado" || h.tipo === "email_enviado") && h.contenido) {
    for (const ref of extraerRefsDeContenidoHistorial(h.contenido)) {
      const p = findByRef(ref);
      add(p?.referencia || ref, p?.id, p?.titulo);
    }
  }
  return chips;
}

function textoCitaSinRefs(contenido) {
  if (!contenido) return "";
  return String(contenido)
    .replace(/\s*\(agenda\s+[a-f0-9-]+\)\.?/gi, "")
    .replace(/\s*\d+\s*vivienda[s]?:\s*[\d\w,\s-]+/gi, "")
    .replace(REF_PROPIEDAD_RE, "")
    .replace(/\s*·\s*·/g, " · ")
    .replace(/\s*·\s*$/g, "")
    .replace(/\.\s*\./g, ".")
    .trim();
}

function parsePgUuidArray(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val.filter(Boolean).map(String);
  if (typeof val === "string" && val.startsWith("{")) {
    const inner = val.slice(1, -1);
    if (!inner.trim()) return [];
    return inner.split(",").map((s) => s.replace(/^"|"$/g, "").trim()).filter(Boolean);
  }
  return [];
}

function snapDuracionVisita(min) {
  const opts = [30, 45, 60, 90];
  const n = Number(min) || 45;
  return opts.reduce((best, o) => (Math.abs(o - n) < Math.abs(best - n) ? o : best), 45);
}

/** Oculta llamadas vinculadas a una cita y las devuelve dentro de la fila cita_creada. */
function agruparHistorialConLlamadasEnCitas(items) {
  const childrenByParent = new Map();
  const childrenByAgenda = new Map();

  for (const h of items) {
    if (h.tipo !== "llamada" && h.tipo !== "llamada_ana") continue;
    const meta = parseHistorialMetadata(h);
    if (meta.parent_historial_id) {
      const pid = String(meta.parent_historial_id);
      if (!childrenByParent.has(pid)) childrenByParent.set(pid, []);
      childrenByParent.get(pid).push(h);
    } else if (meta.agenda_id) {
      const aid = String(meta.agenda_id);
      if (!childrenByAgenda.has(aid)) childrenByAgenda.set(aid, []);
      childrenByAgenda.get(aid).push(h);
    }
  }

  const resultado = [];
  for (const h of items) {
    if (h.tipo === "llamada" || h.tipo === "llamada_ana") {
      const meta = parseHistorialMetadata(h);
      if (meta.parent_historial_id || meta.agenda_id) continue;
      resultado.push({ ...h, llamadasAnidadas: [] });
      continue;
    }
    if (h.tipo === "cita_creada") {
      const metaCita = parseHistorialMetadata(h);
      const merged = [...(childrenByParent.get(String(h.id)) || [])];
      const byAgenda = metaCita.agenda_id
        ? childrenByAgenda.get(String(metaCita.agenda_id)) || []
        : [];
      for (const ll of byAgenda) {
        if (!merged.some((x) => x.id === ll.id)) merged.push(ll);
      }
      resultado.push({
        ...h,
        llamadasAnidadas: merged.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        ),
      });
      continue;
    }
    resultado.push({ ...h, llamadasAnidadas: [] });
  }
  return resultado;
}

const WA_HISTORIAL_LOTE_GAP_MS = 90000;

/** Mensaje de ficha de propiedad enviada por WA (no mostrar como entrada aparte). */
function esMensajeFichaPropiedadWa(contenido) {
  const t = String(contenido || "");
  if (!t) return false;
  if (/movil\.vitalcasa\.com\/propiedad/i.test(t)) return true;
  if (/Ver ficha completa|See full listing|Voir la fiche complète/i.test(t)) return true;
  return /🔑\s*Ref:/i.test(t) && /💰/i.test(t) && /🏡/i.test(t);
}

function esEntradaWaConFichas(h) {
  if (h.tipo !== "whatsapp_enviado") return false;
  const meta = parseHistorialMetadata(h);
  if (meta.con_fichas) return true;
  if (parsePropiedadesIds(h).length > 0) return true;
  const txt = String(h.contenido || "");
  return txt.split("\n").some((l) => FICHAS_LINE_RE.test(l.trim()));
}

function esMensajeWaSecundarioLote(contenido) {
  const t = String(contenido || "").trim();
  if (!t) return true;
  if (esMensajeFichaPropiedadWa(t)) return true;
  if (t === "[Multimedia]") return true;
  if (/^🎬/u.test(t)) return true;
  return false;
}

function refsDesdeEntradasWa(entries) {
  const refs = [];
  const seen = new Set();
  for (const e of entries) {
    for (const ref of extraerRefsDeContenidoHistorial(e.contenido)) {
      const key = String(ref || "").toUpperCase();
      if (!key || seen.has(key)) continue;
      seen.add(key);
      refs.push(ref);
    }
  }
  return refs;
}

/** Una sola fila por envío WA con fichas: texto arriba y refs clicables abajo.
 *  No debe ocultar respuestas conversacionales posteriores (planta, garaje, cita)
 *  aunque caigan en la ventana de 90s del lote de fichas. */
function consolidarHistorialWhatsappEnviado(items) {
  const omitIds = new Set();
  const mergedById = new Map();
  const waEnviados = items.filter((h) => h.tipo === "whatsapp_enviado");
  const sortedAsc = [...waEnviados].sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at),
  );
  const lotes = [];
  for (const h of sortedAsc) {
    const t = new Date(h.created_at).getTime();
    const ultimo = lotes[lotes.length - 1];
    if (!ultimo || t - ultimo.tFin > WA_HISTORIAL_LOTE_GAP_MS) {
      lotes.push({ items: [h], tFin: t });
    } else {
      ultimo.items.push(h);
      ultimo.tFin = t;
    }
  }

  const esSoloFichaOMedia = (h) =>
    esMensajeFichaPropiedadWa(h.contenido) ||
    esMensajeWaSecundarioLote(h.contenido) ||
    esEntradaWaConFichas(h);

  for (const lote of lotes) {
    if (lote.items.length <= 1) {
      if (esMensajeFichaPropiedadWa(lote.items[0].contenido)) omitIds.add(lote.items[0].id);
      continue;
    }

    const conFichas = lote.items.filter(esEntradaWaConFichas);
    const fichas = lote.items.filter((h) => esMensajeFichaPropiedadWa(h.contenido));
    const intros = lote.items.filter(
      (h) => !esMensajeWaSecundarioLote(h.contenido) && !esEntradaWaConFichas(h),
    );

    // Ocultar tarjetas/media sueltas (se fusionan abajo). Nunca textos conversacionales.
    for (const h of lote.items) {
      if (esMensajeFichaPropiedadWa(h.contenido) || esMensajeWaSecundarioLote(h.contenido)) {
        if (!esEntradaWaConFichas(h)) omitIds.add(h.id);
      }
    }

    if (conFichas.length > 0) {
      const master = conFichas.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
      for (const h of lote.items) {
        if (h.id === master.id) continue;
        // Solo fusionar otras fichas/media del lote — no «3ª planta» / «¿tiene garaje?»
        if (esSoloFichaOMedia(h)) omitIds.add(h.id);
      }
      const refsExtra = refsDesdeEntradasWa(fichas);
      const masterTxt = String(master.contenido || "");
      if (refsExtra.length && !masterTxt.split("\n").some((l) => FICHAS_LINE_RE.test(l.trim()))) {
        const intro = contenidoHistorialSinLineaFichas(master.contenido);
        mergedById.set(master.id, {
          ...master,
          contenido: [intro, `Fichas (${refsExtra.length}): ${refsExtra.join(", ")}`]
            .filter(Boolean)
            .join("\n"),
        });
      }
      continue;
    }

    if (fichas.length > 0) {
      const refs = refsDesdeEntradasWa(fichas);
      const firstFichaAt = Math.min(...fichas.map((h) => new Date(h.created_at).getTime()));
      // Intro de pitch justo antes/con la ficha; respuestas posteriores siguen visibles.
      const introsPitch = intros.filter(
        (h) => new Date(h.created_at).getTime() <= firstFichaAt + 5000,
      );
      const base =
        introsPitch.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0] ||
        lote.items[0];
      for (const h of lote.items) {
        if (h.id === base.id) continue;
        if (esMensajeFichaPropiedadWa(h.contenido) || esMensajeWaSecundarioLote(h.contenido)) {
          omitIds.add(h.id);
        }
      }
      const intro = introsPitch.length
        ? contenidoHistorialSinLineaFichas(introsPitch[0].contenido)
        : contenidoHistorialSinLineaFichas(base.contenido);
      mergedById.set(base.id, {
        ...base,
        contenido: [
          intro,
          refs.length ? `Fichas (${refs.length}): ${refs.join(", ")}` : null,
        ].filter(Boolean).join("\n"),
      });
    }
  }

  return items
    .filter((h) => !omitIds.has(h.id))
    .map((h) => mergedById.get(h.id) || h);
}

const EXTRAS = [
  {k:"piscina",l:"🏊 Piscina"},{k:"garaje",l:"🚗 Garaje"},{k:"terraza",l:"☀️ Terraza"},
  {k:"ascensor",l:"🛗 Ascensor"},{k:"amueblado",l:"🪑 Amueblado"},{k:"primera_linea",l:"🏖️ 1ª línea"},
  {k:"vista_mar",l:"🌊 Vista mar"},
];
// Solo ítems con columna/filtro real en GET /leads/propiedades/buscar (equip=…).
// Antes había chips decorativos (Jacuzzi, electrodomésticos…) que no filtraban.
const EQUIP = {
  "Almacenamiento": ["Trastero", "Jardín", "Lavadero", "Balcón", "Patio"],
  "Confort": ["Chimenea"],
  "Seguridad": ["Domótica", "Puerta blindada", "Alarma"],
  "Exterior": ["Barbacoa"],
  "Comunitarios": ["Gimnasio", "Zona infantil", "Conserje", "Acceso minusválidos"],
};

const ORIENTACIONES = ["N","S","E","O","NE","NO","SE","SO"];
const PLANTAS_OPCIONES = ["PB","1º","2º","3º","4º+"];
const CAL_ENERGETICAS = ["A","B","C","D","E","F","G"];

// ============================================================
// CHIP — Adaptado a tema
// ============================================================
function Chip({ label, active, onClick, small, theme, excluded, title }) {
  const c = theme.colors;
  const ex = excluded === true;
  // Mismo patrón que chip activo (azul): fondo sólido opaco + texto blanco + borde transparente
  const exBg = theme.name === "dark" ? "#991b1b" : "#dc2626";
  const border = ex ? "transparent" : active ? c.chipActiveBorder : c.chipBorder;
  const background = ex ? exBg : active ? c.chipActiveBg : c.chipBg;
  const color = ex ? "#ffffff" : active ? c.chipActiveText : c.chipText;
  return (
    <button type="button" onClick={onClick} title={title}
      style={{
        padding: small ? '2px 8px' : '4px 10px',
        fontSize: small ? 10 : 11,
        fontWeight: 500,
        borderRadius: 6,
        border: `1px solid ${border}`,
        background,
        color,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        userSelect: 'none',
        lineHeight: '1.4',
      }}
      onMouseEnter={e => {
        if (ex || active) return;
        e.target.style.background = c.chipHoverBg;
        e.target.style.color = c.chipHoverText;
        e.target.style.borderColor = c.chipHoverBorder;
      }}
      onMouseLeave={e => {
        if (ex || active) return;
        e.target.style.background = c.chipBg;
        e.target.style.color = c.chipText;
        e.target.style.borderColor = c.chipBorder;
      }}
    >
      {label}
    </button>
  );
}

// ============================================================
// GALERÍA FICHA RESUMEN (idéntica a Propiedades.jsx)
// ============================================================
function FichaGaleria({ fotos, bgColor = '#ffffff' }) {
  const [idx, setIdx] = useState(0);
  if (!fotos || fotos.length === 0) return null;
  const url = typeof fotos[idx] === 'string' ? fotos[idx] : fotos[idx]?.url;
  return (
    <div style={{ position: 'relative' }}>
      <img src={url?.startsWith('http') ? url : `http://localhost:4000${url}`} alt="" style={{ width: '100%', height: 384, objectFit: 'cover' }} />
      {/* Curva decorativa inferior */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', overflow: 'hidden', height: 25 }}>
        <svg viewBox="0 0 1440 40" fill="none" xmlns="http://www.w3.org/2000/svg"
          style={{ width: '100%', height: '100%' }} preserveAspectRatio="none">
          <path d="M0 40H1440V0C1440 0 1080 40 720 40C360 40 0 0 0 0V40Z" fill={bgColor} />
        </svg>
      </div>
      <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: 11, padding: '2px 8px', borderRadius: 4 }}>
        {idx + 1} / {fotos.length}
      </div>
      {fotos.length > 1 && <>
        <button onClick={() => setIdx(i => i > 0 ? i - 1 : fotos.length - 1)} style={{
          position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)',
          width: 32, height: 32, borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,0.8)',
          cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#374151',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}>‹</button>
        <button onClick={() => setIdx(i => i < fotos.length - 1 ? i + 1 : 0)} style={{
          position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
          width: 32, height: 32, borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,0.8)',
          cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#374151',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}>›</button>
      </>}


    </div>
  );
}

// ============================================================
// CAMPO RESUMEN / SECCIÓN COLAPSABLE (idéntico a Propiedades.jsx)
// ============================================================
function CampoResumen({ label, valor, c }) {
  if (!valor && valor !== 0) return null;
  const labelColor = c ? c.textMuted : '#94a3b8';
  const valueColor = c ? c.textPrimary : '#1e293b';
  return (
    <div style={{ padding: '6px 8px' }}>
      <div style={{ fontSize: 10, color: labelColor, textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600, marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 13, color: valueColor, fontWeight: 600 }}>{valor}</div>
    </div>
  );
}

function getScrollParentForColapsable(node) {
  let p = node?.parentElement;
  while (p) {
    const { overflowY } = getComputedStyle(p);
    if ((overflowY === "auto" || overflowY === "scroll") && p.scrollHeight > p.clientHeight + 2) return p;
    p = p.parentElement;
  }
  return null;
}

function SeccionColapsable({ titulo, children, c }) {
  const [abierta, setAbierta] = useState(false);
  const rootRef = useRef(null);
  const borderColor = c ? c.border : '#e2e8f0';
  const textColor = c ? c.textPrimary : '#374151';
  const mutedColor = c ? c.textMuted : '#94a3b8';
  const bgColor = c ? c.bgCard : 'none';

  useLayoutEffect(() => {
    if (!abierta || !rootRef.current) return;
    const el = rootRef.current;
    const scrollParent = getScrollParentForColapsable(el);
    const STICKY_TOP = 52;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.scrollMarginTop = `${STICKY_TOP}px`;
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        if (!scrollParent) return;
        window.setTimeout(() => {
          const pr = scrollParent.getBoundingClientRect();
          const er = el.getBoundingClientRect();
          const bottomClip = er.bottom - pr.bottom;
          const room = scrollParent.clientHeight - STICKY_TOP - 12;
          if (bottomClip <= 4) return;
          if (el.offsetHeight > room) return;
          scrollParent.scrollTo({
            top: scrollParent.scrollTop + bottomClip + 8,
            behavior: 'smooth',
          });
        }, 280);
      });
    });
  }, [abierta]);

  return (
    <div ref={rootRef} style={{ border: `1px solid ${borderColor}`, borderRadius: 8, marginBottom: 8 }}>
      <button onClick={() => setAbierta(!abierta)} style={{
        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 12px', fontSize: 13, fontWeight: 600, color: textColor, cursor: 'pointer',
        background: bgColor, border: 'none', borderRadius: 8,
      }}>
        <span>{titulo}</span>
        <span style={{ color: mutedColor, fontSize: 12 }}>{abierta ? "▲" : "▼"}</span>
      </button>
      {abierta && <div style={{ padding: '0 12px 12px' }}>{children}</div>}
    </div>
  );
}

function SeccionTitulo({ children, color, c, isDark }) {
  const colores = {
    azul: isDark
      ? { bg: 'rgba(59,130,246,0.15)', border: '#3b82f6', text: '#93c5fd' }
      : { bg: 'linear-gradient(to right, #eff6ff, #f8fafc)', border: '#3b82f6', text: '#1e40af' },
    verde: isDark
      ? { bg: 'rgba(34,197,94,0.12)', border: '#22c55e', text: '#86efac' }
      : { bg: 'linear-gradient(to right, #f0fdf4, #f8fafc)', border: '#22c55e', text: '#166534' },
  };
  const s = colores[color] || colores.azul;
  return (
    <div style={{ background: s.bg, borderLeft: `3px solid ${s.border}`, padding: '6px 12px', borderRadius: 6, marginBottom: 8, marginTop: 8, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: s.text }}>
      {children}
    </div>
  );
}

// ============================================================
// Helper: lista desde demanda (una o varias separadas por coma)
// ============================================================
function listaDesdeCampoDemanda(val) {
  if (val == null || val === "") return [];
  if (Array.isArray(val)) return val.map(String).map((s) => s.trim()).filter(Boolean);
  const s = String(val).trim();
  if (!s) return [];
  return s.split(",").map((x) => x.trim()).filter(Boolean);
}

// ============================================================
// Helper: extraer criterios desde una demanda
// ============================================================
function precioCriterioStr(raw) {
  if (raw == null || raw === "") return "";
  const n = parsePrecioVentaEntero(raw);
  return Number.isFinite(n) ? formatPrecioVentaEntero(n) : String(raw);
}

function precioCriterioNum(raw) {
  if (raw == null || raw === "") return null;
  const n = parsePrecioVentaEntero(raw);
  return Number.isFinite(n) ? n : null;
}

function extraerCriterios(dm, operacionFallback) {
  const extras = [];
  if (dm.piscina) extras.push("piscina");
  if (dm.garaje) extras.push("garaje");
  if (dm.terraza) extras.push("terraza");
  if (dm.ascensor) extras.push("ascensor");
  if (dm.amueblado) extras.push("amueblado");
  if (dm.primera_linea) extras.push("primera_linea");
  if (dm.vista_mar) extras.push("vista_mar");
  const extrasExcl = [];
  if (dm.piscina_excl === true) extrasExcl.push("piscina");
  if (dm.amueblado_excl === true) extrasExcl.push("amueblado");

  return {
    tipos: dm.tipos || [],
    op: dm.operacion || operacionFallback || "",
    pMin: dm.precio_min != null ? precioCriterioStr(dm.precio_min) : "",
    pMax: dm.precio_max != null ? precioCriterioStr(dm.precio_max) : "",
    hMin: dm.habitaciones_min != null ? String(dm.habitaciones_min) : "",
    bMin: dm.banos_min != null ? String(dm.banos_min) : "",
    m2Min: dm.m2_min != null ? String(dm.m2_min) : "",
    m2Max: dm.m2_max != null ? String(dm.m2_max) : "",
    pobls: (() => {
      // Preferir text[] `poblaciones` (Ana T2 / ampliación zona); fallback al singular legacy.
      const fromArr = listaDesdeCampoDemanda(dm.poblaciones);
      const raw = fromArr.length ? fromArr : listaDesdeCampoDemanda(dm.poblacion);
      return dedupePoblacionNombres(raw);
    })(),
    zonas: (() => {
      const fromArr = listaDesdeCampoDemanda(dm.zonas);
      if (fromArr.length) return fromArr;
      return listaDesdeCampoDemanda(dm.zona);
    })(),
    zonasExcl: listaDesdeCampoDemanda(dm.zonas_excl),
    extras: extras,
    extrasExcl,
    equip: [],
    sinAsc: false,
    plMax: 2,
    // Criterios ampliados V10
    m2Parcela: dm.m2_parcela_min != null ? String(dm.m2_parcela_min) : "",
    orientacion: dm.orientacion || [],
    orientacionExcl: listaDesdeCampoDemanda(dm.orientaciones_excl),
    jardin: dm.jardin || false,
    anoConstruccion: dm.ano_construccion_desde != null ? String(dm.ano_construccion_desde) : "",
    estadoInmueble: dm.estado_inmueble || [],
    estadoInmuebleExcl: listaDesdeCampoDemanda(dm.estado_inmueble_excl),
    vpo: dm.vpo || false,
    vpoExcl: dm.vpo_excl === true,
    calEnergetica: dm.cal_energetica || "",
    plantas: dm.plantas || [],
    plantasExcl: listaDesdeCampoDemanda(dm.plantas_excl),
    aireAc: dm.aire_acondicionado || false,
    calefaccion: dm.calefaccion || false,
    padel: dm.pista_padel || false,
    padelExcl: dm.pista_padel_excl === true,
    tenis: dm.pista_tenis || false,
    tenisExcl: dm.pista_tenis_excl === true,
    puntoRecarga: dm.punto_recarga || false,
    adaptado: dm.adaptado || false,
    salidaHumos: dm.salida_humos || false,
    distanciaMar: dm.distancia_mar_max != null ? String(dm.distancia_mar_max) : "",
    urbanizacionId: dm.urbanizacion_id || "",
    geoLat: dm.geo_centro_lat != null ? Number(dm.geo_centro_lat) : null,
    geoLng: dm.geo_centro_lng != null ? Number(dm.geo_centro_lng) : null,
    geoRadioM: dm.geo_radio_m != null ? Number(dm.geo_radio_m) : null,
  };
}

// ============================================================
// COMPONENTE PRINCIPAL
// ============================================================
// Normaliza teléfono quitando prefijo internacional → dígitos nacionales
const PREFIJOS_PAIS_FE = ['998','996','995','994','993','992','977','976','975','974','973','972','971','970','968','967','966','965','964','963','962','961','960','886','880','856','855','853','852','850','692','691','690','689','688','687','686','685','683','682','681','680','679','678','677','676','675','674','673','672','670','599','598','597','596','595','594','593','592','591','590','509','508','507','506','505','504','503','502','501','500','423','421','420','389','387','386','385','382','381','380','378','377','376','375','374','373','372','371','370','359','358','357','356','355','354','353','352','351','350','299','298','297','291','269','268','267','266','265','264','263','262','261','260','258','257','256','255','254','253','252','251','250','249','248','247','246','245','244','243','242','241','240','239','238','237','236','235','234','233','232','231','230','229','228','227','226','225','224','223','222','221','220','218','216','213','212','98','95','94','93','92','91','90','86','84','82','81','66','65','64','63','62','61','60','58','57','56','55','54','53','52','51','49','48','47','46','45','44','43','41','40','39','36','34','33','32','31','30','27','20','7','1'];
const normalizarTelFE = (t) => {
  if (!t) return null;
  let d = String(t).replace(/[^\d]/g, '');
  if (d.startsWith('00')) {
    const s = d.slice(2);
    for (const p of PREFIJOS_PAIS_FE) { if (s.startsWith(p)) { d = s.slice(p.length); break; } }
  } else if (d.length > 10) {
    for (const p of PREFIJOS_PAIS_FE) { if (d.startsWith(p) && d.length - p.length >= 7) { d = d.slice(p.length); break; } }
  }
  return d || null;
};

function EditableField({ value, campo, editando, setEditando, editVal, setEditVal, onSave, c, fontSize = 11, fontWeight = 500, label = '—', inputPlaceholder, width = 100, addressAutocomplete, placesLocalityContext, alwaysEditable = false, disabled = false, disabledTitle, className }) {
  const isEditing = !disabled && editando === campo;
  const [draft, setDraft] = useState(value || '');
  // Tras aviso suave (u otro guardado), el padre cambia `value`: hay que pintar el draft.
  // No condicionar a alwaysEditable/isEditing — si no, el TEL se queda con el valor viejo.
  useEffect(() => {
    setDraft(value || '');
  }, [value]);
  const st = { fontSize, fontWeight, fontFamily: 'inherit', width };
  const ph = inputPlaceholder || `Insertar ${(label === '—' ? campo : label).toLowerCase()}`;
  // Este campo no pertenece al agente (p. ej. contacto en Fríos asignado a Ana):
  // se muestra en modo solo lectura, sin permitir entrar en edición, en vez de
  // dejar que el usuario lo intente y reciba un error 403 al guardar.
  if (disabled) {
    return (
      <input readOnly value={value || ''} placeholder={label}
        className={className}
        style={{ ...st, cursor: 'not-allowed', opacity: 0.55 }}
        title={disabledTitle || 'No puedes modificar este contacto (no es de tu cartera)'}
      />
    );
  }
  const commitDraft = () => {
    const nextValue = String(draft || '').trim();
    const currentValue = String(value || '').trim();
    // Tel/email/whatsapp: permitir borrar (antes un vacío restauraba el valor y no se podía quitar el teléfono).
    const permiteVacio = ['telefono', 'telefono_secundario', 'whatsapp', 'email'].includes(
      String(campo || '').toLowerCase()
    );
    if (!nextValue) {
      if (permiteVacio && nextValue !== currentValue) {
        onSave(campo, '');
        return;
      }
      setDraft(currentValue);
      return;
    }
    if (nextValue !== currentValue) onSave(campo, nextValue);
  };
  if (isEditing && addressAutocomplete) {
    return (
      <AddressAutocompleteInput
        autoFocus
        value={draft}
        onValueChange={setDraft}
        placeholder={ph}
        className={className}
        style={{ ...st, cursor: 'text' }}
        onBlur={() => {
          const v = draft;
          if (v !== (value || '')) onSave(campo, v);
          else setEditando(null);
        }}
        onInputKeyDown={(e) => {
          if (e.key === 'Enter') {
            const v = draft;
            if (v !== (value || '')) onSave(campo, v);
            else setEditando(null);
          }
          if (e.key === 'Escape') setEditando(null);
        }}
        placesLocalityContext={placesLocalityContext}
      />
    );
  }
  if (alwaysEditable) {
    return (
      <input
        className={className}
        value={draft}
        placeholder={ph}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commitDraft}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
          }
          if (e.key === 'Escape') {
            setDraft(value || '');
            e.currentTarget.blur();
          }
        }}
        style={{ ...st, cursor: 'text' }}
      />
    );
  }
  if (isEditing) {
    const permiteVacio = ['telefono', 'telefono_secundario', 'whatsapp', 'email'].includes(
      String(campo || '').toLowerCase()
    );
    const commitEdit = (raw) => {
      const v = String(raw || '').trim();
      const cur = String(value || '').trim();
      if (v === cur) {
        setEditando(null);
        return;
      }
      if (!v && !permiteVacio) {
        setEditando(null);
        return;
      }
      onSave(campo, v);
    };
    return (
      <input autoFocus
        className={className}
        defaultValue={value || ''}
        placeholder={ph}
        onBlur={e => commitEdit(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') commitEdit(e.target.value);
          if (e.key === 'Escape') setEditando(null);
        }}
        style={{ ...st, cursor: 'text' }}
      />
    );
  }
  return (
    <input readOnly value={value || ''} placeholder={label}
      className={className}
      onClick={() => setEditando(campo)}
      style={{ ...st, cursor: 'pointer' }}
      title="Clic para editar"
    />
  );
}

export default function FichaCliente() {
  const { id } = useParams();
  const nav = useNavigate();
  const location = useLocation();
  const citaOverlay = useCitaModalOverlayOptional();
  const citaOverlayActivo = Boolean(citaOverlay?.isOverlayActive);
  const { theme } = useTheme();
  const { usuario } = useAuth();
  const c = theme.colors;
  const esRutaCliente = location.pathname.startsWith("/clientes/");
  /** Origen Tareas (u otro): botón «← Tareas» restaura filtros de la tabla. */
  const [returnToOrigen] = useState(() => {
    const rt = location.state?.returnTo;
    return typeof rt === "string" && rt.startsWith("/") ? rt : null;
  });
  /** Lead/demanda del clic en Pipeline o Tareas (antes de que se limpie location.state). */
  const [focusLeadId] = useState(() => {
    const lid = location.state?.leadId;
    return lid ? String(lid) : null;
  });
  const [focusDemandaId] = useState(() => {
    const did = location.state?.demandaId;
    return did ? String(did) : null;
  });
  const [lead, setLead] = useState(null);
  const [cliente, setCliente] = useState(null);
  const softWarnCliente = useContactoSoftWarnings(`cliente-${cliente?.id || lead?.cliente_id || lead?.id || 'nuevo'}`);
  const [demandas, setDemandas] = useState([]);
  const [leadsV, setLeadsV] = useState([]);
  const [demAct, setDemAct] = useState(null);

  /**
   * Lead del embudo para la demanda seleccionada.
   * Con 2+ demandas activas, cada una tiene su lead/tarea vigente distinta.
   * Aplica en /clientes/:id y en /leads/:id (antes en leads se ignoraba demAct).
   */
  const leadEmbudoActivo = useMemo(() => {
    if (demAct?.id) {
      const byDem = pickLeadParaDemanda(leadsV, demAct.id, {
        preferLeadId: focusLeadId || (!esRutaCliente ? lead?.id : null),
      });
      if (byDem) return byDem;
      // Demanda sin lead en lista: si el lead de la ruta es de esta demanda, usarlo.
      if (
        lead?.id &&
        lead?.demanda_id &&
        String(lead.demanda_id) === String(demAct.id)
      ) {
        return lead;
      }
      // No heredar el lead/tarea de otra demanda.
      return null;
    }
    if (!esRutaCliente) return lead?.id ? lead : null;
    if (focusLeadId) {
      const focused = (leadsV || []).find((l) => String(l.id) === String(focusLeadId));
      if (focused) return focused;
    }
    return pickLeadEmbudoActivo(leadsV);
  }, [esRutaCliente, lead, leadsV, focusLeadId, demAct?.id]);

  /** Ref(s) / id(s) de la propiedad por la que entró el cliente (origen del lead). */
  const propiedadEntradaLead = useMemo(() => {
    const refs = new Set();
    const ids = new Set();
    const addLead = (l) => {
      if (!l) return;
      const ref = normalizarRefLead(l.propiedad_ref);
      if (ref) refs.add(ref);
      if (l.propiedad_id != null) ids.add(String(l.propiedad_id));
    };
    addLead(lead);
    addLead(leadEmbudoActivo);
    for (const l of leadsV || []) addLead(l);
    return { refs, ids };
  }, [lead, leadEmbudoActivo, leadsV]);

  const leadParaArchivo = leadEmbudoActivo;

  /** Siempre el lead de la demanda activa (no el lead «global» del cliente). */
  const leadFlowId = leadEmbudoActivo?.id || null;

  const nom = useMemo(
    () => (cliente ? `${cliente.nombre || ""} ${cliente.apellido || ""}` : `${lead?.nombre || ""} ${lead?.apellido || ""}`).trim(),
    [cliente, lead]
  );
  const eml = useMemo(() => cliente?.email || lead?.email || "", [cliente?.email, lead?.email]);
  const tel = useMemo(
    () => cliente?.telefono || cliente?.whatsapp || lead?.telefono || lead?.whatsapp || "",
    [cliente?.telefono, cliente?.whatsapp, lead?.telefono, lead?.whatsapp]
  );
  const tel2 = useMemo(() => cliente?.telefono_secundario || "", [cliente?.telefono_secundario]);
  const [carg, setCarg] = useState(true);
  const [err, setErr] = useState("");
  const [nota, setNota] = useState("");
  const [masC, setMasC] = useState(false);
  const [masP, setMasP] = useState(false);
  const [poblacionesConViv, setPoblacionesConViv] = useState([]);
  const [poblacionesConVivErr, setPoblacionesConVivErr] = useState(false);
  const [poblBuscar, setPoblBuscar] = useState("");
  const [poblBuscarRes, setPoblBuscarRes] = useState([]);
  const [poblBuscarLoading, setPoblBuscarLoading] = useState(false);
  const pobBuscarTimerRef = useRef(null);
  const [masT, setMasT] = useState(false);
  const [tiposCatalogo, setTiposCatalogo] = useState([]);
  const [tiposCatalogoErr, setTiposCatalogoErr] = useState(false);
  const [catalogoZonas, setCatalogoZonas] = useState([]);
  const [zonasCatalogoErr, setZonasCatalogoErr] = useState(false);
  const [modalZonaMapa, setModalZonaMapa] = useState(false);
  const [zonasExpandidas, setZonasExpandidas] = useState(false);
  const [props, setProps] = useState([]);
  const [propsExternas, setPropsExternas] = useState(null); // null = modo CRM, array = resultados de portales
  const [propsExternasTipo, setPropsExternasTipo] = useState(null);
  const [propsExternasTotal, setPropsExternasTotal] = useState(0);
  const [propsExternasPage, setPropsExternasPage] = useState(1);
  const [propsExternasLoading, setPropsExternasLoading] = useState(false);
  const [modalPropExt, setModalPropExt] = useState(null);
  const [fichaResumen, setFichaResumen] = useState({ abierta: false, propiedad: null, datos: null });
  const [guardando, setGuardando] = useState(false);
  const [modalCita, setModalCita] = useState(false);
  const citaModalActivo = citaOverlayActivo || modalCita;
  const [eleccionCitaPendiente, setEleccionCitaPendiente] = useState(null);
  const [citaPropsPendientesNueva, setCitaPropsPendientesNueva] = useState([]);
  const pendingCitaPropIdsRef = useRef([]);
  const [citaEdicionAgendaId, setCitaEdicionAgendaId] = useState(null);
  const [citaEdicionSnapshot, setCitaEdicionSnapshot] = useState(null);
  const [citaEdicionInitial, setCitaEdicionInitial] = useState(null);
  const [citaEdicionProperties, setCitaEdicionProperties] = useState([]);
  // Segunda visita (desde el M2): nueva cita con la misma propiedad → nueva T4.
  const [segundaVisitaTarea, setSegundaVisitaTarea] = useState(null);
  const [segundaVisitaSnapshot, setSegundaVisitaSnapshot] = useState(null);
  const [segundaVisitaProps, setSegundaVisitaProps] = useState([]);
  const [segundaVisitaResultado, setSegundaVisitaResultado] = useState("Segunda visita");
  const [modalWhatsApp, setModalWhatsApp] = useState(false);
  const [modalEmail, setModalEmail] = useState(false);
  const [modalNota, setModalNota] = useState(false);
  const [modalPortales, setModalPortales] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [descartadas, setDescartadas] = useState([]);
  /** IDs descartados en M2 / cliente (etiqueta distinta a la X del agente). */
  const [descartadasPorCliente, setDescartadasPorCliente] = useState([]);
  const [enviadasInfo, setEnviadasInfo] = useState({});
  const [visitadasInfo, setVisitadasInfo] = useState({});
  const [enCitaInfo, setEnCitaInfo] = useState({});
  const [ofertasInfo, setOfertasInfo] = useState({});
  const [vendidasInfo, setVendidasInfo] = useState({});
  const [estadosCargados, setEstadosCargados] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [historialPropMeta, setHistorialPropMeta] = useState({});
  const [tareaVigente, setTareaVigente] = useState(null);
  const [modalCualificacionOpen, setModalCualificacionOpen] = useState(false);
  const [tareaModalDescartado, setTareaModalDescartado] = useState(false);
  // IDs de tareas cuyo modal el agente cerró/pospuso en ESTA sesión de la ficha.
  // Ref local: se reinicia al re-montar (re-entrar al cliente), de modo que si la
  // tarea sigue pendiente el modal vuelve a salir aunque se hubiera pospuesto
  // ("ahora no"). Dentro de la sesión, una tarea cerrada no se vuelve a auto-abrir.
  const dismissedTaskIdsRef = useRef(new Set());
  /** T4b1 abierta a mano con «Abrir tarea» (M2) aunque aún no haya respuesta WA. */
  const manualM2T4b1TaskIdRef = useRef(null);
  const pendingAbrirTareaDesdeNavRef = useRef(false);
  const [modalResultadoVisitaOpen, setModalResultadoVisitaOpen] = useState(false);
  const [modalResultadoAgenteOpen, setModalResultadoAgenteOpen] = useState(false);
  const [historialFiltrosIncl, setHistorialFiltrosIncl] = useState([]);
  const [historialFiltrosExcl, setHistorialFiltrosExcl] = useState(["sistema"]);
  const [visorHistorial, setVisorHistorial] = useState(null); // { tipo, contenido, fecha }
  const [leadModalHistorial, setLeadModalHistorial] = useState(null);
  const [previewPanelPos, setPreviewPanelPos] = useState({ x: 0, y: 0 });
  const previewPosRef = useRef({ x: 0, y: 0 });
  const [editando, setEditando] = useState(null);
  const [modalDuplicado, setModalDuplicado] = useState(null); // { campo, valor, clienteExistente } // campo que se está editando
  const [modalClienteCreacion, setModalClienteCreacion] = useState(null);
  const [modalLeadSuelto, setModalLeadSuelto] = useState(null); // respuesta 409 conflicto_lead_suelto al crear cliente
  const [previewLeadSuelto, setPreviewLeadSuelto] = useState(null); // aviso desde buscar-duplicado (sin cliente duplicado)
  const [editVal, setEditVal] = useState('');
  const [agentes, setAgentes] = useState([]);
  const [poblacionesCliente, setPoblacionesCliente] = useState([]);
  const [estadosInmueble, setEstadosInmueble] = useState([]);
  /** Centro geográfico de la población del cliente (Nominatim) para restringir Google Places al editar dirección */
  const [placesClienteContext, setPlacesClienteContext] = useState(null);
  const [cr, setCr] = useState({
    tipos: [], op: "", pMin: "", pMax: "", hMin: "", bMin: "", m2Min: "", m2Max: "",
    pobls: [], zonas: [], zonasExcl: [], extras: [], extrasExcl: [], equip: [], sinAsc: false, plMax: 2,
    // Criterios ampliados V10
    m2Parcela: "", orientacion: [], orientacionExcl: [], jardin: false, anoConstruccion: "",
    estadoInmueble: [], estadoInmuebleExcl: [], vpo: false, vpoExcl: false, calEnergetica: "", plantas: [], plantasExcl: [],
    aireAc: false, calefaccion: false, padel: false, padelExcl: false, tenis: false, tenisExcl: false,
    puntoRecarga: false, adaptado: false, salidaHumos: false,
    distanciaMar: "", urbanizacionId: "",
    geoLat: null, geoLng: null, geoRadioM: null,
  });

  // Refs para autoguardado
  const userModified = useRef(false);
  const saveTimerRef = useRef(null);
  const crRef = useRef(null);
  const demActIdRef = useRef(null);
  const clienteIdRef = useRef(null);
  const demandasLenRef = useRef(0);
  const clienteAgenteIdRef = useRef(null);
  const criterioChipDblRef = useRef({ id: null, t: 0, timer: null });
  const historialChipDblRef = useRef({ id: null, t: 0, timer: null });
  const propsBuscarSeqRef = useRef(0);
  /** Evita que un GET /activa atrasado de otra demanda pise la tarea vigente. */
  const tareaVigenteSeqRef = useRef(0);
  /** Evita spamear Tareas: solo avisa cuando cambia id / reply / código. */
  const tareaVigenteNotifySigRef = useRef("");
  crRef.current = cr;
  demActIdRef.current = demAct?.id;
  clienteIdRef.current = cliente?.id || lead?.cliente_id || null;
  demandasLenRef.current = demandas?.length ?? 0;
  clienteAgenteIdRef.current = cliente?.agente_id ?? null;

  // Fríos (u otro titular distinto al agente logueado) con alcance_modificar="propio":
  // los campos se muestran en solo lectura en vez de dejar que el guardado falle con 403.
  const { esPropio } = usePermiso();
  const clienteAgenteIdActual = cliente?.agente_id ?? lead?.agente_id ?? null;
  const esTitularContacto = !clienteAgenteIdActual || String(clienteAgenteIdActual) === String(usuario?.agente_id || "");
  // Fríos es bandeja compartida: no se edita nunca desde aquí (solo se reactiva
  // creando una cita), da igual el alcance configurado. Admin/Director sí pueden.
  const ESTADOS_FRIO_FICHA = ["inactivo", "frio", "fríos", "frios"];
  const clienteEnFrios = ESTADOS_FRIO_FICHA.includes(String(cliente?.estado || "").toLowerCase().trim());
  const esRolSinRestriccionFrios = ["admin", "administrador", "director"].includes(String(usuario?.rol || "").toLowerCase());
  const bloqueadoPorFrios = clienteEnFrios && !esRolSinRestriccionFrios;
  const puedeModificarContacto = !bloqueadoPorFrios && (!esPropio("ct_clientes", "alcance_modificar") || esTitularContacto);

  const cargarEnviadasCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-enviadas`);
      const rows = r.data?.data || [];
      const map = {};
      for (const row of rows) {
        if (row?.propiedad_id) map[String(row.propiedad_id)] = row;
      }
      setEnviadasInfo(map);
    } catch (e) {
      console.error("Error cargando enviadas del cliente:", e);
    }
  }, []);

  const cargarVisitadasCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-visitadas`);
      const rows = r.data?.data || [];
      const map = {};
      for (const row of rows) {
        if (row?.propiedad_id) map[String(row.propiedad_id)] = row;
      }
      setVisitadasInfo(map);
    } catch (e) {
      console.error("Error cargando visitadas del cliente:", e);
    }
  }, []);

  const cargarEnCitaCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-en-cita`);
      const rows = r.data?.data || [];
      const map = {};
      for (const row of rows) {
        if (row?.propiedad_id) map[String(row.propiedad_id)] = row;
      }
      setEnCitaInfo(map);
    } catch (e) {
      console.error("Error cargando en-cita del cliente:", e);
    }
  }, []);

  const cargarOfertasCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-oferta`);
      const rows = r.data?.data || [];
      const map = {};
      for (const row of rows) {
        if (row?.propiedad_id) map[String(row.propiedad_id)] = row;
      }
      setOfertasInfo(map);
    } catch (e) {
      console.error("Error cargando ofertas del cliente:", e);
    }
  }, []);

  const cargarVendidasCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-vendidas`);
      const rows = r.data?.data || [];
      const map = {};
      for (const row of rows) {
        if (row?.propiedad_id) map[String(row.propiedad_id)] = row;
      }
      setVendidasInfo(map);
    } catch (e) {
      console.error("Error cargando vendidas del cliente:", e);
    }
  }, []);

  const cargarMarcadoresVisitaCliente = useCallback(async (clienteId) => {
    if (!clienteId) return;
    await Promise.all([
      cargarVisitadasCliente(clienteId),
      cargarEnCitaCliente(clienteId),
      cargarOfertasCliente(clienteId),
      cargarVendidasCliente(clienteId),
    ]);
  }, [cargarVisitadasCliente, cargarEnCitaCliente, cargarOfertasCliente, cargarVendidasCliente]);

  const citaOverlayActivoRef = useRef(false);
  useEffect(() => {
    const activo = Boolean(citaOverlay?.isOverlayActive);
    const cid = cliente?.id || lead?.cliente_id || null;
    if (citaOverlayActivoRef.current && !activo && cid) {
      void cargarMarcadoresVisitaCliente(cid);
    }
    citaOverlayActivoRef.current = activo;
  }, [citaOverlay?.isOverlayActive, cliente?.id, lead?.cliente_id, cargarMarcadoresVisitaCliente]);

  const cargarEstados = useCallback(async (demandaId, clienteId = null) => {
    const cid = clienteId || clienteIdRef.current;
    if (demandaId) {
      try {
        const r = await api.get(`/demandas/${demandaId}/propiedades-estado`);
        const estados = r.data.data || [];
        setSeleccionadas(estados.filter(e => e.seleccionada).map(e => e.propiedad_id));
        setDescartadas(estados.filter(e => e.descartada).map(e => e.propiedad_id));
        setDescartadasPorCliente(
          estados
            .filter((e) => e.descartada && (e.descartada_por_cliente === true || e.descartada_por_cliente === "true"))
            .map((e) => e.propiedad_id)
        );
        setEstadosCargados(true);
      } catch (e) {
        console.error("Error cargando estados:", e);
      }
    }
    if (cid) {
      await cargarEnviadasCliente(cid);
      await cargarMarcadoresVisitaCliente(cid);
    }
  }, [cargarEnviadasCliente, cargarMarcadoresVisitaCliente]);

  const cargar = useCallback(async () => {
    // Si es cliente nuevo, inicializar vacío sin llamar al backend
    if (id === "nuevo") {
      setCliente({ nombre: "", apellido: "", email: "", telefono: "", telefono_secundario: "", idioma: "ES", pais: "España" });
      setLead({ id: null, cliente_id: null, nombre: "", apellido: "", email: "", telefono: "", idioma: "ES", pais: "España", operacion: "", etapa: "leads" });
      setDemandas([]);
      setLeadsV([]);
      setCarg(false);
      setErr("");
      return;
    }
    setCarg(true);
    setErr("");
    try {
      if (esRutaCliente) {
        // Viene de /clientes/:id — cargar datos del cliente
        // Reintento: durante deploys Railway el GET puede caer en red/502 un momento.
        const r = await getConReintento(() => api.get(`/clientes/${id}`));
        const d = r.data?.data;
        if (!d?.id) throw Object.assign(new Error("Respuesta vacía"), { response: { status: 502 } });
        setCliente(d);
        setDemandas(d.demandas || []);
        // Cargar leads vinculados al cliente
        let leadsLista = [];
        try {
          const rl = await api.get(`/leads?cliente_id=${d.id}`);
          leadsLista = rl.data.data || [];
          setLeadsV(leadsLista);
        } catch (e) { setLeadsV([]); }
        // Crear un lead virtual con datos del cliente para que la ficha funcione
        setLead({
          id: null,
          cliente_id: d.id,
          agente_id: d.agente_id || null,
          nombre: d.nombre,
          apellido: d.apellido,
          email: d.email,
          telefono: d.telefono,
          idioma: d.idioma,
          operacion: d.tipo_operacion || "",
          etapa: d.estado || "leads",
          agente_nombre: d.agente_nombre,
          cliente: d,
        });
        if (d.demandas?.length > 0) {
          const dm = pickDemandaActiva(d.demandas, {
            leadsV: leadsLista,
            leadId: focusLeadId,
            demandaId: focusDemandaId,
          });
          setDemAct(dm);
          userModified.current = false;
          setCr(extraerCriterios(dm, d.tipo_operacion));
          cargarEstados(dm.id, d.id);
        } else {
          void cargarEnviadasCliente(d.id);
          void cargarMarcadoresVisitaCliente(d.id);
        }
      } else {
        // Viene de /leads/:id — cargar datos del lead
        const r = await getConReintento(() => api.get(`/leads/${id}`));
        const d = r.data?.data;
        if (!d?.id) throw Object.assign(new Error("Respuesta vacía"), { response: { status: 502 } });
        setLead(d); setCliente(d.cliente || null); setDemandas(d.demandas || []);
        setLeadsV(d.leads_vinculados || []);
        if (d.demandas?.length > 0) {
          const dm = pickDemandaActiva(d.demandas, {
            lead: d,
            leadsV: d.leads_vinculados || [],
            leadId: focusLeadId || d.id,
            demandaId: focusDemandaId,
          });
          setDemAct(dm);
          userModified.current = false;
          setCr(extraerCriterios(dm, d.operacion));
          cargarEstados(dm.id, d.cliente?.id || d.cliente_id || null);
        } else {
          setCr(p => ({ ...p, op: d.operacion || "" }));
          const cid = d.cliente?.id || d.cliente_id || null;
          if (cid) {
            void cargarEnviadasCliente(cid);
            void cargarMarcadoresVisitaCliente(cid);
          }
        }
      }
    } catch (e) {
      setErr(mensajeErrorCargaFicha(e));
      console.error("[FichaCliente] cargar:", e?.response?.status || e?.message || e);
    } finally { setCarg(false) }
  }, [id, esRutaCliente, cargarEstados, cargarEnviadasCliente, cargarMarcadoresVisitaCliente, focusLeadId, focusDemandaId]);

  useEffect(() => {
    let alive = true;
    const pob = (cliente?.poblacion || "").trim();
    const prov = (cliente?.provincia || "").trim();
    const paisNorm = (cliente?.pais || "").trim().toLowerCase();
    if (!pob || (paisNorm && paisNorm !== "españa" && paisNorm !== "spain")) {
      setPlacesClienteContext(null);
      return undefined;
    }
    (async () => {
      try {
        const { data } = await api.get("/geo/localidad-centro", {
          params: { poblacion: pob, provincia: prov || "", pais: cliente?.pais?.trim() || "España" },
        });
        if (!alive) return;
        if (data?.ok && data.lat != null && data.lng != null) {
          setPlacesClienteContext({ latitude: data.lat, longitude: data.lng });
        } else setPlacesClienteContext(null);
      } catch {
        if (alive) setPlacesClienteContext(null);
      }
    })();
    return () => {
      alive = false;
    };
  }, [cliente?.poblacion, cliente?.provincia, cliente?.pais]);

  const cargarProps = useCallback(async (criterios) => {
    const seq = ++propsBuscarSeqRef.current;
    try {
      const q = new URLSearchParams();
      const cid = clienteIdRef.current;
      if (cid) q.set("cliente_id", cid);
      const tipos = criterios.tipos || [];
      const pobls = criterios.pobls || [];
      const zonas = criterios.zonas || [];
      const extras = criterios.extras || [];
      const orientacion = criterios.orientacion || [];
      const estadoInmueble = criterios.estadoInmueble || [];
      const plantas = criterios.plantas || [];
      const equip = criterios.equip || [];
      if (tipos.length > 0) q.set("tipos", tipos.join(","));
      if (criterios.op) q.set("operacion", criterios.op);
      const pMinApi = precioCriterioNum(criterios.pMin);
      const pMaxApi = precioCriterioNum(criterios.pMax);
      if (pMinApi != null) q.set("precio_min", String(pMinApi));
      if (pMaxApi != null) q.set("precio_max", String(pMaxApi));
      if (criterios.hMin) q.set("habs_min", criterios.hMin);
      if (criterios.bMin) q.set("banos_min", criterios.bMin);
      if (criterios.m2Min) q.set("m2_min", criterios.m2Min);
      if (criterios.m2Max) q.set("m2_max", criterios.m2Max);
      if (pobls.length > 0) q.set("poblaciones", joinPoblacionesQueryParam(pobls));
      if (zonas.length > 0) q.set("zonas", zonas.join(","));
      if (criterios.zonasExcl?.length > 0) q.set("zonas_excluidas", criterios.zonasExcl.join(","));
      if (
        criterios.geoLat != null &&
        criterios.geoLng != null &&
        criterios.geoRadioM != null &&
        Number(criterios.geoRadioM) > 0
      ) {
        q.set("geo_lat", String(criterios.geoLat));
        q.set("geo_lng", String(criterios.geoLng));
        q.set("geo_radio_m", String(Math.round(criterios.geoRadioM)));
      }
      if (extras.includes("piscina")) q.set("piscina", "true");
      if (extras.includes("garaje")) q.set("garaje", "true");
      if (extras.includes("terraza")) q.set("terraza", "true");
      if (extras.includes("ascensor")) q.set("ascensor", "true");
      if (extras.includes("amueblado")) q.set("amueblado", "true");
      if (extras.includes("primera_linea")) q.set("primera_linea", "true");
      if (extras.includes("vista_mar")) q.set("vista_mar", "true");
      if (criterios.extrasExcl?.includes("piscina")) q.set("piscina_excl", "true");
      if (criterios.extrasExcl?.includes("amueblado")) q.set("amueblado_excl", "true");
      // Criterios ampliados V10
      if (criterios.m2Parcela) q.set("m2_parcela_min", criterios.m2Parcela);
      if (orientacion.length > 0) q.set("orientaciones", orientacion.join(","));
      if (criterios.orientacionExcl?.length > 0) q.set("orientaciones_excl", criterios.orientacionExcl.join(","));
      if (criterios.jardin) q.set("jardin", "true");
      if (criterios.anoConstruccion) q.set("ano_construccion_desde", criterios.anoConstruccion);
      if (estadoInmueble.length > 0) q.set("estado_inmueble", estadoInmueble.join(","));
      if (criterios.estadoInmuebleExcl?.length > 0) q.set("estado_inmueble_excl", criterios.estadoInmuebleExcl.join(","));
      if (criterios.vpo) q.set("vpo", "true");
      if (criterios.vpoExcl) q.set("vpo_excl", "true");
      if (criterios.calEnergetica) q.set("cal_energetica", criterios.calEnergetica);
      if (plantas.length > 0) q.set("plantas", plantas.join(","));
      if (criterios.plantasExcl?.length > 0) q.set("plantas_excl", criterios.plantasExcl.join(","));
      if (criterios.aireAc) q.set("aire_acondicionado", "true");
      if (criterios.calefaccion) q.set("calefaccion", "true");
      if (criterios.padel) q.set("padel", "true");
      if (criterios.padelExcl) q.set("padel_excl", "true");
      if (criterios.tenis) q.set("tenis", "true");
      if (criterios.tenisExcl) q.set("tenis_excl", "true");
      if (criterios.puntoRecarga) q.set("punto_recarga", "true");
      if (criterios.adaptado) q.set("adaptado", "true");
      if (criterios.salidaHumos) q.set("salida_humos", "true");
      if (criterios.distanciaMar) q.set("distancia_mar_max", criterios.distanciaMar);
      if (criterios.urbanizacionId) q.set("urbanizacion_id", criterios.urbanizacionId);
      if (criterios.sinAsc) q.set("sin_asc_planta", criterios.plMax);
      if (equip.length > 0) q.set("equip", equip.join(","));
      const r = await api.get(`/leads/propiedades/buscar?${q.toString()}`);
      if (seq !== propsBuscarSeqRef.current) return;
      setProps(r.data.data || []);
    } catch (e) {
      if (seq !== propsBuscarSeqRef.current) return;
      console.error("Error cargando propiedades:", e);
    }
  }, []);

  // ── Búsqueda en portales externos (scraping BD) ────────────────────────────
  const buscarPropsExternas = useCallback(async (tipo, criterios, page = 1) => {
    setPropsExternasLoading(true);
    try {
      const q = new URLSearchParams();
      q.set("limit", "100");
      q.set("page", String(page));
      if (tipo && tipo !== "todos") q.set("tipo_anunciante", tipo);
      if (criterios?.op) q.set("operacion", criterios.op.toLowerCase());
      if (criterios?.tipos?.length > 0) q.set("tipo_inmueble", criterios.tipos[0]);
      if (criterios?.pobls?.length > 0) q.set("poblacion", criterios.pobls.join(","));
      const pMinExt = precioCriterioNum(criterios?.pMin);
      const pMaxExt = precioCriterioNum(criterios?.pMax);
      if (pMinExt != null) q.set("precio_min", String(pMinExt));
      if (pMaxExt != null) q.set("precio_max", String(pMaxExt));
      if (criterios?.hMin) q.set("hab_min", String(criterios.hMin).replace("+", ""));
      if (criterios?.bMin) q.set("banos_min", String(criterios.bMin).replace("+", ""));
      if (criterios?.m2Min) q.set("m2_min", criterios.m2Min);
      if (criterios?.m2Max) q.set("m2_max", criterios.m2Max);
      if (criterios?.extras?.includes("piscina"))      q.set("piscina", "true");
      if (criterios?.extras?.includes("garaje"))       q.set("garaje", "true");
      if (criterios?.extras?.includes("terraza"))      q.set("terraza", "true");
      if (criterios?.extras?.includes("ascensor"))     q.set("ascensor", "true");
      if (criterios?.extras?.includes("amueblado"))    q.set("amueblado", "true");
      if (criterios?.extras?.includes("primera_linea") || criterios?.extras?.includes("1linea")) q.set("primera_linea", "true");
      if (criterios?.extras?.includes("vista_mar"))    q.set("vista_mar", "true");
      if (criterios?.extras?.includes("padel") || criterios?.extras?.includes("pista_padel")) q.set("pista_padel", "true");
      if (criterios?.orientacion?.length > 0) q.set("orientacion", criterios.orientacion[0]);
      const res = await api.get(`/scraping/propiedades?${q.toString()}`);
      const items = res.data?.items || [];
      const total = res.data?.total || 0;
      if (page === 1) {
        setPropsExternas(items);
      } else {
        setPropsExternas(prev => [...(prev || []), ...items]);
      }
      setPropsExternasTotal(total);
      setPropsExternasPage(page);
    } catch (err) {
      console.error("Error buscando en portales:", err);
      if (page === 1) setPropsExternas([]);
    } finally {
      setPropsExternasLoading(false);
    }
  }, []);

  const startPreviewPanelDrag = useCallback((e) => {
    if (e.button !== 0) return;
    if (e.target.closest("button")) return;
    e.preventDefault();
    const origX = previewPosRef.current.x;
    const origY = previewPosRef.current.y;
    const startX = e.clientX;
    const startY = e.clientY;
    const onMove = (ev) => {
      setPreviewPanelPos({
        x: origX + ev.clientX - startX,
        y: origY + ev.clientY - startY,
      });
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, []);

  const abrirFichaResumen = async (propId) => {
    try {
      const datos = await cargarDatosFichaResumen(propId);
      const propBasica = props.find((p) => p.id === propId) || {};
      setFichaResumen({
        abierta: true,
        propiedad: { ...propBasica, ...datos, id: propId },
        datos,
      });
    } catch (err) {
      console.error("Error cargando ficha resumen:", err);
    }
  };

  const abrirFichaPorRef = async (ref) => {
    try {
      const refNorm = String(ref || "").trim().toLowerCase();
      if (!refNorm) return;
      // Lista de resultados de la demanda: match exacto por ref (no el primer card).
      const propLocal = props.find(
        (p) => String(p.referencia || "").trim().toLowerCase() === refNorm
      );
      if (propLocal?.id) {
        abrirFichaResumen(propLocal.id);
        return;
      }
      // `/propiedades?referencia=` NO filtra (listar usa `buscar`); abría la 1ª del listado.
      const propId = await resolverPropiedadIdPorReferencia(ref);
      if (propId) abrirFichaResumen(propId);
    } catch (e) {
      console.error("Error buscando propiedad por ref:", e);
    }
  };

  const mapPropiedadParaModalCita = useCallback((det, propietarios = []) => {
    let propsNorm = propietarios;
    if (typeof propsNorm === "string") {
      try { propsNorm = JSON.parse(propsNorm); } catch { propsNorm = []; }
    }
    if (!Array.isArray(propsNorm)) propsNorm = [];
    return {
      id: det.id,
      titulo: det.titulo || "Sin título",
      detalle: `${det.tipo_nombre || det.tipo || ""} · ${det.poblacion_nombre || det.poblacion || ""}`,
      precio: det.precio ? `${Number(det.precio).toLocaleString("es-ES")} €` : "Consultar",
      referencia: det.referencia,
      tenemos_llaves: det.tenemos_llaves || false,
      num_llave: det.num_llave || null,
      recoger_llaves_en: det.recoger_llaves_en || null,
      propietarios: propsNorm,
      info_visita: det.info_visita != null ? String(det.info_visita) : "",
    };
  }, []);

  const cargarPropiedadParaModalCita = useCallback(async (propId) => {
    const local = props.find((p) => String(p.id) === String(propId));
    if (local) {
      let propietarios = [];
      if (Array.isArray(local.propietarios)) propietarios = local.propietarios;
      else if (typeof local.propietarios === "string") {
        try { propietarios = JSON.parse(local.propietarios); } catch { propietarios = []; }
      }
      if (!propietarios.length) {
        try {
          const propRes = await api.get(`/propiedades/${propId}/propietarios`);
          propietarios = propRes.data?.data || propRes.data || [];
        } catch { /* ignore */ }
      }
      return mapPropiedadParaModalCita(local, propietarios);
    }
    const detRes = await api.get(`/propiedades/${propId}`);
    const det = detRes.data?.data || detRes.data?.propiedad || detRes.data;
    if (!det?.id) return null;
    let propietarios = [];
    try {
      const propRes = await api.get(`/propiedades/${propId}/propietarios`);
      propietarios = propRes.data?.data || propRes.data || [];
    } catch {
      if (Array.isArray(det.propietarios)) propietarios = det.propietarios;
      else if (typeof det.propietarios === "string") {
        try { propietarios = JSON.parse(det.propietarios); } catch { propietarios = []; }
      }
    }
    return mapPropiedadParaModalCita(det, propietarios);
  }, [props, mapPropiedadParaModalCita]);

  const anadirPropiedadAVisitaOverlay = useCallback(async (propId) => {
    if (!citaOverlay?.isOverlayActive || !propId) return;
    if (citaOverlay.isPropertyInCitaModal(propId)) return;
    const mapped = await cargarPropiedadParaModalCita(propId);
    if (mapped) citaOverlay.appendPropertyToCitaModal(mapped);
  }, [citaOverlay, cargarPropiedadParaModalCita]);

  const propiedadEnCitaModalActivo = useCallback((propId) => {
    if (!propId) return false;
    if (citaOverlay?.isOverlayActive) return citaOverlay.isPropertyInCitaModal(propId);
    if (modalCita && citaEdicionAgendaId) {
      return citaEdicionProperties.some((p) => String(p.id) === String(propId));
    }
    if (modalCita) return seleccionadas.includes(propId);
    return false;
  }, [citaOverlay, modalCita, citaEdicionAgendaId, citaEdicionProperties, seleccionadas]);

  const anadirPropiedadAlModalCitaActivo = useCallback(async (propId) => {
    if (!propId) return;
    if (citaOverlay?.isOverlayActive) {
      await anadirPropiedadAVisitaOverlay(propId);
      return;
    }
    if (!modalCita) return;
    if (propiedadEnCitaModalActivo(propId)) return;
    const mapped = await cargarPropiedadParaModalCita(propId);
    if (!mapped) return;
    if (citaEdicionAgendaId) {
      setCitaEdicionProperties((prev) => {
        if (prev.some((p) => String(p.id) === String(propId))) return prev;
        return [...prev, mapped];
      });
    } else if (!seleccionadas.includes(propId)) {
      setSeleccionadas((prev) => [...prev, propId]);
    }
  }, [
    citaOverlay,
    modalCita,
    citaEdicionAgendaId,
    seleccionadas,
    anadirPropiedadAVisitaOverlay,
    propiedadEnCitaModalActivo,
    cargarPropiedadParaModalCita,
  ]);

  const anadirSeleccionadasAVisitaOverlay = useCallback(async () => {
    if (citaOverlay?.isOverlayActive) {
      if (!seleccionadas.length) return;
      for (const id of seleccionadas) {
        if (citaOverlay.isPropertyInCitaModal(id)) continue;
        const mapped = await cargarPropiedadParaModalCita(id);
        if (mapped) citaOverlay.appendPropertyToCitaModal(mapped);
      }
      return;
    }
    if (modalCita) {
      for (const id of seleccionadas) {
        await anadirPropiedadAlModalCitaActivo(id);
      }
    }
  }, [citaOverlay, seleccionadas, cargarPropiedadParaModalCita, modalCita, anadirPropiedadAlModalCitaActivo]);

  const cerrarModalCita = useCallback(() => {
    setModalCita(false);
    setCitaEdicionAgendaId(null);
    setCitaEdicionSnapshot(null);
    setCitaEdicionInitial(null);
    setCitaEdicionProperties([]);
    setCitaPropsPendientesNueva([]);
  }, []);

  const abrirModalCitaNueva = useCallback(() => {
    setCitaEdicionAgendaId(null);
    setCitaEdicionSnapshot(null);
    setCitaEdicionInitial(null);
    setCitaEdicionProperties([]);
    setModalCita(true);
  }, []);

  const abrirModalCitaExistenteConSeleccion = useCallback(async (agendaId) => {
    if (!agendaId) return;
    const idsParaAnadir = pendingCitaPropIdsRef.current.length
      ? [...pendingCitaPropIdsRef.current]
      : [...seleccionadas];
    pendingCitaPropIdsRef.current = [];
    try {
      let cita;
      let propiedadesModal;
      let initialValues;
      try {
        const loaded = await loadCitaModalFromAgenda(api, agendaId, { mergeLeadRefs: false });
        cita = loaded.cita;
        propiedadesModal = loaded.propiedadesModal;
        initialValues = loaded.initialValues;
      } catch (e) {
        const res = await api.get(`/agenda/${agendaId}`);
        cita = res.data?.data || res.data;
        if (!cita?.id) throw e;
        propiedadesModal = [];
        const { fecha, hora } = isoToFechaHoraLocal(cita.fecha_inicio);
        initialValues = { fecha, horaInicio: hora, duracion: 45 };
      }
      const idsExistentes = new Set(propiedadesModal.map((p) => String(p.id)));
      const extra = [];
      for (const sid of idsParaAnadir) {
        if (idsExistentes.has(String(sid))) continue;
        const mapped = await cargarPropiedadParaModalCita(sid);
        if (mapped) extra.push(mapped);
      }
      setCitaEdicionAgendaId(String(cita.id));
      setCitaEdicionSnapshot(cita);
      setCitaEdicionInitial(initialValues);
      setCitaEdicionProperties([...propiedadesModal, ...extra]);
      setModalCita(true);
    } catch (e) {
      await dialogs.alert(e?.response?.data?.error || e?.message || "No se pudo abrir la cita existente.");
    }
  }, [seleccionadas, cargarPropiedadParaModalCita]);

  const iniciarFlujoCitaDesdeFicha = useCallback(async (extraPropIds = []) => {
    const ids = [...new Set([...seleccionadas, ...(extraPropIds || [])].filter(Boolean))];
    pendingCitaPropIdsRef.current = ids;
    const clienteId = cliente?.id || lead?.cliente_id || null;
    // Sin cliente guardado la cita queda huérfana (tarea sin contacto ni pipeline).
    if (!clienteId || id === "nuevo") {
      pendingCitaPropIdsRef.current = [];
      await dialogs.alert("Guarda el cliente antes de crear una cita.");
      return;
    }
    try {
      const r = await api.get(`/tareas/cliente/${clienteId}/cita-pendiente`);
      if (r.data?.tiene_cita && r.data?.cita?.id) {
        setEleccionCitaPendiente(r.data.cita);
        return;
      }
    } catch {
      /* sin cita pendiente → nueva */
    }
    abrirModalCitaNueva();
    pendingCitaPropIdsRef.current = [];
  }, [seleccionadas, cliente?.id, lead?.cliente_id, id, abrirModalCitaNueva]);

  const anadirPropiedadAVisitaDesdeFicha = useCallback(async (propId) => {
    if (citaModalActivo) {
      await anadirPropiedadAlModalCitaActivo(propId);
      return;
    }
    if (!seleccionadas.includes(propId)) {
      setSeleccionadas((prev) => [...prev, propId]);
    }
    await iniciarFlujoCitaDesdeFicha([propId]);
  }, [citaModalActivo, seleccionadas, anadirPropiedadAlModalCitaActivo, iniciarFlujoCitaDesdeFicha]);

  const abrirModalCitaDesdeAgenda = useCallback(async (agendaId) => {
    if (!agendaId) return;
    try {
      const { cita, propiedadesModal, initialValues } = await loadCitaModalFromAgenda(api, agendaId, {
        mergeLeadRefs: false,
      });
      setCitaEdicionAgendaId(String(cita.id));
      setCitaEdicionSnapshot(cita);
      setCitaEdicionInitial(initialValues);
      setCitaEdicionProperties(propiedadesModal);
      setModalCita(true);
    } catch (e) {
      await dialogs.alert(e?.response?.data?.error || e?.message || "No se pudo abrir la cita.");
    }
  }, []);

  const cerrarSegundaVisita = useCallback(() => {
    setSegundaVisitaTarea(null);
    setSegundaVisitaSnapshot(null);
    setSegundaVisitaProps([]);
    setSegundaVisitaResultado("Segunda visita");
  }, []);

  const abrirSegundaVisita = useCallback(async (tarea, ctx = {}) => {
    const observaciones = ctx?.observaciones || "";
    const obs = String(observaciones || "").trim();
    setSegundaVisitaResultado(obs ? `Segunda visita — ${obs}` : "Segunda visita");
    const propiedadIds = [
      ...new Set(
        [
          ...(Array.isArray(ctx?.propiedad_ids) ? ctx.propiedad_ids : []),
          ctx?.propiedad_id,
        ]
          .map((id) => String(id || "").trim())
          .filter((id) => id && !id.startsWith("ref-")),
      ),
    ];
    try {
      const { cita, propiedadesModal } = await loadSegundaVisitaModalContext(api, tarea, {
        clienteId: cliente?.id || tarea?.cliente_id,
        propiedadIds: propiedadIds.length ? propiedadIds : null,
      });
      setSegundaVisitaTarea(tarea);
      setSegundaVisitaSnapshot({
        ...cita,
        _m2_calificaciones: Array.isArray(ctx?.calificaciones) ? ctx.calificaciones : [],
      });
      setSegundaVisitaProps(propiedadesModal);
    } catch (e) {
      await dialogs.alert(e?.response?.data?.error || e?.message || "No se pudo abrir la cita.");
    }
  }, [cliente?.id]);

  const handleSegundaVisitaConfirm = useCallback(async (data) => {
    try {
      const propsVisita = data?.propiedades || [];
      const tarea = segundaVisitaTarea;
      const prev = segundaVisitaSnapshot || {};
      const fechaInicio = buildCitaDateTimeISO(data.fecha, data.horaInicio);
      const bloques = Math.max(1, propsVisita.length);
      const horaFin = data.horaFin || addMinutosHora(data.horaInicio, bloques * (data.duracion || 45));
      const fechaFin = buildCitaDateTimeISO(data.fecha, horaFin);
      const propiedadIds = propsVisita.map((p) => p.id).filter(Boolean);
      const lineasHorario = propsVisita.map((p) => `${p.horaVisita || data.horaInicio} · Ref. ${p.referencia || p.id}`);
      const califs = Array.isArray(prev._m2_calificaciones) ? prev._m2_calificaciones : [];
      await api.post(`/tareas/lead/${tarea.lead_id}/feedback-visita`, {
        accion: "segunda_visita",
        tarea_id: tarea.id,
        resultado: segundaVisitaResultado || "Segunda visita",
        ...(califs.length ? { calificaciones: califs } : {}),
        agendaPayload: {
          agente_id: prev.agente_id ? String(prev.agente_id) : null,
          usuario_id: prev.usuario_id ? String(prev.usuario_id) : null,
          cliente_id: prev.cliente_id || tarea.cliente_id || null,
          propiedad_ids: propiedadIds.length ? propiedadIds : null,
          titulo: prev.titulo || "Visita",
          descripcion: propsVisita.length
            ? `Segunda visita programada.\n${lineasHorario.join("\n")}`
            : "Segunda visita programada.",
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
        },
      });
      cerrarSegundaVisita();
      await cargarHistorial();
      const clienteIdRef = prev.cliente_id || tarea.cliente_id || cliente?.id || null;
      if (clienteIdRef) {
        await cargarMarcadoresVisitaCliente(clienteIdRef);
        // Solo ref: demAct/cargarHistorial se declaran más abajo → no ponerlos en deps (TDZ).
        const dmId = demActIdRef.current;
        if (dmId) await cargarEstados(dmId, clienteIdRef);
      }
    } catch (e) {
      await dialogs.alert(e?.response?.data?.error || e?.message || "No se pudo crear la segunda visita.");
      throw e;
    }
  }, [segundaVisitaTarea, segundaVisitaSnapshot, segundaVisitaResultado, cerrarSegundaVisita, cliente, cargarEstados, cargarMarcadoresVisitaCliente]);

  useEffect(() => {
    const timer = setTimeout(() => { cargarProps(cr); }, 400);
    return () => clearTimeout(timer);
  }, [cr, cargarProps, cliente?.id, lead?.cliente_id]);

  // Auto re-fetch portales cuando cambian los criterios (si modo portales activo)
  useEffect(() => {
    if (propsExternasTipo === null) return;
    const timer = setTimeout(() => { buscarPropsExternas(propsExternasTipo, cr, 1); }, 400);
    return () => clearTimeout(timer);
  }, [cr, propsExternasTipo, buscarPropsExternas]);

  // ============================================================
  // AUTO-GUARDAR criterios en la demanda
  // ============================================================
  const guardarCriterios = useCallback(async (criterios, demandaId) => {
    const datos = {
      tipos: criterios.tipos,
      operacion: criterios.op ? criterios.op.toLowerCase() : null,
      precio_min: precioCriterioNum(criterios.pMin),
      precio_max: precioCriterioNum(criterios.pMax),
      habitaciones_min: criterios.hMin ? (criterios.hMin === "5+" ? 5 : Number(criterios.hMin)) : null,
      banos_min: criterios.bMin ? (criterios.bMin === "4+" ? 4 : Number(criterios.bMin)) : null,
      m2_min: criterios.m2Min ? Number(criterios.m2Min) : null,
      m2_max: criterios.m2Max ? Number(criterios.m2Max) : null,
      poblacion: (criterios.pobls || []).length > 0 ? criterios.pobls.join(",") : null,
      poblaciones: (criterios.pobls || []).length > 0 ? criterios.pobls : [],
      zona: (criterios.zonas || []).length > 0 ? criterios.zonas.join(",") : null,
      zonas_excl: (criterios.zonasExcl || []).length > 0 ? criterios.zonasExcl.join(",") : null,
      piscina: (criterios.extras || []).includes("piscina"),
      garaje: (criterios.extras || []).includes("garaje"),
      terraza: (criterios.extras || []).includes("terraza"),
      ascensor: (criterios.extras || []).includes("ascensor"),
      amueblado: (criterios.extras || []).includes("amueblado"),
      primera_linea: (criterios.extras || []).includes("primera_linea"),
      vista_mar: (criterios.extras || []).includes("vista_mar"),
      piscina_excl: (criterios.extrasExcl || []).includes("piscina"),
      amueblado_excl: (criterios.extrasExcl || []).includes("amueblado"),
      // Criterios ampliados V10
      m2_parcela_min: criterios.m2Parcela ? Number(criterios.m2Parcela) : null,
      orientacion: criterios.orientacion,
      orientaciones_excl: (criterios.orientacionExcl || []).length > 0 ? criterios.orientacionExcl.join(",") : null,
      jardin: criterios.jardin,
      ano_construccion_desde: criterios.anoConstruccion ? Number(criterios.anoConstruccion) : null,
      estado_inmueble: criterios.estadoInmueble,
      estado_inmueble_excl: (criterios.estadoInmuebleExcl || []).length > 0 ? criterios.estadoInmuebleExcl.join(",") : null,
      vpo: criterios.vpo,
      vpo_excl: !!criterios.vpoExcl,
      cal_energetica: criterios.calEnergetica || null,
      plantas: criterios.plantas,
      plantas_excl: (criterios.plantasExcl || []).length > 0 ? criterios.plantasExcl.join(",") : null,
      aire_acondicionado: criterios.aireAc,
      calefaccion: criterios.calefaccion,
      pista_padel: criterios.padel,
      pista_padel_excl: !!criterios.padelExcl,
      pista_tenis: criterios.tenis,
      pista_tenis_excl: !!criterios.tenisExcl,
      punto_recarga: criterios.puntoRecarga,
      adaptado: criterios.adaptado,
      salida_humos: criterios.salidaHumos,
      distancia_mar_max: criterios.distanciaMar ? Number(criterios.distanciaMar) : null,
      urbanizacion_id: criterios.urbanizacionId || null,
      geo_centro_lat: criterios.geoLat ?? null,
      geo_centro_lng: criterios.geoLng ?? null,
      geo_radio_m: criterios.geoRadioM != null ? Math.round(Number(criterios.geoRadioM)) : null,
    };
    setGuardando(true);
    try {
      const resp = await api.patch(`/demandas/${demandaId}`, datos);
      const updated = resp.data?.data;
      if (updated && updated.id) {
        setDemAct((prev) => (prev?.id === demandaId ? { ...prev, ...updated } : prev));
        setDemandas((prev) => prev.map((d) => (d.id === demandaId ? { ...d, ...updated } : d)));
      }
    } catch (e) {
      console.error("[AutoGuardar] Error guardando criterios:", e);
    } finally {
      setGuardando(false);
    }
  }, []);

  useReloadOnRouteEnter(() => {
    cargar();
  }, [cargar]);
  useEffect(() => {
    api.get("/agentes").then(r => setAgentes(r.data.data || [])).catch(() => {});
    api.get("/auxiliares/estado-inmueble").then((r) => {
      const rows = r.data?.data || [];
      setEstadosInmueble(rows.map((x) => x.nombre).filter(Boolean));
    }).catch(() => {});
  }, []);


  // Cuando cambia la demanda activa, cargar sus criterios + tarea vigente de ESE lead
  const handleCambioDemanda = (dm) => {
    // Cancelar guardado pendiente
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    userModified.current = false;
    setDemAct(dm);
    setCr(extraerCriterios(dm, lead?.operacion));
    // Cargar estados de selección/descarte de esta demanda; enviadas = todas las demandas del cliente
    cargarEstados(dm.id, cliente?.id || lead?.cliente_id || null);
    // Tarea vigente al instante (no esperar solo al useEffect de leadFlowId:
    // si no, parece que «sigue la misma» al alternar demandas).
    const leadDem = pickLeadParaDemanda(leadsV, dm?.id, {
      preferLeadId: focusLeadId || (!esRutaCliente ? lead?.id : null),
    });
    const lid =
      leadDem?.id ||
      (lead?.id && lead?.demanda_id && String(lead.demanda_id) === String(dm?.id)
        ? lead.id
        : null);
    const seq = ++tareaVigenteSeqRef.current;
    if (!lid) {
      setTareaVigente(null);
      return;
    }
    api
      .get(`/tareas/lead/${lid}/activa`)
      .then((r) => {
        if (seq !== tareaVigenteSeqRef.current) return;
        setTareaVigente(r.data?.tarea || null);
      })
      .catch(() => {
        if (seq !== tareaVigenteSeqRef.current) return;
        setTareaVigente(null);
      });
  };

const toggleSeleccion = (propId) => {
    console.log("toggleSeleccion", propId, "demAct:", demAct?.id);
    const nueva = seleccionadas.includes(propId);
    setSeleccionadas(prev => nueva ? prev.filter(x => x !== propId) : [...prev, propId]);
    if (demAct?.id) {
      console.log("Guardando seleccion en BD...");
      guardarEstadoProp(demAct.id, propId, { seleccionada: !nueva });
    } else {
      console.log("NO hay demAct, no se guarda");
    }
  };

  const toggleDescarte = (propId) => {
    console.log("toggleDescarte", propId, "demAct:", demAct?.id);
    const nueva = descartadas.includes(propId);
    setDescartadas(prev => nueva ? prev.filter(x => x !== propId) : [...prev, propId]);
    setDescartadasPorCliente((prev) => prev.filter((id) => id !== propId));
    setSeleccionadas(prev => prev.filter(x => x !== propId));
    if (demAct?.id) {
      console.log("Guardando descarte en BD...");
      guardarEstadoProp(demAct.id, propId, {
        descartada: !nueva,
        seleccionada: false,
        descartada_por_cliente: false,
      });
    } else {
      console.log("NO hay demAct, no se guarda");
    }
  };

  const marcarPropiedadesEnviadasCliente = useCallback(async (propiedades, canal = "whatsapp") => {
    const clienteId = clienteIdRef.current || cliente?.id || lead?.cliente_id || null;
    const propiedad_ids = (propiedades || []).map((p) => p.id).filter(Boolean);
    if (!clienteId || !propiedad_ids.length) return;

    // Optimista: el badge «Enviada» debe verse al instante (email = naranja).
    // El POST /email/enviar-propiedades ya marca en BD; si el POST de aquí falla,
    // igual recargamos desde API en finally.
    const now = new Date().toISOString();
    const isEmail = canal === "email";
    setEnviadasInfo((prev) => {
      const next = { ...prev };
      for (const idRaw of propiedad_ids) {
        const id = String(idRaw);
        const prevRow = next[id] || {};
        const envio = { canal: isEmail ? "email" : "whatsapp", fecha: now };
        const prevEnvios = Array.isArray(prevRow.envios) ? prevRow.envios : [];
        next[id] = {
          ...prevRow,
          propiedad_id: id,
          enviada_email: isEmail ? true : Boolean(prevRow.enviada_email),
          enviada_whatsapp: isEmail ? Boolean(prevRow.enviada_whatsapp) : true,
          fecha_envio_email: isEmail ? now : prevRow.fecha_envio_email || null,
          fecha_envio_whatsapp: isEmail ? prevRow.fecha_envio_whatsapp || null : now,
          envios: [envio, ...prevEnvios],
        };
      }
      return next;
    });

    try {
      await api.post(`/clientes/${clienteId}/propiedades-enviadas`, {
        propiedad_ids,
        canal,
        demanda_id: demActIdRef.current || null,
      });
    } catch (e) {
      console.error("Error marcando propiedades enviadas:", e);
    } finally {
      await cargarEnviadasCliente(clienteId);
    }
  }, [cargarEnviadasCliente, cliente?.id, lead?.cliente_id]);

  const ensureDemandaActiva = useCallback(async (opts = {}) => {
    const silent = opts.silent === true;
    if (demActIdRef.current) return demActIdRef.current;
    const clienteId = clienteIdRef.current;
    if (!clienteId) return null;
    try {
      const rCli = await api.get(`/clientes/${clienteId}`);
      const existentes = rCli.data?.data?.demandas || [];
      if (existentes.length > 0) {
        const dm = existentes[0];
        demActIdRef.current = dm.id;
        demandasLenRef.current = existentes.length;
        if (!silent) {
          setDemAct(dm);
          setDemandas(existentes);
          void cargarEstados(dm.id, clienteId);
        }
        return dm.id;
      }

      const n = 1;
      const r = await api.post(`/clientes/${clienteId}/demandas`, {
        nombre: `Búsqueda ${n}`,
        familia: "residencial",
        operacion: (crRef.current?.op || "").toLowerCase() || "venta",
        agente_id: clienteAgenteIdRef.current || null,
      });
      const dm = r.data?.data;
      if (!dm?.id) return null;
      demActIdRef.current = dm.id;
      demandasLenRef.current = n;
      if (!silent) {
        setDemAct(dm);
        setDemandas((prev) => [dm, ...(prev || [])]);
        void cargarEstados(dm.id, clienteId);
      }
      return dm.id;
    } catch (e) {
      console.error("[Demanda] No se pudo crear demanda automática:", e);
      return null;
    }
  }, [cargarEstados]);

  useEffect(() => {
    if (!userModified.current) return;

    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);

    saveTimerRef.current = setTimeout(async () => {
      try {
        const demId = demActIdRef.current || (await ensureDemandaActiva());
        if (!demId) return;
        await guardarCriterios(crRef.current, demId);
      } finally {
        userModified.current = false;
      }
    }, 800);

    return () => {
      if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    };
  }, [cr, demAct?.id, ensureDemandaActiva, guardarCriterios]);

  useEffect(() => {
    return () => {
      if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
      if (!userModified.current) return;
      void (async () => {
        try {
          const demId = demActIdRef.current || (await ensureDemandaActiva({ silent: true }));
          if (demId) await guardarCriterios(crRef.current, demId);
        } finally {
          userModified.current = false;
        }
      })();
    };
  }, [ensureDemandaActiva, guardarCriterios]);

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState !== "hidden") return;
      if (!userModified.current) return;
      if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
      void (async () => {
        try {
          const demId = demActIdRef.current || (await ensureDemandaActiva());
          if (demId) await guardarCriterios(crRef.current, demId);
        } finally {
          userModified.current = false;
        }
      })();
    };
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, [ensureDemandaActiva, guardarCriterios]);

  const cargarHistorial = useCallback(async () => {
    if (id === "nuevo") return; // cliente nuevo, sin historial
    try {
      if (esRutaCliente) {
        // No pedimos reparar_citas: el reparador automático resucitaba citas/agendas
        // borradas y creaba tareas "reparar_historial" duplicadas + agendas fantasma
        // en cada carga de la ficha. La reparación queda solo en el endpoint manual.
        const rCliente = await api.get(`/historial/cliente/${id}`);
        const filasCliente = rCliente.data?.data || [];
        if (leadFlowId) {
          try {
            const rLead = await api.get(`/leads/${leadFlowId}/historial`);
            setHistorial(mergeHistorialRows(filasCliente, rLead.data?.data || []));
            return;
          } catch {
            /* solo historial cliente */
          }
        }
        setHistorial(filasCliente);
        return;
      }
      const r = await api.get(`/historial/lead/${id}`);
      setHistorial(r.data.data || []);
    } catch (e) {
      console.error("Error cargando historial:", e);
    }
  }, [id, esRutaCliente, leadFlowId]);

  useEffect(() => { cargarHistorial() }, [cargarHistorial]);

  useEffect(() => {
    if (!historial.length) return;
    const needed = new Set();
    historial.forEach((h) => {
      parsePropiedadesIds(h).forEach((pid) => {
        const sid = String(pid);
        const inProps = props.some((p) => String(p.id) === sid);
        const inMeta = historialPropMeta[sid];
        if (!inProps && !inMeta) needed.add(sid);
      });
    });
    if (!needed.size) return;
    let cancelled = false;
    Promise.all(
      [...needed].map((id) =>
        api.get(`/propiedades/${id}`)
          .then((r) => r.data?.data || r.data?.propiedad || r.data)
          .catch(() => null)
      )
    ).then((results) => {
      if (cancelled) return;
      setHistorialPropMeta((prev) => {
        const next = { ...prev };
        results.forEach((p) => {
          if (p?.id) {
            next[String(p.id)] = { id: p.id, referencia: p.referencia, titulo: p.titulo };
          }
        });
        return next;
      });
    });
    return () => { cancelled = true; };
  }, [historial, props, historialPropMeta]);

  const recargarTareaHistorialFlow = useCallback(async () => {
    const seq = ++tareaVigenteSeqRef.current;
    try {
      const histPromise = cargarHistorial();
      // Tarea vigente = del lead de la demanda seleccionada (no la «mejor» del cliente entero).
      const tareaPromise = leadFlowId
        ? api.get(`/tareas/lead/${leadFlowId}/activa`)
        : Promise.resolve({ data: { tarea: null } });
      const [, tareaRes] = await Promise.all([histPromise, tareaPromise]);
      if (seq !== tareaVigenteSeqRef.current) return;
      const tarea = tareaRes.data?.tarea || null;
      setTareaVigente(tarea);
      // Si el cliente contestó (o la tarea pasó a M1/M2), avisar al tablero Tareas sin F5.
      const meta = parseTaskMetadata(tarea);
      const sig = [
        tarea?.id || "",
        String(meta.task_code || ""),
        hasWhatsappReplyPending(tarea) ? "1" : "0",
        taskNeedsM1Modal(tarea) ? "m1" : "",
        taskNeedsM2Modal(tarea) ? "m2" : "",
        String(tarea?.titulo || ""),
      ].join("|");
      if (sig !== tareaVigenteNotifySigRef.current) {
        const prev = tareaVigenteNotifySigRef.current;
        tareaVigenteNotifySigRef.current = sig;
        if (prev && (hasWhatsappReplyPending(tarea) || taskNeedsM1Modal(tarea) || taskNeedsM2Modal(tarea))) {
          notifyTareasChanged({ reason: "ficha_tarea", leadId: leadFlowId || null });
        }
      }
    } catch {
      /* refresco en segundo plano */
    }
  }, [leadFlowId, cargarHistorial]);

  const abrirLeadModalDesdeHistorial = useCallback(async (leadId) => {
    const lid = leadId ? String(leadId).trim() : "";
    if (!lid) return;
    try {
      const res = await api.get(`/leads/${lid}`);
      const data = res.data?.data;
      if (data) setLeadModalHistorial(data);
      else await dialogs.alert("No se encontró el lead");
    } catch (e) {
      await dialogs.alert(e.response?.data?.error || "No se pudo cargar el lead");
    }
  }, []);

  const llamarCliente = useCallback(async (telefono, opts = {}) => {
    try {
      const leadId = lead?.id || leadFlowId || null;
      const data = await api.post("/telnyx/llamar", {
        telefonoCliente: telefono,
        clienteId: cliente?.id || null,
        leadId,
        vincularCitaPendiente: !!opts.vincularCitaPendiente,
      }).then((r) => r.data);
      if (data.ok) {
        await dialogs.alert("📞 Llamada iniciada — tu móvil recibirá la llamada en breve", { autoCloseMs: 2000 });
        if (leadId) {
          [10000, 20000, 35000, 60000, 90000].forEach((ms) => {
            setTimeout(() => recargarTareaHistorialFlow(), ms);
          });
          const runBridgeBackup = async () => {
            await api.post("/telnyx/cerrar-llamada-bridge", { leadId, backup: true }).catch(() => {});
            await recargarTareaHistorialFlow();
          };
          setTimeout(runBridgeBackup, 125000);
          setTimeout(runBridgeBackup, 300000);
        }
      } else {
        await dialogs.alert(`Error: ${data.error}`);
      }
    } catch (e) {
      await dialogs.alert(`Error: ${e.response?.data?.error || e.message}`);
    }
  }, [lead?.id, leadFlowId, cliente?.id, recargarTareaHistorialFlow]);

  useEffect(() => {
    const seq = ++tareaVigenteSeqRef.current;
    if (!leadFlowId) {
      setTareaVigente(null);
      return undefined;
    }
    api
      .get(`/tareas/lead/${leadFlowId}/activa`)
      .then((r) => {
        if (seq !== tareaVigenteSeqRef.current) return;
        setTareaVigente(r.data?.tarea || null);
      })
      .catch(() => {
        if (seq !== tareaVigenteSeqRef.current) return;
        setTareaVigente(null);
      });
    return undefined;
  }, [leadFlowId]);

  useEffect(() => {
    if (!leadFlowId) return undefined;
    // Con M1/M2 abiertos no refrescar la tarea en poll: el objeto nuevo
    // re-disparaba efectos del modal y lo «paradeaba» / borraba la selección.
    // En espera de WA: poll más corto para pillar el reply y avisar a Tareas.
    const tick = () => {
      if (modalCualificacionOpen || modalResultadoVisitaOpen) return;
      recargarTareaHistorialFlow();
    };
    tick();
    const waitingReply =
      isWhatsappWaitingTask(tareaVigente) && !hasWhatsappReplyPending(tareaVigente);
    const interval = setInterval(tick, waitingReply ? 5000 : 10000);
    const onFocus = () => tick();
    const onVis = () => {
      if (document.visibilityState === "visible") tick();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [
    leadFlowId,
    recargarTareaHistorialFlow,
    modalCualificacionOpen,
    modalResultadoVisitaOpen,
    tareaVigente,
  ]);

  useEffect(() => {
    setTareaModalDescartado(false);
    // Al cambiar de lead/cliente, olvidar los descartes de la ficha anterior:
    // así el nuevo cliente vuelve a auto-abrir su modal si tiene tarea pendiente.
    dismissedTaskIdsRef.current = new Set();
  }, [leadFlowId]);

  useEffect(() => {
    if (!location.state?.abrirTareaVigente) return;
    pendingAbrirTareaDesdeNavRef.current = true;
    setTareaModalDescartado(false);
    if (location.state?.tareaId) dismissedTaskIdsRef.current.delete(String(location.state.tareaId));
    // Conservar origen (returnTo / lead / demanda) al quitar solo el flag de auto-abrir modal.
    nav(location.pathname, {
      replace: true,
      state: {
        returnTo: location.state?.returnTo || undefined,
        leadId: location.state?.leadId || undefined,
        demandaId: location.state?.demandaId || undefined,
        tareaId: location.state?.tareaId || undefined,
      },
    });
  }, [location.state, location.pathname, nav]);

  useEffect(() => {
    if (!pendingAbrirTareaDesdeNavRef.current || !tareaVigente?.id) return;
    pendingAbrirTareaDesdeNavRef.current = false;
    if (taskIsM1Type(tareaVigente)) {
      setModalCualificacionOpen(true);
    } else if (taskIsM2Type(tareaVigente)) {
      setModalResultadoVisitaOpen(true);
    } else if (isT4PostVisitaEspera(tareaVigente)) {
      // Espera post-visita: no abrir modal de cita aunque arrastre agenda_id.
    } else if (isT4b1PendingContact(tareaVigente) || isT4b1AutoContactTask(tareaVigente)) {
      // T4b1 sin respuesta del cliente: no auto-abrir M2 (feedback de visita).
      // El agente usa Llamar / WhatsApp o «Abrir tarea» para marcar el contacto.
    } else if (isVisitFeedbackTask(tareaVigente) || getVisitAgendaId(tareaVigente)) {
      const agendaId = getVisitAgendaId(tareaVigente);
      if (agendaId) void abrirModalCitaDesdeAgenda(agendaId);
    }
  }, [tareaVigente, abrirModalCitaDesdeAgenda]);

  useEffect(() => {
    const taskId = tareaVigente?.id || null;
    // Tarea ya cerrada/pospuesta en esta sesión: no reabrir (se re-muestra al
    // re-entrar al cliente, porque el ref se reinicia al re-montar).
    if (taskId && dismissedTaskIdsRef.current.has(taskId)) {
      setModalCualificacionOpen(false);
      return;
    }
    if (!tareaVigente) {
      setModalCualificacionOpen(false);
      return;
    }
    if (isWhatsappWaitingTask(tareaVigente) && !hasWhatsappReplyPending(tareaVigente)) {
      setModalCualificacionOpen(false);
      return;
    }
    // Ana gestiona WA/cualificación: no auto-abrir M1 (evitar cualificar por error).
    if (isAnaManagedLeadTask(tareaVigente) || isAnaQualificationTask(tareaVigente)) {
      setModalCualificacionOpen(false);
      return;
    }
    // taskIsM1Type IGNORA el snooze de "ahora no": al volver a entrar en la ficha,
    // si la tarea sigue pendiente, el M1 vuelve a salir.
    if (taskIsM1Type(tareaVigente)) {
      setModalCualificacionOpen(true);
    } else {
      setModalCualificacionOpen(false);
    }
  }, [tareaVigente]);

  useEffect(() => {
    const taskId = tareaVigente?.id || null;
    if (taskId && dismissedTaskIdsRef.current.has(taskId)) {
      setModalResultadoVisitaOpen(false);
      return;
    }
    // M2 solo cuando toca cualificar la visita (T4 / T4b1 con respuesta).
    // T4b1 insistencia sin contacto no abre feedback de visita.
    if (taskNeedsM2Modal(tareaVigente)) {
      setModalResultadoVisitaOpen(true);
    } else {
      setModalResultadoVisitaOpen(false);
    }
  }, [tareaVigente]);

  const abrirTareaVigente = async () => {
    setTareaModalDescartado(false);
    if (tareaVigente?.id) dismissedTaskIdsRef.current.delete(tareaVigente.id);
    let tarea = tareaVigente;
    if (tarea?.id && leadFlowId) {
      try {
        await api.post(`/tareas/lead/${leadFlowId}/reabrir-modal`, { tarea_id: tarea.id });
        const r = await api.get(`/tareas/lead/${leadFlowId}/activa`);
        tarea = r.data?.tarea || null;
        setTareaVigente(tarea);
      } catch {
        /* ignorar */
      }
    }
    if (!tarea?.id) {
      await recargarTareaHistorialFlow();
      return;
    }
    if (taskIsM1Type(tarea)) {
      setModalCualificacionOpen(true);
      return;
    }
    if (taskIsM2Type(tarea)) {
      setModalResultadoVisitaOpen(true);
      return;
    }
    // T4b1: M2 solo con respuesta (arriba). Sin contacto / en espera → ir a Tareas;
    // la llamada o el WA se detectan solos (Telnyx / fromMe), sin preguntar.
    if (isT4b1Task(tarea) && (isT4b1PendingContact(tarea) || isT4b1AutoContactTask(tarea))) {
      nav("/tareas");
      return;
    }
    if (isSinPropiedadesBuscarTask(tarea)) {
      const envio = await dialogs.confirm(
        "¿Enviaste una propiedad por WhatsApp (p. ej. del scraping)? Si confirmas, se abrirá el modal de resultado."
      );
      if (envio) {
        try {
          await api.patch(`/tareas/${tarea.id}`, {
            estado: "completada",
            resultado: "Propiedad enviada por WhatsApp",
            resultado_codigo: "enviado",
            completada_en: new Date().toISOString(),
          });
          setTareaModalDescartado(false);
          if (tareaVigente?.id) dismissedTaskIdsRef.current.delete(tareaVigente.id);
          await recargarTareaHistorialFlow();
          const r = await api.get(`/tareas/lead/${leadFlowId}/activa`);
          const tActualizada = r.data?.tarea || null;
          if (tActualizada) setTareaVigente(tActualizada);
          if (taskNeedsM1Modal(tActualizada)) {
            setModalCualificacionOpen(true);
          } else if (taskIsM2Type(tActualizada)) {
            setModalResultadoVisitaOpen(true);
          }
        } catch (err) {
          await dialogs.alert(err.response?.data?.error || "No se pudo registrar el envío");
        }
        return;
      }
      const frios = await dialogs.confirm(
        "¿Confirmas que no hay propiedad para enviar? El cliente pasará a Fríos."
      );
      if (!frios) return;
      try {
        await api.patch(`/tareas/${tarea.id}`, {
          estado: "completada",
          resultado: "No hay propiedad nueva para enviar",
          resultado_codigo: "no_enviado",
          completada_en: new Date().toISOString(),
        });
        await recargarTareaHistorialFlow();
      } catch (err) {
        await dialogs.alert(err.response?.data?.error || "No se pudo completar la tarea");
      }
      return;
    }
    if (isAgenteResultTask(tarea) && !isWhatsappWaitingTask(tarea)) {
      setModalResultadoAgenteOpen(true);
      return;
    }
    // T4/TC · Cita: abrir el modal de la cita aquí (mismo comportamiento que en Tareas).
    // T4 · Esperar respuesta (post visita) NO es cita: con reply → M2 (arriba); sin reply → espera.
    {
      const codeVisita = String(parseTaskMetadata(tarea).task_code || "").toUpperCase();
      const agendaIdVisita = getVisitAgendaId(tarea);
      if (
        agendaIdVisita &&
        (isVisitFeedbackTask(tarea) ||
          codeVisita === "TC" ||
          (codeVisita === "T4" && !isT4PostVisitaEspera(tarea)))
      ) {
        await abrirModalCitaDesdeAgenda(agendaIdVisita);
        return;
      }
    }
    if (leadFlowId && (isWhatsappWaitingTask(tarea) || isWhatsappFlowTask(tarea))) {
      const code = String(parseTaskMetadata(tarea).task_code || "").toUpperCase();
      const isVisitWa = ["T3B", "T3B1"].includes(code);
      const isT4bObjecionesDescarte = isT4bObjecionesDescarteTask(tarea);
      const ok = await dialogs.confirm(
        isWhatsappWaitingTask(tarea)
          ? (isT4bObjecionesDescarte
            ? "¿El cliente ha respondido? Se abrirá el resultado del contacto."
            : isVisitWa
              ? "¿El lead ha respondido al WhatsApp? Se abrirá el modal para agendar cita."
              : "¿El lead ha respondido al WhatsApp? Se abrirá la cualificación.")
          : "¿Has enviado el WhatsApp? Marca la respuesta del lead para continuar.",
      );
      if (!ok) return;
      try {
        await api.post(`/tareas/lead/${leadFlowId}/whatsapp-respondido`);
        setTareaModalDescartado(false);
        if (tareaVigente?.id) dismissedTaskIdsRef.current.delete(tareaVigente.id);
        await recargarTareaHistorialFlow();
        const r = await api.get(`/tareas/lead/${leadFlowId}/activa`);
        const tActualizada = r.data?.tarea || null;
        if (tActualizada) setTareaVigente(tActualizada);
        if (taskNeedsM1Modal(tActualizada)) {
          setModalCualificacionOpen(true);
        } else if (taskIsM2Type(tActualizada)) {
          setModalResultadoVisitaOpen(true);
        }
      } catch (err) {
        await dialogs.alert(err.response?.data?.error || "No se pudo registrar la respuesta");
      }
      return;
    }
    nav("/tareas");
  };

  useEffect(() => {
    if (fichaResumen.abierta) setPreviewPanelPos({ x: 0, y: 0 });
  }, [fichaResumen.abierta, fichaResumen.propiedad?.id]);

  useEffect(() => {
    previewPosRef.current = previewPanelPos;
  }, [previewPanelPos]);

  // ── Guardar un estado en la BD ──
  const guardarEstadoProp = async (demandaId, propiedadId, datos) => {
    if (!demandaId) return;
    try {
      await api.put(`/demandas/${demandaId}/propiedades-estado/${propiedadId}`, datos);
    } catch (e) {
      console.error("Error guardando estado:", e);
    }
  };

// ── Enviar WhatsApp: marcar propiedades como enviadas (historial lo registra el backend al enviar) ──
  const quitarSeleccionPropiedadesEnviadas = async (propiedades) => {
    const ids = (propiedades || []).map((p) => p?.id).filter(Boolean);
    if (!ids.length) return;
    setSeleccionadas((prev) => prev.filter((id) => !ids.includes(id)));
    const demandaId = demActIdRef.current;
    if (demandaId) {
      await Promise.all(
        ids.map((propId) => guardarEstadoProp(demandaId, propId, { seleccionada: false }))
      );
    }
  };

  const handleWhatsAppSend = async ({ propiedades, mensaje }) => {
    if (propiedades?.length > 0) {
      await marcarPropiedadesEnviadasCliente(propiedades, "whatsapp");
      await quitarSeleccionPropiedadesEnviadas(propiedades);
    }
    // Misma ficha puede tener varios leads: marcar el lead de la tarea mostrada.
    const leadIdWa = tareaVigente?.lead_id || leadFlowId || null;
    if (leadIdWa) {
      try {
        const { data } = await api.post(`/tareas/lead/${leadIdWa}/whatsapp-enviado`);
        if (data?.mode === "not_whatsapp_wait_task") {
          console.warn("[FichaCliente] whatsapp-enviado sin tarea WA:", data?.taskCode);
        }
      } catch (e) {
        await dialogs.alert(
          e.response?.data?.error || "No se pudo registrar el envío de WhatsApp en el flujo del lead"
        );
      }
    }
    await recargarTareaHistorialFlow();
    cargarHistorial();

    const leadIdReload = leadIdWa || leadFlowId;
    if (!leadIdReload) return;
    try {
      const r = await api.get(`/tareas/lead/${leadIdReload}/activa`);
      setTareaVigente(r.data?.tarea || null);
    } catch (e) {
      console.error("[FichaCliente] post-envío WA:", e);
    }
  };

  const handleEmailSend = async ({ propiedades, mensaje }) => {
    const clienteId = clienteIdRef.current || cliente?.id || lead?.cliente_id || null;
    if (propiedades?.length > 0) {
      await marcarPropiedadesEnviadasCliente(propiedades, "email");
      await quitarSeleccionPropiedadesEnviadas(propiedades);
      // Por si el mark optimista/API del modal no pasó por marcarPropiedadesEnviadasCliente
      // (p. ej. clienteId tardío): relee marcas ya escritas por /email/enviar-propiedades.
      if (clienteId) await cargarEnviadasCliente(clienteId);
    } else {
      // Historial de email sin fichas (backend no registra propiedades_ids)
      try {
        await api.post("/historial", {
          lead_id: esRutaCliente ? null : id,
          cliente_id: clienteId,
          tipo: "email_enviado",
          canal: "email",
          contenido: mensaje || "",
          destinatario: eml,
          metadata: { origen: "ficha_cliente" },
        });
      } catch (e) {
        console.error("Error guardando historial:", e);
      }
    }

    // T1c email: mismo avance de flujo que WA (pasa a «Esperar respuesta»).
    // Sin esto la tarea se queda en «Enviar email» aunque el mail ya haya salido.
    const leadIdEmail = tareaVigente?.lead_id || leadFlowId || null;
    if (leadIdEmail) {
      try {
        const { data } = await api.post(`/tareas/lead/${leadIdEmail}/whatsapp-enviado`);
        if (data?.mode === "not_whatsapp_wait_task") {
          console.warn("[FichaCliente] email-enviado sin tarea de espera:", data?.taskCode);
        }
      } catch (e) {
        await dialogs.alert(
          e.response?.data?.error || "No se pudo registrar el envío de email en el flujo del lead"
        );
      }
    }
    await recargarTareaHistorialFlow();
    cargarHistorial();

    const leadIdReload = leadIdEmail || leadFlowId;
    if (!leadIdReload) return;
    try {
      const r = await api.get(`/tareas/lead/${leadIdReload}/activa`);
      setTareaVigente(r.data?.tarea || null);
    } catch (e) {
      console.error("[FichaCliente] post-envío email:", e);
    }
  };

  const handleNotaSave = async ({ tipo, contenido }) => {
    try {
      await api.post("/historial", {
        lead_id: esRutaCliente ? null : id,
        cliente_id: cliente?.id || lead?.cliente_id || null,
        tipo: "nota",
        canal: null,
        contenido: contenido,
        metadata: {},
      });
    } catch (e) {
      console.error("Error guardando nota:", e);
    }
    cargarHistorial();
  };

  const buildCitaDateTimeISO = (fecha, hora) => {
    if (!fecha || !hora) return null;
    const [y, mo, d] = fecha.split("-").map(Number);
    const [h, mi] = String(hora).split(":").map(Number);
    const dt = new Date(y, mo - 1, d, h, mi || 0, 0, 0);
    if (Number.isNaN(dt.getTime())) return null;
    return dt.toISOString();
  };

  const addMinutosHora = (hora, mins) => {
    const [h, m] = String(hora || "0:0").split(":").map(Number);
    const total = h * 60 + m + mins;
    const hh = String(Math.floor(total / 60) % 24).padStart(2, "0");
    const mm = String(total % 60).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  const handleCitaConfirm = async (data) => {
    try {
      if (data?.cierreMode === "ana") {
        throw new Error("Ana (IA) aún no está activa. Elige «Yo mismo» para programar la visita.");
      }
      const propsVisita = data?.propiedades || [];
      const clienteId = cliente?.id || lead?.cliente_id || null;
      const leadObj = esRutaCliente
        ? (leadsV.find((l) => l.activo !== false) || leadsV[0] || null)
        : (lead || null);
      const leadId = leadObj?.id || null;
      if ((!clienteId && !leadId) || id === "nuevo") {
        throw new Error("Guarda el cliente antes de crear una cita.");
      }
      const leadEsTerminal =
        !!leadObj && ETAPAS_LEAD_TERMINAL.has(String(leadObj.etapa || "").toLowerCase());
      const clienteEnFrio = ESTADOS_FRIO_FICHA.includes(
        String(cliente?.estado || "").trim().toLowerCase()
      );
      // Reactivar desde Fríos: la cita es la vía de salida → asignar al agente
      // que confirma (sesión), no al titular frío (suele ser Ana).
      const reactivarPorCita = !!(clienteId && (leadEsTerminal || !leadId || clienteEnFrio));
      const agenteId = reactivarPorCita
        ? (usuario?.agente_id || cliente?.agente_id || leadObj?.agente_id || lead?.agente_id || null)
        : (cliente?.agente_id || leadObj?.agente_id || lead?.agente_id || usuario?.agente_id || null);
      if (!agenteId) {
        throw new Error(
          reactivarPorCita
            ? "Inicia sesión como agente para crear la cita y sacar al cliente de Fríos."
            : "No hay agente asignado. Asigna un agente al cliente o inicia sesión como agente."
        );
      }

      const fechaInicio = buildCitaDateTimeISO(data.fecha, data.horaInicio);
      const bloques = Math.max(1, propsVisita.length);
      const horaFin = data.horaFin || addMinutosHora(data.horaInicio, bloques * (data.duracion || 45));
      const fechaFin = buildCitaDateTimeISO(data.fecha, horaFin);
      if (!fechaInicio || !fechaFin) {
        throw new Error("Fecha u hora de la visita no válidas.");
      }

      const propiedadIds = propsVisita.map((p) => p.id).filter(Boolean);
      const refs = propsVisita.map((p) => p.referencia || p.titulo || p.id).filter(Boolean);
      const nombreCliente = (cliente ? `${cliente.nombre || ""} ${cliente.apellido || ""}` : `${lead?.nombre || ""} ${lead?.apellido || ""}`).trim() || "Cliente";
      const titulo = `Visita — ${nombreCliente}`;
      const lineasHorario = propsVisita.map((p) => {
        const ref = p.referencia || p.id;
        return `${p.horaVisita || data.horaInicio} · Ref. ${ref}`;
      });
      const descripcion = propsVisita.length
        ? `Visita programada desde ficha cliente.\n${lineasHorario.join("\n")}`
        : "Visita programada desde ficha cliente.";

      if (citaEdicionAgendaId) {
        const prev = citaEdicionSnapshot || {};
        await api.put(`/agenda/${citaEdicionAgendaId}`, {
          id: citaEdicionAgendaId,
          agente_id: prev.agente_id ? String(prev.agente_id) : String(agenteId),
          usuario_id: prev.usuario_id ? String(prev.usuario_id) : (usuario?.id ? String(usuario.id) : null),
          lead_id: prev.lead_id || leadId || null,
          cliente_id: prev.cliente_id || clienteId || null,
          contacto_id: prev.contacto_id || null,
          captacion_id: String(prev.tipo || "visita").toLowerCase() === "captacion" ? (prev.captacion_id || null) : null,
          titulo: prev.titulo || titulo,
          descripcion,
          tipo: prev.tipo || "visita",
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
          estado: prev.estado || "pendiente",
          direccion: prev.direccion || null,
          notas: prev.notas || null,
          propiedad_ids: propiedadIds.length ? propiedadIds : null,
          creado_por_ia: prev.creado_por_ia || false,
          confirmado_por_cliente: prev.confirmado_por_cliente || false,
        });
        await cargarHistorial();
        if (clienteId) await cargarMarcadoresVisitaCliente(clienteId);
        try {
          sessionStorage.setItem("vitalcasa_msg", "Cita actualizada correctamente.");
        } catch { /* ignore */ }
        return;
      }

      // Lead terminal (frío/eliminado/ventas) o cliente en frío / sin lead activo:
      // reactivar con flujo de visita (T4) vía cita-desde-frio (no agenda huérfana).
      if (reactivarPorCita) {
        try {
          const url = leadId
            ? `/tareas/lead/${leadId}/cita-desde-frio`
            : `/tareas/cliente/${clienteId}/cita-desde-frio`;
          const demandaIdCita = demActIdRef.current || demAct?.id || null;
          const r = await api.post(url, {
            agenda: {
              agente_id: String(agenteId),
              usuario_id: usuario?.id ? String(usuario.id) : null,
              propiedad_ids: propiedadIds.length ? propiedadIds : null,
              titulo,
              descripcion,
              fecha_inicio: fechaInicio,
              fecha_fin: fechaFin,
              demanda_id: demandaIdCita,
            },
          });
          if (r.data?.ok) {
            if (demandaIdCita) {
              try {
                const tr = await api.patch(`/demandas/${demandaIdCita}`, { marcar_actividad: true });
                const updated = tr.data?.data;
                if (updated?.id) {
                  setDemAct((prev) => (prev?.id === updated.id ? { ...prev, ...updated } : prev));
                  setDemandas((prev) => prev.map((d) => (d.id === updated.id ? { ...d, ...updated } : d)));
                }
              } catch { /* best-effort: updated_at para próxima apertura */ }
            }
            await cargarHistorial();
            if (clienteId) await cargarMarcadoresVisitaCliente(clienteId);
            try {
              sessionStorage.setItem("vitalcasa_msg", "Cita creada y tarea de visita (T4) generada.");
            } catch { /* ignore */ }
            return;
          }
          throw new Error(
            r.data?.error ||
              "No se pudo crear la cita desde Fríos (respuesta sin ok)."
          );
        } catch (e) {
          const msg = e?.response?.data?.error || e?.message || "";
          // Si el cliente no tiene ningún lead vinculado, seguimos al flujo de
          // cita "cliente suelto"; cualquier otro error lo propagamos.
          if (!/no se encontró un lead vinculado/i.test(msg)) {
            throw new Error(msg || "No se pudo crear la cita");
          }
        }
      }

      const agendaRes = await api.post("/agenda", {
        agente_id: String(agenteId),
        usuario_id: usuario?.id ? String(usuario.id) : null,
        creado_por: String(agenteId),
        lead_id: leadId || null,
        cliente_id: clienteId || null,
        propiedad_ids: propiedadIds.length ? propiedadIds : null,
        titulo,
        descripcion,
        tipo: "visita",
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
        estado: "pendiente",
        confirmado_por_cliente: false,
      });
      const agendaId = agendaRes?.data?.data?.id || agendaRes?.data?.id || null;
      if (!agendaId) {
        throw new Error("La cita no se guardó en agenda (respuesta sin id).");
      }

      // Si hay un lead activo, el backend (hook al crear la agenda) completa la
      // cualificación/agendar-cita (T2A/T3) y crea la tarea de visita (TC → T4).
      // Solo creamos una tarea manual cuando NO hay flujo de lead (cliente suelto).
      if (!leadId) {
        const tareaRes = await api.post("/tareas", {
          lead_id: null,
          cliente_id: clienteId || null,
          agente_id: String(agenteId),
          tipo: "visita",
          descripcion: refs.length ? `${titulo} · ${refs.join(", ")}` : titulo,
          prioridad: "alta",
          fecha_vencimiento: fechaInicio,
          es_principal: false,
          origen: "ficha_cliente",
          metadata: {
            agenda_id: agendaId,
            propiedad_ids: propiedadIds.length ? propiedadIds : null,
            origen: "ficha_cliente",
          },
        });
        if (tareaRes?.data?.ok === false && !tareaRes?.data?.data) {
          throw new Error(tareaRes?.data?.error || "No se pudo crear la tarea de la visita");
        }
      }

      const fechaLegible = data.fecha
        ? new Date(`${data.fecha}T12:00:00`).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" })
        : "";
      await api.post("/historial", {
        lead_id: esRutaCliente ? null : id,
        cliente_id: clienteId,
        agente_id: agenteId,
        tipo: "cita_creada",
        canal: null,
        contenido: `${fechaLegible} · ${data.horaInicio}–${horaFin} · ${propsVisita.length} vivienda${propsVisita.length !== 1 ? "s" : ""}: ${refs.join(", ")}`,
        propiedades_ids: propiedadIds,
        metadata: {
          agenda_id: agendaId,
          fecha: data.fecha,
          hora_inicio: data.horaInicio,
          hora_fin: horaFin,
          duracion_min: data.duracion,
          cierre_mode: data.cierreMode,
        },
      });

      const demandaIdCitaAgenda = demActIdRef.current || demAct?.id || null;
      if (demandaIdCitaAgenda) {
        try {
          const tr = await api.patch(`/demandas/${demandaIdCitaAgenda}`, { marcar_actividad: true });
          const updated = tr.data?.data;
          if (updated?.id) {
            setDemAct((prev) => (prev?.id === updated.id ? { ...prev, ...updated } : prev));
            setDemandas((prev) => prev.map((d) => (d.id === updated.id ? { ...d, ...updated } : d)));
          }
        } catch { /* best-effort */ }
      }

      await cargarHistorial();
      if (clienteId) await cargarMarcadoresVisitaCliente(clienteId);
      try {
        sessionStorage.setItem(
          "vitalcasa_msg",
          "Cita guardada. En Agenda usa «Todos» o el agente del cliente si no la ves en tu calendario."
        );
      } catch { /* ignore */ }
    } catch (e) {
      throw new Error(e?.response?.data?.error || e?.message || "No se pudo guardar la cita");
    }
  };

  const transferCitaModalAFicha = useCallback((path) => {
    if (!path) return;
    const contact = {
      nombre: nom,
      telefono: tel,
      email: eml,
      iniciales: nom.split(" ").map((p) => p[0]).join("").substring(0, 2).toUpperCase(),
      clienteId: cliente?.id || null,
    };
    const properties = citaEdicionAgendaId && citaEdicionProperties.length
      ? citaEdicionProperties
      : [...new Set([...seleccionadas, ...citaPropsPendientesNueva])]
          .map((sid) => {
            const p = props.find((x) => String(x.id) === String(sid));
            if (!p) return null;
            let propietarios = [];
            if (Array.isArray(p.propietarios)) propietarios = p.propietarios;
            else if (typeof p.propietarios === "string") {
              try { propietarios = JSON.parse(p.propietarios); } catch { propietarios = []; }
            }
            return mapPropiedadParaModalCita(p, propietarios);
          })
          .filter(Boolean);

    const modalProps = {
      onConfirm: handleCitaConfirm,
      modoEdicion: Boolean(citaEdicionAgendaId),
      initialValues: citaEdicionInitial,
      contact,
      properties,
      agentName: lead?.agente_nombre || "",
      onLlamarTelefono: (telefono) => llamarCliente(telefono, { vincularCitaPendiente: true }),
      onAbrirVistaPrevia: abrirFichaResumen,
      onBuscarPropiedadPorRef: (ref) => fetchPropiedadPorRef(api, ref),
    };

    if (citaOverlay) {
      citaOverlay.transferModalToFicha({
        path,
        returnTo: `${location.pathname}${location.search}`,
        onCloseLocal: cerrarModalCita,
        modalProps,
      });
      return;
    }
    nav(path);
  }, [
    nom, tel, eml, cliente?.id, citaEdicionAgendaId, citaEdicionProperties, citaEdicionInitial,
    seleccionadas, citaPropsPendientesNueva, mapPropiedadParaModalCita, props, handleCitaConfirm,
    lead?.agente_nombre, abrirFichaResumen, citaOverlay, cerrarModalCita, location.pathname,
    location.search, nav, llamarCliente,
  ]);

  const guardarCampoCliente = async (campo, valor, forzar = false) => {
    const clienteId = cliente?.id || lead?.cliente_id;
    // Modo nuevo: guardar en estado local primero, luego verificar duplicado
    if (!clienteId) {
      setCliente(prev => ({ ...(prev || {}), [campo]: valor }));
      setLead(prev => ({ ...(prev || {}), [campo]: valor }));
      setEditando(null);
      // Verificar duplicado en segundo plano
      if ((campo === 'telefono' || campo === 'email') && valor && !forzar) {
        try {
          const telNorm = campo === 'telefono' ? valor : null;
          const emailVal = campo === 'email' ? valor : null;
          const r = await api.get('/clientes/buscar-duplicado', { params: { telefono: telNorm, email: emailVal } });
          console.log('[MODAL] respuesta:', r.data);
          if (r.data?.existe) {
            console.log('[MODAL] llamando setModalDuplicado');
            setModalDuplicado({ campo, valor, clienteExistente: r.data.cliente_existente, duplicate_type: r.data.duplicate_type, reason: r.data.reason, agente_nombre: r.data.agente_nombre, mensaje: r.data.mensaje });
            setPreviewLeadSuelto(null);
            console.log('[MODAL] setModalDuplicado llamado');
          } else {
            setPreviewLeadSuelto(r.data?.lead_suelto || null);
          }
        } catch (err) { console.error('[MODAL] error catch:', err); }
      }
      return;
    }
    // Dejar el valor tal cual lo escribe el usuario y validar por número de dígitos.
    let valorFinal = valor;
    if (!forzar && valor && ['apellido', 'dni', 'telefono', 'telefono_secundario', 'email'].includes(campo)) {
      const ctx = {
        idioma: cliente?.idioma || lead?.idioma || 'ES',
        pais: cliente?.pais || lead?.pais || 'España',
        dni: campo === 'dni' ? valor : (cliente?.dni || ''),
        dni_nie: campo === 'dni' ? valor : (cliente?.dni || ''),
      };
      const tipo = campo === 'apellido' ? 'apellidos' : campo;
      valorFinal = await softWarnCliente.checkField(tipo, valor, ctx);
    }
    if ((campo === 'telefono' || campo === 'telefono_secundario') && valorFinal) {
      const digits = String(valorFinal).replace(/\D/g, '');
      if (digits.length > 0 && digits.length < 9) {
        await dialogs.alert("El teléfono debe tener al menos 9 dígitos");
        setEditando(null);
        return;
      }
    }
    try {
      // El valor del modal puede diferir del draft del input: pintar ya la corrección.
      const aplicarLocal = (v) => {
        setCliente((prev) => (prev ? { ...prev, [campo]: v } : prev));
        setLead((prev) => {
          if (!prev) return prev;
          const next = { ...prev, [campo]: v };
          if (prev.cliente) next.cliente = { ...prev.cliente, [campo]: v };
          return next;
        });
      };
      const vacio = !String(valorFinal ?? '').trim();
      // TEL en ficha = cliente.telefono || cliente.whatsapp || lead…: al borrar TEL también limpia WA.
      const patchCliente = {
        [campo]: vacio ? null : valorFinal,
        ...(forzar ? { forzar_duplicado: true } : {}),
      };
      if (campo === 'telefono' && vacio) patchCliente.whatsapp = null;

      aplicarLocal(vacio ? '' : valorFinal);
      if (campo === 'telefono' && vacio) {
        setCliente((prev) => (prev ? { ...prev, whatsapp: '' } : prev));
        setLead((prev) => {
          if (!prev) return prev;
          const next = { ...prev, whatsapp: '' };
          if (prev.cliente) next.cliente = { ...prev.cliente, whatsapp: '' };
          return next;
        });
      }

      const patchRes = await api.patch(`/clientes/${clienteId}`, patchCliente);
      const saved = patchRes?.data?.data || patchRes?.data?.cliente || null;
      if (saved && typeof saved === 'object') {
        // Actualizar estado local sin reload completo (cargar() → pantallazo «Cargando…»).
        setCliente((prev) => (prev ? { ...prev, ...saved } : saved));
        setLead((prev) => {
          if (!prev) return prev;
          const next = {
            ...prev,
            [campo]: saved[campo] ?? (vacio ? '' : valorFinal),
            ...(campo === 'telefono' && vacio ? { whatsapp: saved.whatsapp || '' } : {}),
          };
          if (prev.cliente) next.cliente = { ...prev.cliente, ...saved };
          return next;
        });
      } else {
        aplicarLocal(vacio ? '' : valorFinal);
      }

      // Sync leads vinculados (en /clientes el lead virtual tiene id null → usar leadsV / embudo).
      if (['telefono', 'telefono_secundario', 'whatsapp', 'email'].includes(campo)) {
        const ids = new Set();
        if (lead?.id) ids.add(String(lead.id));
        if (leadEmbudoActivo?.id) ids.add(String(leadEmbudoActivo.id));
        for (const l of leadsV || []) {
          if (l?.id) ids.add(String(l.id));
        }
        const patchLead = { [campo]: vacio ? null : valorFinal };
        if (campo === 'telefono' && vacio) patchLead.whatsapp = null;
        await Promise.all(
          [...ids].map((lid) =>
            api.patch(`/leads/${lid}`, patchLead).catch((le) => {
              console.warn('[FichaCliente] sync lead tras cliente:', le?.message || le);
            })
          )
        );
        if (ids.size) {
          setLeadsV((prev) =>
            (prev || []).map((l) =>
              ids.has(String(l.id))
                ? {
                    ...l,
                    [campo]: vacio ? '' : valorFinal,
                    ...(campo === 'telefono' && vacio ? { whatsapp: '' } : {}),
                  }
                : l
            )
          );
        }
      }
      setEditando(null);
      setEditVal('');
    } catch (e) {
      if (e.response?.status === 409) {
        const otro = e.response.data?.cliente_existente;
        setModalDuplicado({ campo, valor: valorFinal, clienteExistente: otro, duplicate_type: e.response.data?.duplicate_type, reason: e.response.data?.reason, agente_nombre: e.response.data?.agente_nombre, mensaje: e.response.data?.mensaje });
        setEditando(null); setEditVal('');
        return;
      }
      console.error("Error guardando campo:", e);
      setEditando(null);
    }
  };

  const crearClienteNuevo = async (opts = {}) => {
    if (!cliente?.nombre) { await dialogs.alert("El nombre es obligatorio"); return; }
    setGuardando(true);
    const base = {
      nombre:    cliente.nombre   || null,
      apellido:  cliente.apellido || null,
      email:     cliente.email    || null,
      telefono:  cliente.telefono || null,
      telefono_secundario: cliente.telefono_secundario || null,
      whatsapp:  cliente.whatsapp || null,
      idioma:    cliente.idioma   || 'ES',
      agente_id: cliente.agente_id || null,
      pais:      cliente.pais     || 'España',
      provincia: cliente.provincia || null,
      poblacion: cliente.poblacion || null,
      direccion: cliente.direccion || null,
      dni:       cliente.dni      || null,
    };
    try {
      const res = await api.post('/clientes', { ...base, ...opts, origen: opts.origen || 'contactos' });
      const nuevo = res.data.data;
      setModalLeadSuelto(null);
      setModalClienteCreacion(null);
      nav(`/clientes/${nuevo.id}`, { replace: true });
    } catch (e) {
      if (e.response?.status === 409) {
        const d = e.response.data || {};
        if (d.error === 'conflicto_cliente') {
          setModalClienteCreacion({ response: d, retryOpts: opts });
          return;
        }
        if (d.error === 'conflicto_lead_suelto') {
          setModalLeadSuelto(d);
          setPreviewLeadSuelto(null);
          return;
        }
        await dialogs.alert(d.error || "Error al crear el cliente");
      } else {
        console.error("Error creando cliente:", e);
        await dialogs.alert("Error al crear el cliente");
      }
    } finally {
      setGuardando(false);
    }
  };

  const crearDemanda = async () => {
    const clienteId = cliente?.id || lead?.cliente_id;
    if (!clienteId) return;
    try {
      const numDemandas = demandas.length + 1;
      await api.post(`/clientes/${clienteId}/demandas`, {
        nombre: `Búsqueda ${numDemandas}`,
        familia: "residencial",
        operacion: cr.op?.toLowerCase() || "venta",
        agente_id: cliente?.agente_id || null,
      });
      cargar();
    } catch (e) {
      console.error("Error creando demanda:", e);
    }
  };

  const tArr = (f, v) => { userModified.current = true; setCr(p => { const a = p[f]; return { ...p, [f]: a.includes(v) ? a.filter(x => x !== v) : [...a, v] } }); };

  // Clic: aplicar al momento (incluir/quitar). Doble clic en ventana: excluir.
  // Antes se difería el 1.er clic 380ms → el 2.º clic (impaciencia) acababa en exclusión
  // y filtros como piscina no parecían «exigir» (p. ej. 3648-C sin piscina seguía saliendo).
  const CRITERIO_DBL_MS = 380;
  const scheduleCriterioInclExcl = (id, onSingle, onDouble) => {
    const now = Date.now();
    const r = criterioChipDblRef.current;
    if (r.id === id && now - r.t < CRITERIO_DBL_MS) {
      if (r.timer) {
        clearTimeout(r.timer);
        r.timer = null;
      }
      r.id = null;
      r.t = 0;
      userModified.current = true;
      onDouble();
      return;
    }
    r.id = id;
    r.t = now;
    if (r.timer) clearTimeout(r.timer);
    userModified.current = true;
    onSingle();
    r.timer = setTimeout(() => {
      r.timer = null;
      r.id = null;
    }, CRITERIO_DBL_MS);
  };

  const onZonaChipPress = (z) => {
    scheduleCriterioInclExcl(
      `zona:${z}`,
      () => setCr((p) => {
        const zo = p.zonas || [];
        const ex = p.zonasExcl || [];
        if (zo.includes(z)) return { ...p, zonas: zo.filter((x) => x !== z), zonasExcl: ex.filter((x) => x !== z) };
        return { ...p, zonas: [...zo, z], zonasExcl: ex.filter((x) => x !== z) };
      }),
      () => setCr((p) => {
        const ex = p.zonasExcl || [];
        const zo = p.zonas || [];
        if (ex.includes(z)) return { ...p, zonasExcl: ex.filter((x) => x !== z) };
        return { ...p, zonas: zo.filter((x) => x !== z), zonasExcl: [...ex, z] };
      }),
    );
  };

  const onArrayInclExclChip = (inclKey, exclKey, val) => {
    scheduleCriterioInclExcl(
      `${String(inclKey)}:${String(val)}`,
      () => setCr((p) => {
        const inc = p[inclKey] || [];
        const ex = p[exclKey] || [];
        if (inc.includes(val)) return { ...p, [inclKey]: inc.filter((x) => x !== val), [exclKey]: ex.filter((x) => x !== val) };
        return { ...p, [inclKey]: [...inc, val], [exclKey]: ex.filter((x) => x !== val) };
      }),
      () => setCr((p) => {
        const ex = p[exclKey] || [];
        const inc = p[inclKey] || [];
        if (ex.includes(val)) return { ...p, [exclKey]: ex.filter((x) => x !== val) };
        return { ...p, [inclKey]: inc.filter((x) => x !== val), [exclKey]: [...ex, val] };
      }),
    );
  };

  const onExtraInclExclChip = (k) => {
    scheduleCriterioInclExcl(
      `extra:${k}`,
      () => setCr((p) => {
        const inc = p.extras || [];
        const ex = p.extrasExcl || [];
        if (inc.includes(k)) return { ...p, extras: inc.filter((x) => x !== k), extrasExcl: ex.filter((x) => x !== k) };
        return { ...p, extras: [...inc, k], extrasExcl: ex.filter((x) => x !== k) };
      }),
      () => setCr((p) => {
        const ex = p.extrasExcl || [];
        const inc = p.extras || [];
        if (ex.includes(k)) return { ...p, extrasExcl: ex.filter((x) => x !== k) };
        return { ...p, extras: inc.filter((x) => x !== k), extrasExcl: [...ex, k] };
      }),
    );
  };

  const onBoolTriChip = (inclField, exclField) => {
    scheduleCriterioInclExcl(
      `bool:${inclField}`,
      () => setCr((p) => {
        if (p[inclField]) return { ...p, [inclField]: false, [exclField]: false };
        return { ...p, [inclField]: true, [exclField]: false };
      }),
      () => setCr((p) => {
        if (p[exclField]) return { ...p, [inclField]: false, [exclField]: false };
        return { ...p, [inclField]: false, [exclField]: true };
      }),
    );
  };

  const scheduleHistorialChipInclExcl = (id, onSingle, onDouble) => {
    const now = Date.now();
    const r = historialChipDblRef.current;
    if (r.id === id && now - r.t < CRITERIO_DBL_MS) {
      if (r.timer) {
        clearTimeout(r.timer);
        r.timer = null;
      }
      r.id = null;
      r.t = 0;
      onDouble();
      return;
    }
    r.id = id;
    r.t = now;
    if (r.timer) clearTimeout(r.timer);
    onSingle();
    r.timer = setTimeout(() => {
      r.timer = null;
      r.id = null;
    }, CRITERIO_DBL_MS);
  };

  const onHistorialFiltroChipPress = (filtroId, isReset = false) => {
    scheduleHistorialChipInclExcl(
      `hist:${filtroId}`,
      () => {
        if (isReset) {
          setHistorialFiltrosIncl([]);
          setHistorialFiltrosExcl([]);
          return;
        }
        setHistorialFiltrosIncl((inc) => {
          if (inc.includes(filtroId)) return inc.filter((x) => x !== filtroId);
          return [...inc, filtroId];
        });
        setHistorialFiltrosExcl((ex) => ex.filter((x) => x !== filtroId));
      },
      () => {
        if (isReset) {
          setHistorialFiltrosIncl([]);
          setHistorialFiltrosExcl([...HISTORIAL_FILTRO_IDS]);
          return;
        }
        setHistorialFiltrosExcl((ex) => {
          if (ex.includes(filtroId)) return ex.filter((x) => x !== filtroId);
          return [...ex, filtroId];
        });
        setHistorialFiltrosIncl((inc) => inc.filter((x) => x !== filtroId));
      },
    );
  };

  const sF = (f, v) => { userModified.current = true; setCr(p => ({ ...p, [f]: v })); };
  const sPrecioCriterio = (campo, raw, blur) => {
    userModified.current = true;
    if (!blur) {
      setCr((p) => ({ ...p, [campo]: raw }));
      return;
    }
    const s = String(raw ?? "").trim();
    if (!s) {
      setCr((p) => ({ ...p, [campo]: "" }));
      return;
    }
    const n = parsePrecioVentaEntero(s);
    setCr((p) => ({ ...p, [campo]: Number.isFinite(n) ? formatPrecioVentaEntero(n) : s }));
  };
  const s1 = (f, v) => { userModified.current = true; setCr(p => ({ ...p, [f]: p[f] === v ? "" : v })); };

  const cambiarEtapa = async (et) => {
    try { await api.patch(`/leads/${id}/etapa`, { etapa: et }); setLead(p => ({ ...p, etapa: et })) } catch (e) { }
  };

  const ff = (f) => {
    if (!f) return "";
    return new Date(f).toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  // ============================================================
  // ESTILOS COMUNES
  // ============================================================
  const inputStyle = {
    width: '100%', padding: '6px 10px', fontSize: 11,
    border: `1px solid ${c.border}`, borderRadius: 6,
    background: c.bgInput, color: c.textPrimary, outline: 'none',
    transition: 'border-color 0.15s, background 0.15s, color 0.15s',
  };

  /** Inputs/selects de criterios con valor: mismo azul que chips (criterio-campo-lleno = chipActiveBg). */
  const criterioCampoRelleno = (valor) => String(valor ?? "").trim() !== "";
  const estiloInputCriterio = (valor, extra = {}) => {
    const filled = criterioCampoRelleno(valor);
    return {
      ...inputStyle,
      ...extra,
      fontWeight: filled ? 700 : 500,
    };
  };
  const classInputCriterio = (valor) =>
    criterioCampoRelleno(valor) ? "criterio-campo-lleno" : undefined;
  const onFocusInputCriterio = (e) => {
    if (!e.target.classList.contains("criterio-campo-lleno")) {
      e.target.style.borderColor = c.borderFocus;
    }
  };
  const onBlurInputCriterio = (e) => {
    if (!e.target.classList.contains("criterio-campo-lleno")) {
      e.target.style.borderColor = c.border;
    }
  };

  const masCriteriosConDatos = Boolean(
    criterioCampoRelleno(cr.m2Parcela) ||
      criterioCampoRelleno(cr.anoConstruccion) ||
      criterioCampoRelleno(cr.distanciaMar) ||
      criterioCampoRelleno(cr.calEnergetica) ||
      (cr.orientacion || []).length ||
      (cr.orientacionExcl || []).length ||
      (cr.estadoInmueble || []).length ||
      (cr.estadoInmuebleExcl || []).length ||
      (cr.plantas || []).length ||
      (cr.plantasExcl || []).length ||
      cr.jardin ||
      cr.vpo ||
      cr.vpoExcl ||
      cr.aireAc ||
      cr.calefaccion ||
      cr.padel ||
      cr.padelExcl ||
      cr.tenis ||
      cr.tenisExcl ||
      cr.puntoRecarga ||
      cr.adaptado ||
      cr.salidaHumos ||
      (cr.equip || []).length
  );

  const sectionLabel = {
    fontSize: 13, fontWeight: 600, color: theme.name === 'dark' ? c.textPrimary : '#1d4ed8', marginBottom: 4,
  };

  const sectionDivider = {
    borderBottom: `1px solid ${c.sectionBorder}`,
  };

  const historialSinFiltroActivo =
    historialFiltrosIncl.length === 0 && historialFiltrosExcl.length === 0;

  const historialVisibles = useMemo(() => {
    const base = historial.filter((h) => !HISTORIAL_EXCL_TIPOS.includes(h.tipo));
    const filtered = base.filter((h) => historialPasaFiltros(h, historialFiltrosIncl, historialFiltrosExcl));
    return consolidarHistorialWhatsappEnviado(filtered);
  }, [historial, historialFiltrosIncl, historialFiltrosExcl]);

  const historialRender = useMemo(
    () => agruparHistorialConLlamadasEnCitas(historialVisibles),
    [historialVisibles]
  );

  /** Poblaciones seleccionadas que no están en la fila principal: se muestran siempre antes de «Más». */
  const extraPoblsEnCabecera = useMemo(() => {
    const setPrin = new Set(POBLS_PRINCIPALES.map(normNombrePobl));
    const seen = new Set();
    const out = [];
    for (const p of cr.pobls || []) {
      const k = normNombrePobl(p);
      if (!k || setPrin.has(k) || seen.has(k)) continue;
      seen.add(k);
      out.push(p);
    }
    return out;
  }, [cr.pobls]);

  /** Tipos seleccionados que no están en la fila principal: se muestran siempre antes de «Más». */
  const extraTiposEnCabecera = useMemo(() => {
    const setPrin = new Set(TIPOS_PRINCIPALES.map(normNombrePobl));
    const seen = new Set();
    const out = [];
    for (const t of cr.tipos || []) {
      const k = normNombrePobl(t);
      if (!k || setPrin.has(k) || seen.has(k)) continue;
      seen.add(k);
      out.push(t);
    }
    return out;
  }, [cr.tipos]);

  const poblsMasLista = useMemo(() => {
    const setPrin = new Set(POBLS_PRINCIPALES.map(normNombrePobl));
    const setYaCab = new Set(extraPoblsEnCabecera.map(normNombrePobl));
    const seen = new Set();
    const out = [];
    for (const n of poblacionesConViv) {
      const k = normNombrePobl(n);
      if (!k || setPrin.has(k) || setYaCab.has(k) || seen.has(k)) continue;
      seen.add(k);
      out.push(n);
    }
    return out.sort((a, b) => String(a).localeCompare(String(b), "es", { sensitivity: "base" }));
  }, [poblacionesConViv, extraPoblsEnCabecera]);

  const tiposMasLista = useMemo(() => {
    const setPrin = new Set(TIPOS_PRINCIPALES.map(normNombrePobl));
    const setYaCab = new Set(extraTiposEnCabecera.map(normNombrePobl));
    const seen = new Set();
    const out = [];
    for (const n of tiposCatalogo) {
      const k = normNombrePobl(n);
      if (!k || setPrin.has(k) || setYaCab.has(k) || seen.has(k)) continue;
      seen.add(k);
      out.push(n);
    }
    return out.sort((a, b) => String(a).localeCompare(String(b), "es", { sensitivity: "base" }));
  }, [tiposCatalogo, extraTiposEnCabecera]);

  const zonasParaChips = useMemo(() => {
    const poblsSel = cr.pobls || [];
    const seen = new Set();
    const out = [];
    const pushNom = (nom) => {
      const n = String(nom || "").trim();
      if (!n) return;
      const k = normNombrePobl(n);
      if (seen.has(k)) return;
      seen.add(k);
      out.push(n);
    };
    for (const z of catalogoZonas) {
      if (poblsSel.length > 0) {
        const match = poblsSel.some((p) => poblsZonaCoinciden(p, z.poblacion));
        if (!match) continue;
      }
      pushNom(z.nombre);
    }
    for (const sel of [...(cr.zonas || []), ...(cr.zonasExcl || [])]) pushNom(sel);
    return out.sort((a, b) => String(a).localeCompare(String(b), "es", { sensitivity: "base" }));
  }, [catalogoZonas, cr.pobls, cr.zonas, cr.zonasExcl]);

  const { zonasFilaPrincipal, zonasResto } = useMemo(() => {
    const principal = [];
    const usados = new Set();
    const coincidePatron = (nombre, patron) => {
      const n = normZonaKey(nombre);
      const p = normZonaKey(patron);
      return n === p || n.startsWith(p) || p.startsWith(n);
    };
    for (const patrones of ZONAS_PRINCIPAL_PATRONES) {
      const hit = zonasParaChips.find((z) => patrones.some((p) => coincidePatron(z, p)));
      if (hit) {
        const k = normZonaKey(hit);
        if (!usados.has(k)) {
          usados.add(k);
          principal.push(hit);
        }
      }
    }
    // Si no hay fila Dénia (p. ej. otra población), promover primeras del catálogo a cabecera.
    if (principal.length === 0) {
      for (const z of zonasParaChips) {
        if (principal.length >= 6) break;
        const k = normZonaKey(z);
        if (usados.has(k)) continue;
        usados.add(k);
        principal.push(z);
      }
    }
    const resto = zonasParaChips.filter((z) => !usados.has(normZonaKey(z)));
    return { zonasFilaPrincipal: principal, zonasResto: resto };
  }, [zonasParaChips]);

  /** Zonas seleccionadas (incl/excl) fuera de la fila principal: visibles siempre, como extraPobls. */
  const extraZonasEnCabecera = useMemo(() => {
    const setPrin = new Set(zonasFilaPrincipal.map(normZonaKey));
    const seen = new Set();
    const out = [];
    for (const z of [...(cr.zonas || []), ...(cr.zonasExcl || [])]) {
      const k = normZonaKey(z);
      if (!k || setPrin.has(k) || seen.has(k)) continue;
      seen.add(k);
      out.push(z);
    }
    return out;
  }, [cr.zonas, cr.zonasExcl, zonasFilaPrincipal]);

  /** Resto del catálogo para +Zonas (sin las ya promovidas a cabecera). */
  const zonasRestoLista = useMemo(() => {
    const setYaCab = new Set(extraZonasEnCabecera.map(normZonaKey));
    return zonasResto.filter((z) => !setYaCab.has(normZonaKey(z)));
  }, [zonasResto, extraZonasEnCabecera]);

  const poblacionParaMapa = useMemo(() => {
    const deniaKey = normNombrePobl("Dénia");
    const pobls = cr.pobls || [];
    const denia = pobls.find((p) => normNombrePobl(p) === deniaKey);
    if (denia) return denia;
    return pobls[0] || "";
  }, [cr.pobls]);

  const geoMapaActivo =
    cr.geoLat != null && cr.geoLng != null && cr.geoRadioM != null && Number(cr.geoRadioM) > 0;

  // Descartadas (demanda / cliente / visita M2): siguen en el grid al final, pero no cuentan en el total.
  const descartadasEfectivasIds = useMemo(() => {
    const ids = new Set();
    for (const id of descartadas || []) if (id) ids.add(String(id));
    for (const id of descartadasPorCliente || []) if (id) ids.add(String(id));
    for (const p of props || []) {
      if (p?.id && propDescartadaPorClienteEnVisitas(p.id, visitadasInfo)) ids.add(String(p.id));
    }
    return ids;
  }, [props, descartadas, descartadasPorCliente, visitadasInfo]);

  const propsOrdenadas = useMemo(() => {
    if (!props.length) return props;
    const descartadasEfectivas = [...descartadasEfectivasIds];
    const ctx = {
      descartadas: descartadasEfectivas,
      enviadasInfo,
      visitadasInfo,
      enCitaInfo,
      ofertasInfo,
      vendidasInfo,
    };
    return [...props].sort((a, b) => {
      const pa = prioridadPropiedadResultado(a.id, ctx);
      const pb = prioridadPropiedadResultado(b.id, ctx);
      return pa - pb;
    });
  }, [props, descartadasEfectivasIds, enviadasInfo, visitadasInfo, enCitaInfo, ofertasInfo, vendidasInfo]);

  const nPropsCabeza = useMemo(() => {
    if (propsExternas !== null) return propsExternas.length;
    if (!props.length) return 0;
    let n = 0;
    for (const p of props) {
      if (p?.id && !descartadasEfectivasIds.has(String(p.id))) n += 1;
    }
    return n;
  }, [props, propsExternas, descartadasEfectivasIds]);

  useEffect(() => {
    let cancel = false;
    setZonasCatalogoErr(false);
    api
      .get("/auxiliares/zona")
      .then((r) => {
        if (cancel) return;
        setCatalogoZonas(Array.isArray(r.data?.data) ? r.data.data : []);
      })
      .catch(() => {
        if (cancel) return;
        setCatalogoZonas([]);
        setZonasCatalogoErr(true);
      });
    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    if (!masP) {
      setPoblBuscar("");
      setPoblBuscarRes([]);
      setPoblBuscarLoading(false);
      if (pobBuscarTimerRef.current) {
        clearTimeout(pobBuscarTimerRef.current);
        pobBuscarTimerRef.current = null;
      }
      return;
    }
    if (poblacionesConViv.length > 0) return;
    let cancel = false;
    setPoblacionesConVivErr(false);
    api
      .get("/auxiliares/poblaciones-con-viviendas")
      .then((r) => {
        if (cancel) return;
        setPoblacionesConViv(Array.isArray(r.data?.data) ? r.data.data : []);
      })
      .catch(() => {
        if (cancel) return;
        setPoblacionesConViv([]);
        setPoblacionesConVivErr(true);
      });
    return () => {
      cancel = true;
    };
  }, [masP, poblacionesConViv.length]);

  useEffect(() => {
    if (!masP) return;
    const q = poblBuscar.trim();
    if (q.length < 2) {
      setPoblBuscarRes([]);
      setPoblBuscarLoading(false);
      if (pobBuscarTimerRef.current) {
        clearTimeout(pobBuscarTimerRef.current);
        pobBuscarTimerRef.current = null;
      }
      return;
    }
    if (pobBuscarTimerRef.current) clearTimeout(pobBuscarTimerRef.current);
    setPoblBuscarLoading(true);
    pobBuscarTimerRef.current = setTimeout(() => {
      api
        .get("/auxiliares/poblaciones-todas", { params: { q } })
        .then((r) => {
          setPoblBuscarRes(Array.isArray(r.data?.data) ? r.data.data : []);
        })
        .catch(() => setPoblBuscarRes([]))
        .finally(() => setPoblBuscarLoading(false));
    }, 280);
    return () => {
      if (pobBuscarTimerRef.current) {
        clearTimeout(pobBuscarTimerRef.current);
        pobBuscarTimerRef.current = null;
      }
    };
  }, [masP, poblBuscar]);

  useEffect(() => {
    if (!masT) return;
    if (tiposCatalogo.length > 0) return;
    let cancel = false;
    setTiposCatalogoErr(false);
    api
      .get("/auxiliares/tipo-inmueble")
      .then((r) => {
        if (cancel) return;
        const rows = Array.isArray(r.data?.data) ? r.data.data : [];
        setTiposCatalogo(rows.map((row) => row.nombre).filter(Boolean));
      })
      .catch(() => {
        if (cancel) return;
        setTiposCatalogo([]);
        setTiposCatalogoErr(true);
      });
    return () => {
      cancel = true;
    };
  }, [masT, tiposCatalogo.length]);

  // ============================================================
  // RENDER
  // ============================================================
  if (carg) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: c.bgApp }}><p style={{ color: c.textMuted, fontSize: 13 }}>Cargando...</p></div>;
  if (err) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14, background: c.bgApp, padding: 24 }}>
        <p style={{ color: c.accentRed, fontSize: 13, textAlign: 'center', maxWidth: 420, margin: 0 }}>{err}</p>
        <button
          type="button"
          onClick={() => { setErr(''); setCarg(true); void cargar(); }}
          style={{
            border: `1px solid ${c.border || '#334155'}`,
            background: c.bgPanel || c.bgCard || '#1e293b',
            color: c.text || '#e2e8f0',
            borderRadius: 8,
            padding: '8px 16px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }

  const llamarConAna = async (telefono) => {
    if (!telefono) {
      await dialogs.alert("Este contacto no tiene teléfono");
      return;
    }
    if (!(await dialogs.confirm(`¿Ana llamará ahora a ${nom || telefono}?`))) return;
    try {
      const data = await api.post('/telnyx/llamar-ana', {
        telefonoLead: telefono,
        leadId: lead?.id || null,
        clienteId: cliente?.id || null,
        nombre: nom || null,
        propiedad_ref: lead?.propiedad_ref || null,
        operacion: lead?.operacion || null,
      }).then(r => r.data);
      if (data.ok) {
        await dialogs.alert("🤖 Ana está llamando — la conversación quedará guardada en el historial");
      } else {
        await dialogs.alert("Error: " + data.error);
      }
    } catch (e) {
      await dialogs.alert("Error: " + (e.response?.data?.error || e.message));
    }
  };

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 49px)', overflow: 'hidden', background: c.bgApp }}>

      {/* ========== PANEL IZQUIERDO ========== */}
      <div style={{
        width: '50%', background: c.bgPanel, borderRight: `1px solid ${c.border}`,
        display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0,
      }}>
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>

        {/* CABECERA */}
        <div style={{ padding: '12px 16px 10px', ...sectionDivider }}>

          {returnToOrigen && (() => {
            const esVueltaFrios = /[?&]openFrios=/.test(returnToOrigen);
            const verde = c.accentGreen || "#16a34a";
            return (
            <div style={{ marginBottom: 8 }}>
              <button
                type="button"
                onClick={() => nav(returnToOrigen)}
                title="Volver a la pantalla anterior"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  border: `1px solid ${theme.name === "dark" ? "rgba(22,163,74,0.45)" : "rgba(22,163,74,0.35)"}`,
                  background: theme.name === "dark" ? "rgba(22,163,74,0.14)" : "#f0fdf4",
                  color: verde,
                  borderRadius: 8,
                  padding: "4px 10px",
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                ← {returnToOrigen.startsWith("/tareas")
                  ? "Tareas"
                  : esVueltaFrios
                    ? "Fríos"
                    : "Volver"}
              </button>
            </div>
            );
          })()}

          {/* Fila 1: Nombre + Apellido · Procedencia · Fecha */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <EditableField value={lead.nombre} campo="nombre" editando={editando} setEditando={setEditando} editVal={editVal} setEditVal={setEditVal} onSave={guardarCampoCliente} c={c} fontSize={15} fontWeight={700} label="Nombre" inputPlaceholder="Insertar nombre" width={130} disabled={!puedeModificarContacto} className="ficha-cliente-dato" />
              <EditableField value={lead.apellido || cliente?.apellido} campo="apellido" editando={editando} setEditando={setEditando} editVal={editVal} setEditVal={setEditVal} onSave={guardarCampoCliente} c={c} fontSize={15} fontWeight={700} label="Apellidos" inputPlaceholder="Insertar apellidos" width={350} disabled={!puedeModificarContacto} className="ficha-cliente-dato" />
              <span style={{ fontSize: 10, color: '#475569', whiteSpace: 'nowrap' }}>
                {[fuenteVisibleEnLead(lead.fuente), ff(lead.created_at)].filter(Boolean).join(' · ')}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {/* Botón guardar cliente nuevo */}
              {id === 'nuevo' && (
                <>
                  {previewLeadSuelto && !modalLeadSuelto && (
                    <div style={{
                      marginRight: 8, maxWidth: 280, padding: '6px 10px', borderRadius: 8, fontSize: 11, lineHeight: 1.35,
                      background: theme.name === 'dark' ? 'rgba(59,130,246,0.12)' : '#eff6ff',
                      border: `1px solid ${theme.name === 'dark' ? '#1d4ed880' : '#bfdbfe'}`,
                      color: c.textSecondary,
                    }}>
                      <span style={{ fontWeight: 700, color: c.accentBlue }}>Lead sin ficha</span>
                      {' '}con este teléfono o email:{' '}
                      <button
                        type="button"
                        onClick={() => nav(`/pipeline?openLead=${previewLeadSuelto.id}`)}
                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: c.accentBlue, fontWeight: 600, textDecoration: 'underline', fontSize: 11 }}
                      >
                        {`${previewLeadSuelto.nombre || ''} ${previewLeadSuelto.apellido || ''}`.trim() || `Lead #${previewLeadSuelto.id}`}
                      </button>
                      . Al guardar podrás vincularlo o crear el cliente solo.
                    </div>
                  )}
                  <button onClick={() => crearClienteNuevo()} disabled={guardando} style={{
                  padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
                  background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                  color: '#fff', fontSize: 12, fontWeight: 600,
                  opacity: guardando ? 0.6 : 1,
                }}>
                  {guardando ? 'Guardando...' : '💾 Guardar cliente'}
                </button>
                </>
              )}
              {/* Agente asignado */}
              <div style={{ position: 'relative' }}>
              {editando === 'agente_id' && puedeModificarContacto ? (
                <select
                  autoFocus
                  defaultValue={cliente?.agente_id || ''}
                  onChange={e => {
                    const val = e.target.value || null;
                    const nombreSeleccionado = val ? (agentes.find(a => a.id === val)?.nombre || '') : '';
                    // Actualizar estado local inmediatamente para que se vea sin esperar al cargar()
                    setCliente(prev => prev ? { ...prev, agente_id: val, agente_nombre: nombreSeleccionado } : prev);
                    setEditando(null);
                    guardarCampoCliente('agente_id', val);
                  }}
                  onBlur={() => setEditando(null)}
                  style={{
                    fontSize: 11, fontWeight: 600, color: theme.name === 'dark' ? '#ffffff' : c.accentBlue, background: c.bgInput,
                    border: `1px solid ${c.accentBlue}`, borderRadius: 4, padding: '2px 6px',
                    outline: 'none', fontFamily: 'inherit',
                  }}
                >
                  <option value="">Sin agente</option>
                  {agentes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                </select>
              ) : (
                <span
                  onClick={puedeModificarContacto ? () => setEditando('agente_id') : undefined}
                  style={{
                    fontSize: 11, fontWeight: 600,
                    color: puedeModificarContacto ? (theme.name === 'dark' ? '#ffffff' : c.accentBlue) : c.textMuted,
                    cursor: puedeModificarContacto ? 'pointer' : 'not-allowed',
                    borderBottom: puedeModificarContacto ? `1px dashed ${c.accentBlueBorder}` : 'none',
                    opacity: puedeModificarContacto ? 1 : 0.7,
                  }}
                  title={puedeModificarContacto ? "Clic para cambiar agente" : "No puedes reasignar este contacto (no es de tu cartera)"}
                >
                  🧑‍💼 {cliente?.agente_nombre || lead.agente_nombre || 'Sin agente'}
                </span>
              )}
              </div>{/* fin div agente */}
            </div>{/* fin div flex botón+agente */}
          </div>{/* fin fila 1 */}

          {/* === FILAS 2-4 con anchos fijos alineados === */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}>

            {/* Fila 2: Teléfono · Teléfono 2 · Email · Idioma */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              {/* Teléfono */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: '#ffffff', minWidth: 22 }}>TEL</span>
                <EditableField
                  key={`tel-1-${tel}`}
                  value={tel}
                  campo="telefono"
                  editando={editando}
                  setEditando={setEditando}
                  editVal={editVal}
                  setEditVal={setEditVal}
                  onSave={guardarCampoCliente}
                  c={c}
                  fontSize={11}
                  fontWeight={500}
                  label="—"
                  inputPlaceholder="Insertar teléfono"
                  width={120}
                  alwaysEditable
                  disabled={!puedeModificarContacto}
                  className="ficha-cliente-dato"
                />
                <span
                  title={tel ? "Llamar por Telnyx" : "Sin teléfono"}
                  onClick={() => tel && llamarCliente(tel)}
                  style={{
                    cursor: tel ? 'pointer' : 'default',
                    fontSize: 15,
                    lineHeight: 1,
                    marginLeft: 2,
                    color: tel ? '#ff4d7a' : c.textMuted,
                    userSelect: 'none',
                  }}
                >
                  ✆
                </span>
              </div>
              {/* Teléfono 2 */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: '#ffffff', minWidth: 28 }}>TEL 2</span>
                <EditableField
                  key={`tel-2-${tel2}`}
                  value={tel2}
                  campo="telefono_secundario"
                  editando={editando}
                  setEditando={setEditando}
                  editVal={editVal}
                  setEditVal={setEditVal}
                  onSave={guardarCampoCliente}
                  c={c}
                  fontSize={11}
                  fontWeight={500}
                  label="—"
                  inputPlaceholder="Insertar teléfono 2"
                  width={118}
                  alwaysEditable
                  disabled={!puedeModificarContacto}
                  className="ficha-cliente-dato"
                />
                <span
                  title={tel2 ? "Llamar por Telnyx" : "Sin teléfono"}
                  onClick={() => tel2 && llamarCliente(tel2)}
                  style={{
                    cursor: tel2 ? 'pointer' : 'default',
                    fontSize: 15,
                    lineHeight: 1,
                    marginLeft: 2,
                    color: tel2 ? '#ff4d7a' : c.textMuted,
                    userSelect: 'none',
                  }}
                >
                  ✆
                </span>
              </div>
              {/* Email */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: '#ffffff', minWidth: 24 }}>Mail</span>
                <EditableField
                  key={`eml-${eml}`}
                  value={eml}
                  campo="email"
                  editando={editando}
                  setEditando={setEditando}
                  editVal={editVal}
                  setEditVal={setEditVal}
                  onSave={guardarCampoCliente}
                  c={c}
                  fontSize={11}
                  fontWeight={500}
                  label="—"
                  inputPlaceholder="Insertar email"
                  width={246}
                  alwaysEditable
                  disabled={!puedeModificarContacto}
                  className="ficha-cliente-dato"
                />
                <span
                  title={eml ? "Abrir email" : "Sin email"}
                  onClick={() => eml && setModalEmail(true)}
                  style={{
                    cursor: eml ? 'pointer' : 'default',
                    fontSize: 15,
                    lineHeight: 1,
                    marginLeft: 2,
                    color: eml ? '#e5eefc' : c.textMuted,
                    userSelect: 'none',
                  }}
                >
                  ✉
                </span>
              </div>
              {/* Idioma — tamaño fijo al final */}
              <div style={{ flexShrink: 0 }}>
                {editando === 'idioma' && puedeModificarContacto ? (
                  <select autoFocus value={lead.idioma || cliente?.idioma || 'es'}
                    onChange={e => guardarCampoCliente('idioma', e.target.value)}
                    onBlur={() => setEditando(null)}
                    style={{ fontSize: 10, fontFamily: 'inherit' }}
                  >
                    <option value="es">Español</option><option value="en">English</option>
                    <option value="de">Deutsch</option><option value="fr">Français</option>
                    <option value="nl">Nederlands</option><option value="ru">Русский</option>
                  </select>
                ) : (
                  <span
                    onClick={puedeModificarContacto ? () => setEditando('idioma') : undefined}
                    title={puedeModificarContacto ? "Clic para cambiar idioma" : "No puedes modificar este contacto (no es de tu cartera)"}
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 6px',
                      borderRadius: 4, fontSize: 10, fontWeight: 500, cursor: puedeModificarContacto ? 'pointer' : 'not-allowed',
                      background: c.accentBlueLight, color: theme.name === 'dark' ? '#ffffff' : c.accentBlue, border: `1px solid ${c.accentBlueBorder}`,
                      opacity: puedeModificarContacto ? 1 : 0.7,
                    }}>
                    <svg width={9} height={9} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10A15.3 15.3 0 0112 2z" /></svg>
                    {lead.idioma === "es" ? "ES" : lead.idioma === "en" ? "EN" : lead.idioma === "de" ? "DE" : lead.idioma === "fr" ? "FR" : lead.idioma === "nl" ? "NL" : lead.idioma === "ru" ? "RU" : (lead.idioma || "ES").toUpperCase()}
                  </span>
                )}
              </div>
            </div>

            {/* Fila 3: DNI + Dirección */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                <span style={{ fontSize: 10, color: c.textPrimary, fontWeight: 500, whiteSpace: 'nowrap' }}>DNI:</span>
                <EditableField value={cliente?.dni} campo="dni" editando={editando} setEditando={setEditando} editVal={editVal} setEditVal={setEditVal} onSave={guardarCampoCliente} c={c} fontSize={11} fontWeight={500} label="—" inputPlaceholder="Insertar DNI" width={80} disabled={!puedeModificarContacto} className="ficha-cliente-dato" />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ fontSize: 10, color: c.textPrimary, fontWeight: 500, whiteSpace: 'nowrap' }}>Dirección:</span>
                <EditableField value={cliente?.direccion} campo="direccion" editando={editando} setEditando={setEditando} editVal={editVal} setEditVal={setEditVal} onSave={guardarCampoCliente} c={c} fontSize={11} fontWeight={500} label="—" inputPlaceholder="Insertar dirección" width={326} addressAutocomplete placesLocalityContext={placesClienteContext} disabled={!puedeModificarContacto} className="ficha-cliente-dato" />
              </div>
            </div>

            {/* Fila 4: Provincia · Población (flex:1) · País */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                <span style={{ fontSize: 10, color: c.textPrimary, fontWeight: 500, whiteSpace: 'nowrap' }}>Provincia:</span>
                <select value={cliente?.provincia || ''}
                  disabled={!puedeModificarContacto}
                  title={!puedeModificarContacto ? 'No puedes modificar este contacto (no es de tu cartera)' : undefined}
                  onChange={async e => {
                    const prov = e.target.value;
                    guardarCampoCliente('provincia', prov);
                    guardarCampoCliente('poblacion', '');
                    setPoblacionesCliente([]);
                    if (prov) {
                      const provObj = PROVINCIAS_ES.find(p => p.nombre === prov);
                      if (provObj) {
                        try { const r = await api.get(`/auxiliares/poblaciones/${provObj.id}`); setPoblacionesCliente(r.data.data || []); } catch(e) {}
                      }
                    }
                  }}
                  className="ficha-cliente-dato"
                  style={{ fontSize: 11, fontFamily: 'inherit', width: 120 }}
                >
                  <option value="">— Provincia</option>
                  {PROVINCIAS_ES.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ fontSize: 10, color: c.textPrimary, fontWeight: 500, whiteSpace: 'nowrap' }}>Población:</span>
                {poblacionesCliente.length > 0 ? (
                  <select value={cliente?.poblacion || ''}
                    disabled={!puedeModificarContacto}
                    title={!puedeModificarContacto ? 'No puedes modificar este contacto (no es de tu cartera)' : undefined}
                    onChange={e => guardarCampoCliente('poblacion', e.target.value)}
                    className="ficha-cliente-dato"
                    style={{ fontSize: 11, fontFamily: 'inherit', width: 130 }}
                  >
                    <option value="">— Población</option>
                    {poblacionesCliente.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
                  </select>
                ) : (
                  <EditableField value={cliente?.poblacion} campo="poblacion" editando={editando} setEditando={setEditando} editVal={editVal} setEditVal={setEditVal} onSave={guardarCampoCliente} c={c} fontSize={11} fontWeight={500} label="—" inputPlaceholder="Población" width={130} disabled={!puedeModificarContacto} className="ficha-cliente-dato" />
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                <span style={{ fontSize: 10, color: c.textPrimary, fontWeight: 500, whiteSpace: 'nowrap' }}>País:</span>
                <select value={cliente?.pais || ''}
                  disabled={!puedeModificarContacto}
                  title={!puedeModificarContacto ? 'No puedes modificar este contacto (no es de tu cartera)' : undefined}
                  onChange={e => guardarCampoCliente('pais', e.target.value)}
                  className="ficha-cliente-dato"
                  style={{ fontSize: 11, fontFamily: 'inherit', width: 100 }}
                >
                  <option value="">— País</option>
                  {PAISES_COMUNES.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
            </div>

          </div>{/* fin bloque justificado */}
        </div>

        <div style={{ padding: '4px 16px 6px', ...sectionDivider }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 }}>
            <div style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em', color: theme.name === 'dark' ? c.textPrimary : '#1d4ed8' }}>
              Tarea vigente
            </div>
            {leadParaArchivo && (
              <LeadArchivoMenu
                lead={leadParaArchivo}
                isDark={theme.name === 'dark'}
                c={c}
                onArchivado={async () => {
                  await cargar();
                  await recargarTareaHistorialFlow();
                }}
              />
            )}
          </div>
          <TaskCurrentCard
            task={tareaVigente}
            leadEtapa={leadEmbudoActivo?.etapa}
            c={c}
            isDark={theme.name === 'dark'}
            onOpen={abrirTareaVigente}
            variant="leadModal"
          />
        </div>

        {/* DEMANDAS */}
        <div style={{ padding: '4px 16px 6px', ...sectionDivider }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em', color: theme.name === 'dark' ? c.textPrimary : '#1d4ed8' }}>Demandas</div>
              <button onClick={crearDemanda} title="Nueva demanda" style={{
                padding: '2px 8px', borderRadius: 4, border: `1px solid ${c.accentBlueBorder}`,
                background: c.accentBlueLight, color: theme.name === 'dark' ? '#ffffff' : c.accentBlue, fontSize: 11, fontWeight: 600,
                display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer',
              }}>+ Demanda</button>
            </div>
            {guardando && <span style={{ fontSize: 9, color: c.accentOrange, fontWeight: 500 }}>💾 Guardando...</span>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {demandas.map(d => (
              <button key={d.id} onClick={() => handleCambioDemanda(d)} style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4, padding: '5px 8px', borderRadius: 6,
                width: '100%', textAlign: 'left', cursor: 'pointer', transition: 'all 0.15s',
                border: `1px solid ${demAct?.id === d.id ? c.demandaActiveBorder : c.demandaInactiveBorder}`,
                background: demAct?.id === d.id ? c.demandaActiveBg : c.demandaInactiveBg,
              }}>
                {/* Fila 1: icono + nombre + operacion */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%' }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    background: d.operacion === "alquiler" ? c.accentPinkLight : c.accentGreenLight,
                  }}>
                    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke={d.operacion === "alquiler" ? c.accentPink : c.accentGreenDark} strokeWidth="2" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
                  </div>
                  <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: c.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.nombre}</div>
                    {editando === `demanda_${d.id}` ? (
                      <input
                        autoFocus
                        value={editVal}
                        onClick={e => e.stopPropagation()}
                        onChange={e => setEditVal(e.target.value)}
                        onBlur={() => {
                          if (editVal && editVal !== d.nombre) {
                            api.patch(`/demandas/${d.id}`, { nombre: editVal }).then(() => {
                              setDemandas(prev => prev.map(x => x.id === d.id ? { ...x, nombre: editVal } : x));
                              if (demAct?.id === d.id) setDemAct(prev => ({ ...prev, nombre: editVal }));
                            }).catch(err => console.error(err));
                          }
                          setEditando(null);
                        }}
                        onKeyDown={e => {
                          if (e.key === 'Enter') { e.target.blur(); }
                          if (e.key === 'Escape') { setEditando(null); }
                        }}
                        style={{
                          fontSize: 11, fontWeight: 600, color: c.textPrimary, background: c.bgInput,
                          border: `1px solid ${c.accentBlue}`, borderRadius: 4, padding: '1px 6px',
                          outline: 'none', fontFamily: 'inherit', width: 140,
                        }}
                      />
                    ) : (
                      <span onClick={e => {
                        e.stopPropagation();
                        setEditando(`demanda_${d.id}`);
                        setEditVal(d.nombre);
                      }} style={{ cursor: 'pointer', flexShrink: 0, display: 'flex', alignItems: 'center' }} title="Editar nombre">
                        <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke={c.accentOrange} strokeWidth="2.5" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                      </span>
                    )}
                  </div>
                  <span style={{
                    padding: '2px 6px', borderRadius: 4, fontSize: 10, fontWeight: 600, flexShrink: 0,
                    background: d.operacion === "alquiler" ? c.accentPinkLight : c.accentGreenLight,
                    color: d.operacion === "alquiler" ? c.accentPink : c.accentGreenDark,
                  }}>{d.operacion === "alquiler" ? "Alq" : "Venta"}</span>
                  {esDemandaCancelada(d) && (
                    <span style={{
                      padding: '2px 6px', borderRadius: 4, fontSize: 10, fontWeight: 700, flexShrink: 0,
                      background: 'rgba(220,38,38,0.15)', color: '#dc2626',
                      border: '1px solid rgba(220,38,38,0.35)',
                    }} title={d.notas || 'Demanda cancelada (compra)'}>Cancelada</span>
                  )}
                  {String(d.estado || '').toLowerCase() === 'reabierta' && (
                    <span style={{
                      padding: '2px 6px', borderRadius: 4, fontSize: 10, fontWeight: 700, flexShrink: 0,
                      background: 'rgba(22,163,74,0.14)', color: '#15803d',
                      border: '1px solid rgba(22,163,74,0.4)',
                    }} title={d.notas || 'Demanda reabierta por nuevo lead'}>Reabierta</span>
                  )}
                </div>
                {/* Fila 2: historial de refs (primer lead → actual), dedupe por ref */}
                {(() => {
                  const seen = new Set();
                  const refsDemanda = (leadsV || [])
                    .filter((l) => l.demanda_id === d.id && l.propiedad_ref)
                    .sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0))
                    .filter((l) => {
                      const k = String(l.propiedad_ref || "").trim().toUpperCase();
                      if (!k || seen.has(k)) return false;
                      seen.add(k);
                      return true;
                    });
                  if (!refsDemanda.length) return null;
                  return (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, width: '100%', paddingLeft: 34 }}>
                    {refsDemanda.map(l => {
                      const proc = l.fuente || l.portal_origen || '';
                      const procBg = proc ? colorHexProcedencia(proc) : '#64748b';
                      const procTxt = textOnSolidColor(procBg);
                      const tagStyle = { fontSize: 11, fontWeight: 700, padding: '2px 7px', whiteSpace: 'nowrap', border: 'none', cursor: 'pointer' };
                      return (
                        <span key={l.id} onClick={e => { e.stopPropagation(); abrirFichaPorRef(l.propiedad_ref); }} style={{ display: 'flex', gap: 0, alignItems: 'center' }}>
                          {proc
                            ? <><span style={{ ...tagStyle, background: procBg, color: procTxt, borderRadius: '5px 0 0 5px' }}>{proc}</span>
                                <span style={{ ...tagStyle, background: theme.name === 'dark' ? '#334155' : '#e2e8f0', color: theme.name === 'dark' ? '#e2e8f0' : '#334155', borderRadius: '0 5px 5px 0' }}>{l.propiedad_ref}</span></>
                            : <span style={{ ...tagStyle, background: theme.name === 'dark' ? '#334155' : '#e2e8f0', color: theme.name === 'dark' ? '#e2e8f0' : '#334155', borderRadius: 5 }}>{l.propiedad_ref}</span>
                          }
                        </span>
                      );
                    })}
                  </div>
                  );
                })()}
              </button>
            ))}
          </div>
         
        </div>

        {/* CRITERIOS DE BÚSQUEDA */}
        <div style={{ padding: '8px 16px', ...sectionDivider }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em', color: theme.name === 'dark' ? c.textPrimary : '#1d4ed8' }}>Criterios de búsqueda</div>
            <button
              type="button"
              title="Limpiar todos los criterios"
              onClick={() => {
                userModified.current = true;
                setCr({
                  tipos: [], op: "", pMin: "", pMax: "", hMin: "", bMin: "", m2Min: "", m2Max: "",
                  pobls: [], zonas: [], zonasExcl: [], extras: [], extrasExcl: [], equip: [], sinAsc: false, plMax: 2,
                  geoLat: null, geoLng: null, geoRadioM: null,
                  m2Parcela: "", orientacion: [], orientacionExcl: [], jardin: false, anoConstruccion: "",
                  estadoInmueble: [], estadoInmuebleExcl: [], vpo: false, vpoExcl: false, calEnergetica: "", plantas: [], plantasExcl: [],
                  aireAc: false, calefaccion: false, padel: false, padelExcl: false, tenis: false, tenisExcl: false,
                  puntoRecarga: false, adaptado: false, salidaHumos: false,
                  distanciaMar: "", urbanizacionId: "",
                });
              }}
              style={{
                fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, cursor: 'pointer',
                border: `1px solid ${c.border}`, background: 'transparent',
                color: theme.name === 'dark' ? c.textPrimary : '#1d4ed8', display: 'flex', alignItems: 'center', gap: 4,
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = c.accentRed; e.currentTarget.style.color = c.accentRed; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = c.border; e.currentTarget.style.color = theme.name === 'dark' ? c.textPrimary : '#1d4ed8'; }}
            >
              ✕ Limpiar
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>

            {/* Operación + Tipo */}
            <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
              <div style={{ flexShrink: 0 }}>
                <div style={sectionLabel}>Operación</div>
                <div style={{ display: 'flex', gap: 4 }}>{OPS.map(o => <Chip key={o} label={o} active={cr.op.toLowerCase() === o.toLowerCase()} onClick={() => s1("op", o)} theme={theme} />)}</div>
              </div>
              <div style={{ borderLeft: `1px solid ${c.border}`, paddingLeft: 16, flex: 1 }}>
                <div style={sectionLabel}>Tipo</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {TIPOS_PRINCIPALES.map(t => <Chip key={t} label={t} active={cr.tipos.includes(t)} onClick={() => tArr("tipos", t)} theme={theme} />)}
                  {extraTiposEnCabecera.map((t) => (
                    <Chip key={`cab-t-${normNombrePobl(t)}`} label={t} active={cr.tipos.includes(t)} onClick={() => tArr("tipos", t)} theme={theme} />
                  ))}
                  <button type="button" onClick={() => setMasT(!masT)} style={{
                    padding: '4px 10px', fontSize: 11, fontWeight: 500, borderRadius: 6, cursor: 'pointer',
                    border: `1px solid ${masT ? c.accentBlueBorder : c.border}`,
                    background: masT ? c.accentBlueLight : c.chipBg,
                    color: masT ? c.accentBlue : c.textMuted,
                    transition: 'all 0.15s',
                  }}>{masT ? "▾ Menos" : "▸ Más"}</button>
                </div>
                {masT && (
                  <div style={{ marginTop: 8 }}>
                    {tiposCatalogoErr && (
                      <span style={{ fontSize: 10, color: c.textMuted, display: "block", marginBottom: 6 }}>
                        No se pudo cargar el catálogo de tipos.
                      </span>
                    )}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                      {tiposMasLista.length === 0 && !tiposCatalogoErr && (
                        <span style={{ fontSize: 10, color: c.textMuted }}>No hay más tipos en el catálogo aparte de los de la fila superior.</span>
                      )}
                      {tiposMasLista.map((t) => (
                        <Chip key={t} label={t} active={cr.tipos.includes(t)} onClick={() => tArr("tipos", t)} theme={theme} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
                  

            {/* Precio + Habitaciones + Baños en una línea */}
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
              <div>
                <div style={sectionLabel}>Precio mín.</div>
                <input type="text" value={cr.pMin} onChange={e => sPrecioCriterio("pMin", e.target.value, false)} className={classInputCriterio(cr.pMin)} style={estiloInputCriterio(cr.pMin, { padding: '5px 8px' })} placeholder="—"
                  onFocus={onFocusInputCriterio}
                  onBlur={e => { onBlurInputCriterio(e); sPrecioCriterio("pMin", e.target.value, true); }} />
              </div>
              <div>
                <div style={sectionLabel}>Prec. máx.</div>
                <input type="text" value={cr.pMax} onChange={e => sPrecioCriterio("pMax", e.target.value, false)} className={classInputCriterio(cr.pMax)} style={estiloInputCriterio(cr.pMax, { padding: '5px 8px' })} placeholder="—"
                  onFocus={onFocusInputCriterio}
                  onBlur={e => { onBlurInputCriterio(e); sPrecioCriterio("pMax", e.target.value, true); }} />
              </div>
              <div>
                <div style={sectionLabel}>Hab. mín.</div>
                <div style={{ display: 'flex', gap: 3 }}>{HABS.map(h => <Chip key={h} label={h} small active={cr.hMin === h} onClick={() => s1("hMin", h)} theme={theme} />)}</div>
              </div>
              <div>
                <div style={sectionLabel}>Baños mín.</div>
                <div style={{ display: 'flex', gap: 3 }}>{BANOS.map(b => <Chip key={b} label={b} small active={cr.bMin === b} onClick={() => s1("bMin", b)} theme={theme} />)}</div>
              </div>
            </div>

            {/* Superficie (alineado debajo de Precio) */}
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
              <div>
                <div style={sectionLabel}>m² mín.</div>
                <input type="text" value={cr.m2Min} onChange={e => sF("m2Min", e.target.value)} className={classInputCriterio(cr.m2Min)} style={estiloInputCriterio(cr.m2Min, { padding: '5px 8px' })} placeholder="—"
                  onFocus={onFocusInputCriterio}
                  onBlur={onBlurInputCriterio} />
              </div>
              <div>
                <div style={sectionLabel}>m² máx.</div>
                <input type="text" value={cr.m2Max} onChange={e => sF("m2Max", e.target.value)} className={classInputCriterio(cr.m2Max)} style={estiloInputCriterio(cr.m2Max, { padding: '5px 8px' })} placeholder="—"
                  onFocus={onFocusInputCriterio}
                  onBlur={onBlurInputCriterio} />
              </div>
              <div />
              <div />
            </div>

            {/* Población */}
            <div>
              <div style={sectionLabel}>Población</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {POBLS_PRINCIPALES.map(p => <Chip key={p} label={p} active={cr.pobls.includes(p)} onClick={() => tArr("pobls", p)} theme={theme} />)}
                {extraPoblsEnCabecera.map((p) => (
                  <Chip key={`cab-p-${normNombrePobl(p)}`} label={p} active={cr.pobls.includes(p)} onClick={() => tArr("pobls", p)} theme={theme} />
                ))}
                <button type="button" onClick={() => setMasP(!masP)} style={{
                  padding: '4px 10px', fontSize: 11, fontWeight: 500, borderRadius: 6, cursor: 'pointer',
                  border: `1px solid ${masP ? c.accentBlueBorder : c.border}`,
                  background: masP ? c.accentBlueLight : c.chipBg,
                  color: masP ? c.accentBlue : c.textMuted,
                  transition: 'all 0.15s',
                }}>{masP ? "▾ Menos" : "▸ Más"}</button>
              </div>
              {masP && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ position: "relative", width: "100%", maxWidth: 340 }}>
                    <input
                      type="text"
                      value={poblBuscar}
                      onChange={(e) => setPoblBuscar(e.target.value)}
                      placeholder="Escribe al menos 2 letras…"
                      autoComplete="off"
                      style={{ ...inputStyle, padding: "6px 10px", width: "100%" }}
                      onFocus={(e) => { e.target.style.borderColor = c.borderFocus; }}
                      onBlur={(e) => { e.target.style.borderColor = c.border; }}
                    />
                    {poblBuscarLoading && (
                      <span style={{ fontSize: 10, color: c.textMuted, marginTop: 4, display: "block" }}>Buscando…</span>
                    )}
                    {poblBuscarRes.length > 0 && (
                      <ul
                        style={{
                          position: "absolute",
                          left: 0,
                          right: 0,
                          top: "100%",
                          marginTop: 4,
                          maxHeight: 220,
                          overflowY: "auto",
                          background: c.bgCard || c.bgInput,
                          border: `1px solid ${c.border}`,
                          borderRadius: 6,
                          listStyle: "none",
                          padding: 4,
                          margin: 0,
                          zIndex: 50,
                          boxShadow: theme.name === "dark" ? "0 8px 24px rgba(0,0,0,.45)" : "0 8px 24px rgba(0,0,0,.1)",
                        }}
                      >
                        {poblBuscarRes.map((row) => (
                          <li key={row.id}>
                            <button
                              type="button"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                tArr("pobls", row.nombre);
                                setPoblBuscar("");
                                setPoblBuscarRes([]);
                              }}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                padding: "6px 8px",
                                fontSize: 12,
                                border: "none",
                                background: "transparent",
                                color: c.textPrimary,
                                cursor: "pointer",
                                borderRadius: 4,
                              }}
                            >
                              {row.nombre}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  {poblacionesConVivErr && (
                    <span style={{ fontSize: 10, color: c.textMuted, display: "block", marginBottom: 6 }}>
                      No se pudo cargar la lista de poblaciones con viviendas dadas de alta.
                    </span>
                  )}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {poblsMasLista.length === 0 && !poblacionesConVivErr && (
                      <span style={{ fontSize: 10, color: c.textMuted }}>No hay más poblaciones en cartera aparte de las de la fila superior.</span>
                    )}
                    {poblsMasLista.map((p) => (
                      <Chip key={p} label={p} active={cr.pobls.includes(p)} onClick={() => tArr("pobls", p)} theme={theme} />
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Zona */}
            <div>
              <div style={sectionLabel}>Zona</div>
              {geoMapaActivo ? (
                <div style={{ fontSize: 9, color: "#4f46e5", fontWeight: 600, marginBottom: 4 }}>
                  Mapa {(Number(cr.geoRadioM) / 1000).toFixed(1)} km
                </div>
              ) : null}
              {zonasCatalogoErr ? (
                <span style={{ fontSize: 10, color: c.textMuted, display: "block", marginBottom: 4 }}>
                  No se pudo cargar el catálogo de zonas.
                </span>
              ) : null}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center" }}>
                {zonasFilaPrincipal.length === 0 && zonasResto.length === 0 && extraZonasEnCabecera.length === 0 && !zonasCatalogoErr ? (
                  <span style={{ fontSize: 10, color: c.textMuted }}>
                    {cr.pobls?.length ? "Sin zonas para esta población en configuración." : "Selecciona población para ver zonas."}
                  </span>
                ) : null}
                {zonasFilaPrincipal.map((z) => (
                  <Chip
                    key={z}
                    label={z}
                    small
                    active={(cr.zonas || []).includes(z)}
                    excluded={(cr.zonasExcl || []).includes(z)}
                    onClick={() => onZonaChipPress(z)}
                    theme={theme}
                  />
                ))}
                {extraZonasEnCabecera.map((z) => (
                  <Chip
                    key={`extra-z-${z}`}
                    label={z}
                    small
                    active={(cr.zonas || []).includes(z)}
                    excluded={(cr.zonasExcl || []).includes(z)}
                    onClick={() => onZonaChipPress(z)}
                    theme={theme}
                  />
                ))}
                <button
                  type="button"
                  title={
                    cr.pobls?.length
                      ? geoMapaActivo
                        ? "Editar zona en mapa"
                        : "Elegir zona en mapa (pin + radio)"
                      : "Selecciona al menos una población"
                  }
                  disabled={!(cr.pobls || []).length}
                  onClick={() => setModalZonaMapa(true)}
                  style={{
                    padding: "2px 10px",
                    fontSize: 10,
                    fontWeight: 700,
                    borderRadius: 6,
                    border: `1px solid ${geoMapaActivo ? c.chipActiveBorder : c.border}`,
                    background: geoMapaActivo ? c.chipActiveBg : c.chipBg,
                    color: geoMapaActivo ? c.chipActiveText : c.chipText,
                    cursor: (cr.pobls || []).length ? "pointer" : "not-allowed",
                    opacity: (cr.pobls || []).length ? 1 : 0.45,
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                  }}
                >
                  Elegir
                </button>
                {zonasRestoLista.length > 0 || (zonasExpandidas && zonasResto.length > 0) ? (
                  <button
                    type="button"
                    onClick={() => setZonasExpandidas((v) => !v)}
                    style={{
                      padding: "2px 10px",
                      fontSize: 10,
                      fontWeight: 700,
                      borderRadius: 6,
                      border: `1px dashed ${c.border}`,
                      background: "transparent",
                      color: theme.name === "dark" ? c.textPrimary : "#1d4ed8",
                      cursor: "pointer",
                      lineHeight: 1.4,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {zonasExpandidas ? "−Zonas" : "+Zonas"}
                  </button>
                ) : null}
              </div>
              {zonasExpandidas && zonasRestoLista.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6 }}>
                  {zonasRestoLista.map((z) => (
                    <Chip
                      key={z}
                      label={z}
                      small
                      active={(cr.zonas || []).includes(z)}
                      excluded={(cr.zonasExcl || []).includes(z)}
                      onClick={() => onZonaChipPress(z)}
                      theme={theme}
                    />
                  ))}
                </div>
              ) : null}
            </div>

            {/* Extras */}
            <div>
              <div style={sectionLabel}>Extras</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
                {EXTRAS.map((e) => {
                  const inclExcl = e.k === "piscina" || e.k === "amueblado";
                  if (inclExcl) {
                    return (
                      <Chip
                        key={e.k}
                        label={e.l}
                        active={cr.extras.includes(e.k)}
                        excluded={(cr.extrasExcl || []).includes(e.k)}
                        onClick={() => onExtraInclExclChip(e.k)}
                        title="Clic: exigir · Doble clic: excluir"
                        theme={theme}
                      />
                    );
                  }
                  return <Chip key={e.k} label={e.l} active={cr.extras.includes(e.k)} onClick={() => tArr("extras", e.k)} theme={theme} />;
                })}
                <Chip label="🛗 Sin ascensor hasta planta" active={cr.sinAsc} onClick={() => sF("sinAsc", !cr.sinAsc)} theme={theme} />
                {cr.sinAsc && <div style={{
                  display: 'flex', alignItems: 'center', borderRadius: 6, overflow: 'hidden',
                  border: `1px solid ${c.chipActiveBorder === 'transparent' ? c.chipActiveBg : c.chipActiveBorder}`,
                  background: c.chipActiveBg,
                }}>
                  <button onClick={() => sF("plMax", Math.max(0, cr.plMax - 1))} style={{
                    width: 24, height: 24, border: 'none', background: 'transparent', cursor: 'pointer',
                    color: c.chipActiveText, fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>▾</button>
                  <span style={{ width: 16, textAlign: 'center', fontSize: 11, fontWeight: 700, color: c.chipActiveText }}>{cr.plMax}</span>
                  <button onClick={() => sF("plMax", Math.min(10, cr.plMax + 1))} style={{
                    width: 24, height: 24, border: 'none', background: 'transparent', cursor: 'pointer',
                    color: c.chipActiveText, fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>▴</button>
                </div>}
              </div>
            </div>

            {/* + Más criterios */}
            <button onClick={() => setMasC(!masC)} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
              width: '100%', padding: '6px 0', borderRadius: 6, fontSize: 11, fontWeight: 700,
              border: masCriteriosConDatos || masC
                ? `1px solid ${c.chipActiveBorder === 'transparent' ? c.chipActiveBg : c.chipActiveBorder}`
                : `1px dashed ${c.border}`,
              background: masCriteriosConDatos || masC ? c.chipActiveBg : 'transparent',
              color: masCriteriosConDatos || masC ? c.chipActiveText : (theme.name === 'dark' ? c.textPrimary : '#1d4ed8'),
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}>
              <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{ transform: masC ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}><polyline points="6 9 12 15 18 9" /></svg>
              {masC ? "Menos criterios" : (masCriteriosConDatos ? "Más criterios (activos)" : "+ Más criterios")}
            </button>
            {/* Criterios activos fuera del panel: visibles al colapsar, como +Poblaciones / +Zonas */}
            {!masC && masCriteriosConDatos ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 4 }}>
                {criterioCampoRelleno(cr.m2Parcela) ? (
                  <Chip
                    label={`m² Parcela ≥${cr.m2Parcela}`}
                    small
                    active
                    onClick={() => { userModified.current = true; setCr((p) => ({ ...p, m2Parcela: "" })); }}
                    theme={theme}
                  />
                ) : null}
                {criterioCampoRelleno(cr.anoConstruccion) ? (
                  <Chip
                    label={`Año desde ${cr.anoConstruccion}`}
                    small
                    active
                    onClick={() => { userModified.current = true; setCr((p) => ({ ...p, anoConstruccion: "" })); }}
                    theme={theme}
                  />
                ) : null}
                {criterioCampoRelleno(cr.distanciaMar) ? (
                  <Chip
                    label={`Dist. mar ≤${cr.distanciaMar} m`}
                    small
                    active
                    onClick={() => { userModified.current = true; setCr((p) => ({ ...p, distanciaMar: "" })); }}
                    theme={theme}
                  />
                ) : null}
                {criterioCampoRelleno(cr.calEnergetica) ? (
                  <Chip
                    label={`Cal. energética ${cr.calEnergetica}`}
                    small
                    active
                    onClick={() => { userModified.current = true; setCr((p) => ({ ...p, calEnergetica: "" })); }}
                    theme={theme}
                  />
                ) : null}
                {[...(cr.orientacion || []), ...(cr.orientacionExcl || []).filter((o) => !(cr.orientacion || []).includes(o))].map((o) => (
                  <Chip
                    key={`mc-ori-${o}`}
                    label={`Orientación ${o}`}
                    small
                    active={(cr.orientacion || []).includes(o)}
                    excluded={(cr.orientacionExcl || []).includes(o)}
                    onClick={() => onArrayInclExclChip("orientacion", "orientacionExcl", o)}
                    theme={theme}
                  />
                ))}
                {[...(cr.estadoInmueble || []), ...(cr.estadoInmuebleExcl || []).filter((e) => !(cr.estadoInmueble || []).includes(e))].map((e) => (
                  <Chip
                    key={`mc-est-${e}`}
                    label={`Estado ${e}`}
                    small
                    active={(cr.estadoInmueble || []).includes(e)}
                    excluded={(cr.estadoInmuebleExcl || []).includes(e)}
                    onClick={() => onArrayInclExclChip("estadoInmueble", "estadoInmuebleExcl", e)}
                    theme={theme}
                  />
                ))}
                {[...(cr.plantas || []), ...(cr.plantasExcl || []).filter((pl) => !(cr.plantas || []).includes(pl))].map((pl) => (
                  <Chip
                    key={`mc-pl-${pl}`}
                    label={`Planta ${pl}`}
                    small
                    active={(cr.plantas || []).includes(pl)}
                    excluded={(cr.plantasExcl || []).includes(pl)}
                    onClick={() => onArrayInclExclChip("plantas", "plantasExcl", pl)}
                    theme={theme}
                  />
                ))}
                {cr.jardin ? (
                  <Chip label="🌿 Jardín" small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, jardin: false })); }} theme={theme} />
                ) : null}
                {(cr.vpo || cr.vpoExcl) ? (
                  <Chip label="🏗️ VPO" small active={!!cr.vpo} excluded={!!cr.vpoExcl} onClick={() => onBoolTriChip("vpo", "vpoExcl")} theme={theme} />
                ) : null}
                {cr.aireAc ? (
                  <Chip label="❄️ A.A." small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, aireAc: false })); }} theme={theme} />
                ) : null}
                {cr.calefaccion ? (
                  <Chip label="🔥 Calefacción" small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, calefaccion: false })); }} theme={theme} />
                ) : null}
                {(cr.padel || cr.padelExcl) ? (
                  <Chip label="🏸 Pista Pádel" small active={!!cr.padel} excluded={!!cr.padelExcl} onClick={() => onBoolTriChip("padel", "padelExcl")} theme={theme} />
                ) : null}
                {(cr.tenis || cr.tenisExcl) ? (
                  <Chip label="🎾 Pista Tenis" small active={!!cr.tenis} excluded={!!cr.tenisExcl} onClick={() => onBoolTriChip("tenis", "tenisExcl")} theme={theme} />
                ) : null}
                {cr.puntoRecarga ? (
                  <Chip label="🔌 Punto Recarga" small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, puntoRecarga: false })); }} theme={theme} />
                ) : null}
                {cr.adaptado ? (
                  <Chip label="♿ Adaptado" small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, adaptado: false })); }} theme={theme} />
                ) : null}
                {cr.salidaHumos ? (
                  <Chip label="💨 Salida Humos" small active onClick={() => { userModified.current = true; setCr((p) => ({ ...p, salidaHumos: false })); }} theme={theme} />
                ) : null}
                {(cr.equip || []).map((i) => (
                  <Chip key={`mc-eq-${i}`} label={`Equip. ${i}`} small active onClick={() => tArr("equip", i)} theme={theme} />
                ))}
              </div>
            ) : null}
            {masC && <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>

              {/* Superficie parcela */}
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
                <div>
                  <div style={sectionLabel}>m² Parcela mín.</div>
                  <input type="text" value={cr.m2Parcela} onChange={e => sF("m2Parcela", e.target.value)} className={classInputCriterio(cr.m2Parcela)} style={estiloInputCriterio(cr.m2Parcela, { padding: '5px 8px' })} placeholder="—"
                    onFocus={onFocusInputCriterio}
                    onBlur={onBlurInputCriterio} />
                </div>
                <div>
                  <div style={sectionLabel}>Año construido desde</div>
                  <input type="text" value={cr.anoConstruccion} onChange={e => sF("anoConstruccion", e.target.value)} className={classInputCriterio(cr.anoConstruccion)} style={estiloInputCriterio(cr.anoConstruccion, { padding: '5px 8px' })} placeholder="Ej: 2000"
                    onFocus={onFocusInputCriterio}
                    onBlur={onBlurInputCriterio} />
                </div>
                <div>
                  <div style={sectionLabel}>Dist. mar máx. (m)</div>
                  <input type="text" value={cr.distanciaMar} onChange={e => sF("distanciaMar", e.target.value)} className={classInputCriterio(cr.distanciaMar)} style={estiloInputCriterio(cr.distanciaMar, { padding: '5px 8px' })} placeholder="Ej: 500"
                    onFocus={onFocusInputCriterio}
                    onBlur={onBlurInputCriterio} />
                </div>
                <div>
                  <div style={sectionLabel}>Cal. Energética</div>
                  <select value={cr.calEnergetica} onChange={e => { userModified.current = true; setCr(p => ({ ...p, calEnergetica: e.target.value })); }} className={classInputCriterio(cr.calEnergetica)} style={estiloInputCriterio(cr.calEnergetica, { padding: '5px 8px' })}>
                    <option value="">Cualquiera</option>
                    {CAL_ENERGETICAS.map(l => <option key={l} value={l}>{l}</option>)}
                  </select>
                </div>
              </div>

              {/* Orientación */}
              <div>
                <div style={sectionLabel}>Orientación</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {ORIENTACIONES.map((o) => (
                    <Chip
                      key={o}
                      label={o}
                      active={cr.orientacion.includes(o)}
                      excluded={(cr.orientacionExcl || []).includes(o)}
                      onClick={() => onArrayInclExclChip("orientacion", "orientacionExcl", o)}
                      theme={theme}
                    />
                  ))}
                </div>
              </div>

              {/* Estado inmueble */}
              <div>
                <div style={sectionLabel}>Estado inmueble</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {estadosInmueble.map((e) => (
                    <Chip
                      key={e}
                      label={e}
                      active={cr.estadoInmueble.includes(e)}
                      excluded={(cr.estadoInmuebleExcl || []).includes(e)}
                      onClick={() => onArrayInclExclChip("estadoInmueble", "estadoInmuebleExcl", e)}
                      theme={theme}
                    />
                  ))}
                </div>
              </div>

              {/* Plantas */}
              <div>
                <div style={sectionLabel}>Plantas</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {PLANTAS_OPCIONES.map((pl) => (
                    <Chip
                      key={pl}
                      label={pl}
                      active={cr.plantas.includes(pl)}
                      excluded={(cr.plantasExcl || []).includes(pl)}
                      onClick={() => onArrayInclExclChip("plantas", "plantasExcl", pl)}
                      theme={theme}
                    />
                  ))}
                </div>
              </div>

              {/* Toggles booleanos */}
              <div>
                <div style={sectionLabel}>Otros filtros</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  <Chip label="🌿 Jardín" active={cr.jardin} onClick={() => { userModified.current = true; setCr(p => ({ ...p, jardin: !p.jardin })); }} theme={theme} />
                  <Chip label="🏗️ VPO" active={cr.vpo} excluded={cr.vpoExcl} onClick={() => onBoolTriChip("vpo", "vpoExcl")} theme={theme} />
                  <Chip label="❄️ A.A." active={cr.aireAc} onClick={() => { userModified.current = true; setCr(p => ({ ...p, aireAc: !p.aireAc })); }} theme={theme} />
                  <Chip label="🔥 Calefacción" active={cr.calefaccion} onClick={() => { userModified.current = true; setCr(p => ({ ...p, calefaccion: !p.calefaccion })); }} theme={theme} />
                  <Chip label="🏸 Pista Pádel" active={cr.padel} excluded={cr.padelExcl} onClick={() => onBoolTriChip("padel", "padelExcl")} theme={theme} />
                  <Chip label="🎾 Pista Tenis" active={cr.tenis} excluded={cr.tenisExcl} onClick={() => onBoolTriChip("tenis", "tenisExcl")} theme={theme} />
                  <Chip label="🔌 Punto Recarga" active={cr.puntoRecarga} onClick={() => { userModified.current = true; setCr(p => ({ ...p, puntoRecarga: !p.puntoRecarga })); }} theme={theme} />
                  <Chip label="♿ Adaptado" active={cr.adaptado} onClick={() => { userModified.current = true; setCr(p => ({ ...p, adaptado: !p.adaptado })); }} theme={theme} />
                  <Chip label="💨 Salida Humos" active={cr.salidaHumos} onClick={() => { userModified.current = true; setCr(p => ({ ...p, salidaHumos: !p.salidaHumos })); }} theme={theme} />
                </div>
              </div>

              {/* Urbanización — TODO: cargar desde BD con GET /api/urbanizaciones */}

              {/* EQUIP (categorías originales) */}
              {Object.entries(EQUIP).map(([cat, items]) => <div key={cat}>
                <div style={sectionLabel}>{cat}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>{items.map(i => <Chip key={i} label={i} small active={cr.equip.includes(i)} onClick={() => tArr("equip", i)} theme={theme} />)}</div>
              </div>)}
            </div>}

          </div>
        </div>

        
        {/* HISTORIAL */}
        <div style={{ padding: '8px 16px' }}>
          <div style={{ marginBottom: 8 }}>
            <div style={{ ...sectionLabel, marginBottom: 6 }}>Historial</div>
            <div style={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                {[
                  { id: "todos", label: "Todos", reset: true },
                  { id: "whatsapp", label: "WhatsApp" },
                  { id: "mail", label: "Mail" },
                  { id: "llamadas", label: "Llamadas" },
                  { id: "citas", label: "Citas" },
                  { id: "notas", label: "Notas" },
                  { id: "sistema", label: "Sistema" },
                ].map((f) => {
                  const active = f.reset
                    ? historialSinFiltroActivo
                    : historialFiltrosIncl.includes(f.id);
                  const excluded = !f.reset && historialFiltrosExcl.includes(f.id);
                  return (
                    <Chip
                      key={f.id}
                      label={f.label}
                      small
                      active={active}
                      excluded={excluded}
                      theme={theme}
                      onClick={() => onHistorialFiltroChipPress(f.id, !!f.reset)}
                    />
                  );
                })}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            {historialRender.map(h => {
              const waIcono = tileWhatsAppHistorialFicha(13);
              const llIcono = tileLlamadaHistorialFicha();
              const iconos = {
                whatsapp_enviado: waIcono,
                whatsapp_recibido: waIcono,
                whatsapp_respuesta: waIcono,
                email_enviado: { bg: c.btnEmailBg || '#b45309', sh: c.btnEmailShadow || '0 2px 6px rgba(180,83,9,0.25)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 6L2 7" /></svg> },
                cita_creada: { bg: c.btnCitaBg, sh: c.btnCitaShadow, ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg> },
                nota: { bg: c.btnNotaBg, sh: c.btnNotaShadow, ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg> },
                llamada: llIcono,
                llamada_ana: llIcono,
                etapa_cambio: { bg: 'linear-gradient(135deg, #475569, #64748b)', sh: '0 2px 6px rgba(71,85,105,0.25)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 102.13-9.36L1 10" /></svg> },
                lead_creado: { bg: 'linear-gradient(135deg, #6366f1, #4f46e5)', sh: '0 2px 6px rgba(99,102,241,0.25)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" /></svg> },
                lead_reasignado: { bg: 'linear-gradient(135deg, #f59e0b, #d97706)', sh: '0 2px 6px rgba(245,158,11,0.3)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 014-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 01-4 4H3" /></svg> },
                tarea_vencida: { bg: 'linear-gradient(135deg, #ef4444, #dc2626)', sh: '0 2px 6px rgba(239,68,68,0.3)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg> },
                cliente_creado: { bg: 'linear-gradient(135deg, #0ea5e9, #0284c7)', sh: '0 2px 6px rgba(14,165,233,0.25)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg> },
                demanda_creada: { bg: 'linear-gradient(135deg, #10b981, #059669)', sh: '0 2px 6px rgba(16,185,129,0.25)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="18" x2="12" y2="12" /><line x1="9" y1="15" x2="15" y2="15" /></svg> },
                oferta_registrada: { bg: 'linear-gradient(135deg, #ca8a04, #a16207)', sh: '0 2px 6px rgba(202,138,4,0.3)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M12 1v22" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /></svg> },
                cualificacion_visita: { bg: 'linear-gradient(135deg, #0d9488, #0f766e)', sh: '0 2px 6px rgba(13,148,136,0.3)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg> },
                sin_interes: { bg: 'linear-gradient(135deg, #64748b, #475569)', sh: '0 2px 6px rgba(71,85,105,0.3)', ic: <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg> },
              };
              const accentColors = {
                whatsapp_enviado: WA_VERDE_OFICIAL,
                whatsapp_recibido: WA_VERDE_OFICIAL,
                whatsapp_respuesta: WA_VERDE_OFICIAL,
                email_enviado: '#b45309',
                cita_creada: '#8b5cf6',
                nota: '#6b7280',
                llamada: LLAMADA_AMARILLO,
                llamada_ana: LLAMADA_AMARILLO,
                etapa_cambio: '#475569',
                lead_creado: '#6366f1',
                lead_reasignado: '#f59e0b',
                tarea_vencida: '#ef4444',
                cliente_creado: '#0ea5e9',
                demanda_creada: '#10b981',
                oferta_registrada: '#ca8a04',
                cualificacion_visita: '#0d9488',
                sin_interes: '#64748b',
              };
              const ic = iconos[h.tipo] || iconos.nota;
              const accentColor = accentColors[h.tipo] || '#94a3b8';
              const labels = {
                whatsapp_enviado: etiquetaWhatsAppEnviadoHistorial(h),
                whatsapp_recibido: etiquetaHistorialConAutor('WhatsApp recibido', h),
                whatsapp_respuesta: etiquetaHistorialConAutor('WhatsApp recibido', h),
                email_enviado: etiquetaHistorialConAutor('Email enviado', h),
                cita_creada: etiquetaHistorialConAutor(
                  h.asunto || 'Cita programada',
                  h,
                ),
                nota: etiquetaHistorialConAutor('Nota', h),
                llamada: etiquetaHistorialConAutor('Llamada', h),
                llamada_ana: etiquetaHistorialConAutor('Llamada Ana (IA)', h),
                etapa_cambio: etiquetaHistorialConAutor(h.asunto || 'Cambio de etapa', h),
                lead_creado: etiquetaHistorialConAutor(h.asunto || 'Lead creado', h),
                lead_reasignado: etiquetaHistorialConAutor(
                  h.asunto || 'Reasignación de agente',
                  h,
                ),
                tarea_vencida: etiquetaHistorialConAutor(h.asunto || 'Tarea vencida', h),
                cliente_creado: etiquetaHistorialConAutor('Cliente creado', h),
                demanda_creada: etiquetaHistorialConAutor('Demanda creada', h),
                oferta_registrada: etiquetaHistorialConAutor('Oferta registrada', h),
                cualificacion_visita: etiquetaHistorialConAutor('Cualificación de visita', h),
                sin_interes: etiquetaHistorialConAutor('Sin interés / descarte', h),
              };
              const fecha = h.created_at ? new Date(h.created_at) : null;
              const fechaStr = fecha ? fecha.toLocaleDateString("es-ES", { day: "numeric", month: "short" }) : '';
              const horaStr = fecha ? fecha.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }) : '';

              const chipsRefs = chipsReferenciasHistorial(h, props, historialPropMeta);
              const metaCitaHistorial = h.tipo === "cita_creada" ? parseHistorialMetadata(h) : {};
              const agendaIdHistorial = metaCitaHistorial.agenda_id || null;
              const abrirRefChip = (pe) => {
                if (pe.id) abrirFichaResumen(pe.id);
                else if (pe.ref) abrirFichaPorRef(pe.ref);
              };

              return (
                <div key={h.id} style={{
                  display: 'flex', gap: 10,
                  padding: theme.name === 'dark' ? '8px 0' : '9px 10px',
                  background: theme.name === 'dark' ? 'transparent' : c.bgCard,
                  border: theme.name === 'dark' ? 'none' : `1px solid ${c.border}`,
                  borderLeft: theme.name === 'dark' ? 'none' : `3px solid ${accentColor}`,
                  borderRadius: theme.name === 'dark' ? 0 : 8,
                  borderBottom: theme.name === 'dark' ? `1px solid ${c.sectionBorder}` : undefined,
                  marginBottom: theme.name === 'dark' ? 0 : 4,
                  boxShadow: theme.name === 'dark' ? 'none' : '0 1px 3px rgba(0,0,0,0.05)',
                }}>
                  {/* Icono */}
                  <div style={{
                    width: 30, height: 30, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    background: ic.bg, boxShadow: ic.sh,
                  }}>{ic.ic}</div>

                  {/* Fecha + Hora */}
                  <div style={{ flexShrink: 0, width: 44, textAlign: 'center', paddingTop: 1 }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: c.textPrimary, lineHeight: 1.2 }}>{fechaStr}</div>
                    <div style={{ fontSize: 10, color: c.textMuted, lineHeight: 1.2 }}>{horaStr}</div>
                  </div>

                  {/* Contenido */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: c.textPrimary, display: "flex", alignItems: "center", gap: 6 }}>
                      <PuntoWaHistorial tipo={h.tipo} />
                      <span>{labels[h.tipo] || etiquetaHistorialConAutor(h.asunto || h.tipo, h)}</span>
                    </div>

                    {/* Destinatario */}
                    {h.destinatario && (
                      <div style={{ fontSize: 11, color: c.textMuted, marginTop: 2 }}>
                        → {h.destinatario}
                      </div>
                    )}

                    {/* Referencias de propiedades (clic → vista previa) */}
                    {(chipsRefs.length > 0 || (h.tipo === "cita_creada" && agendaIdHistorial)) && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4, alignItems: 'center' }}>
                        {chipsRefs.map((pe, i) => (
                          <span
                            key={`${pe.ref || pe.id || i}`}
                            role="button"
                            tabIndex={0}
                            onClick={(e) => { e.stopPropagation(); abrirRefChip(pe); }}
                            onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); abrirRefChip(pe); } }}
                            style={{
                              fontSize: 10, fontWeight: 600, padding: '2px 7px', borderRadius: 4,
                              background: c.accentBlueLight, color: theme.name === 'dark' ? '#ffffff' : c.accentBlue,
                              border: `1px solid ${c.accentBlueBorder}`,
                              cursor: 'pointer', whiteSpace: 'nowrap',
                            }}
                          >
                            {pe.ref || pe.titulo || "—"}
                          </span>
                        ))}
                        {h.tipo === "cita_creada" && agendaIdHistorial && (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              abrirModalCitaDesdeAgenda(agendaIdHistorial);
                            }}
                            title="Ver y editar cita"
                            style={{
                              flexShrink: 0,
                              background: 'none',
                              border: `1px solid ${c.border}`,
                              borderRadius: 4,
                              cursor: 'pointer',
                              padding: '2px 6px',
                              color: c.textMuted,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                          </button>
                        )}
                      </div>
                    )}

                    {/* Detalle compacto para lead_creado */}
                    {h.tipo === 'lead_creado' && (() => {
                      const m = h.metadata || {};
                      const proc = h.canal || m.fuente || '';
                      const ref = m.propiedad_ref || m.referencia || '';
                      const comentario = m.notas || m.mensaje_original || h.contenido || '';
                      return (
                        <div style={{ fontSize: 11, color: c.textSecondary, marginTop: 2, display: 'flex', alignItems: 'center', gap: 4, overflow: 'hidden' }}>
                          {proc && <span style={{ flexShrink: 0, padding: '1px 5px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: colorHexProcedencia(proc), color: textOnSolidColor(colorHexProcedencia(proc)) }}>{proc}</span>}
                          {ref && (
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={(e) => { e.stopPropagation(); abrirFichaPorRef(ref); }}
                              onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); abrirFichaPorRef(ref); } }}
                              style={{
                                flexShrink: 0, padding: '1px 5px', borderRadius: 4, fontSize: 10, fontWeight: 600,
                                background: c.accentGreenLight, color: c.accentGreenDark, cursor: 'pointer',
                              }}
                            >
                              {ref}
                            </span>
                          )}
                          {comentario && <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: c.textMuted }}>{comentario}</span>}
                          {(h.lead_id || leadFlowId || (!esRutaCliente && id && id !== "nuevo" ? id : null)) && (
                            <button
                              type="button"
                              onClick={() => abrirLeadModalDesdeHistorial(h.lead_id || leadFlowId || id)}
                              title="Ver ficha del lead"
                              style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: c.textMuted, display: 'flex', alignItems: 'center' }}
                            >
                              <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                            </button>
                          )}
                        </div>
                      );
                    })()}

                    {/* Detalle cita (sin repetir refs en texto) */}
                    {h.tipo === "cita_creada" && h.contenido && (
                      <div style={{ fontSize: 11, color: c.textMuted, marginTop: 2 }}>
                        {textoCitaSinRefs(h.contenido) || h.contenido}
                      </div>
                    )}

                    {/* Llamadas de la cita (transcripciones dentro de la acción) */}
                    {h.tipo === "cita_creada" && (h.llamadasAnidadas || []).length > 0 && (
                      <div style={{ marginTop: 6, paddingLeft: 8, borderLeft: `2px solid ${accentColor}` }}>
                        {(h.llamadasAnidadas || []).map((ll) => (
                          <div key={ll.id} style={{ marginBottom: 6 }}>
                            <div style={{ fontSize: 10, fontWeight: 700, color: c.textSecondary }}>
                              📞 {ll.tipo === "llamada_ana" ? "Llamada Ana" : "Llamada"}
                              {ll.created_at && (
                                <span style={{ fontWeight: 500, color: c.textMuted, marginLeft: 6 }}>
                                  {new Date(ll.created_at).toLocaleString("es-ES", {
                                    day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
                                  })}
                                </span>
                              )}
                            </div>
                            {ll.contenido && (
                              <div style={{ fontSize: 11, color: c.textMuted, marginTop: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                                <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {ll.contenido.replace(/\n[\s\S]*/, "…")}
                                </span>
                                <button
                                  type="button"
                                  onClick={() => setVisorHistorial({
                                    tipo: ll.tipo,
                                    contenido: ll.contenido,
                                    fecha: ll.created_at,
                                    asunto: ll.asunto,
                                  })}
                                  title="Ver transcripción"
                                  style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: c.textMuted, display: 'flex', alignItems: 'center' }}
                                >
                                  <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                  </svg>
                                </button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Texto del mensaje (otros tipos) */}
                    {h.tipo !== "lead_creado" && h.tipo !== "cita_creada" && h.contenido && (
                      <div style={{ fontSize: 11, color: c.textMuted, marginTop: 2, display: 'flex', alignItems: 'center', gap: 4, overflow: 'hidden' }}>
                        <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {contenidoHistorialSinLineaFichas(h.contenido) || h.contenido}
                        </span>
                        {(h.contenido.length > 60 || h.tipo === "whatsapp_enviado" || h.tipo === "email_enviado" || h.tipo === "whatsapp_recibido") && (
                          <button
                            type="button"
                            onClick={() => {
                              const metaH = parseHistorialMetadata(h);
                              const contenidoVisor =
                                h.tipo === "whatsapp_enviado" || h.tipo === "whatsapp_recibido"
                                  ? textoCompletoHistorialWa(h, metaH)
                                  : h.contenido;
                              setVisorHistorial({
                                tipo: h.tipo,
                                contenido: contenidoVisor,
                                fecha: h.created_at,
                                asunto: h.asunto,
                                chipsRefs: chipsRefs,
                              });
                            }}
                            title="Ver completo"
                            style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: c.textMuted, display: 'flex', alignItems: 'center' }}
                          >
                            <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                            </svg>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

            {/* Lead creado (fallback si no hay entrada en historial) */}
            {(() => {
              const sinEntrada = !historial.some(h => h.tipo === 'lead_creado');
              // En vista lead usa lead; en vista cliente usa leadsV[0] o cliente
              const leadRef = lead?.created_at ? lead : leadsV?.[0] || null;
              const clienteRef = cliente;
              const fechaOrigen = leadRef?.created_at || clienteRef?.created_at;
              if (!fechaOrigen || !sinEntrada || !historialSinFiltroActivo) return null;
              const fuente = leadRef?.fuente || leadRef?.portal_origen || '';
              const ref = leadRef?.propiedad_ref || '';
              const nombre = [leadRef?.nombre || clienteRef?.nombre, leadRef?.apellido || clienteRef?.apellido].filter(Boolean).join(' ');
              const contacto = [leadRef?.email || clienteRef?.email, leadRef?.telefono || clienteRef?.telefono].filter(Boolean).join(' · ');
              const comentario = leadRef?.notas || leadRef?.mensaje_original || '';
              return (
                <div style={{
                  display: 'flex', gap: 10,
                  padding: theme.name === 'dark' ? '8px 0' : '9px 10px',
                  background: theme.name === 'dark' ? 'transparent' : c.bgCard,
                  border: theme.name === 'dark' ? 'none' : `1px solid ${c.border}`,
                  borderLeft: theme.name === 'dark' ? 'none' : '3px solid #6366f1',
                  borderRadius: theme.name === 'dark' ? 0 : 8,
                  marginBottom: theme.name === 'dark' ? 0 : 4,
                  boxShadow: theme.name === 'dark' ? 'none' : '0 1px 3px rgba(0,0,0,0.05)',
                }}>
                  <div style={{ width: 30, height: 30, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', boxShadow: '0 2px 6px rgba(99,102,241,0.25)' }}>
                    <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" /></svg>
                  </div>
                  <div style={{ flexShrink: 0, width: 44, textAlign: 'center', paddingTop: 1 }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: c.textPrimary, lineHeight: 1.2 }}>{new Date(fechaOrigen).toLocaleDateString("es-ES", { day: "numeric", month: "short" })}</div>
                    <div style={{ fontSize: 10, color: c.textMuted, lineHeight: 1.2 }}>{new Date(fechaOrigen).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}</div>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: c.textPrimary }}>Lead creado</div>
                    <div style={{ fontSize: 11, color: c.textSecondary, marginTop: 2, display: 'flex', alignItems: 'center', gap: 4, overflow: 'hidden' }}>
                      {fuente && <span style={{ flexShrink: 0, padding: '1px 5px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: colorHexProcedencia(fuente), color: textOnSolidColor(colorHexProcedencia(fuente)) }}>{fuente}</span>}
                      {ref && <span style={{ flexShrink: 0, padding: '1px 5px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: c.accentGreenLight, color: c.accentGreenDark }}>{ref}</span>}
                      {comentario && <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: c.textMuted }}>{comentario}</span>}
                      {leadRef?.id && (
                        <button
                          type="button"
                          onClick={() => abrirLeadModalDesdeHistorial(leadRef.id)}
                          title="Ver ficha del lead"
                          style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: c.textMuted, display: 'flex', alignItems: 'center' }}
                        >
                          <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })()}

          </div>
        </div>
        </div>

        {/* ACCIONES RÁPIDAS — fijas al pie del panel */}
        <div style={{ flexShrink: 0, padding: '6px 16px 8px', borderTop: `1px solid ${c.sectionBorder}`, background: c.bgPanel }}>
          <div style={{ ...sectionLabel, marginBottom: 2 }}>Acciones rápidas</div>
          <div style={{ display: 'flex', gap: 6 }}>
            {[
              { l: "Llamar", bg: c.btnCallBg, sh: c.btnCallShadow, ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={c.btnCallIconStroke || '#dc2626'} strokeWidth="2.2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg> },
              { l: "WhatsApp", bg: c.btnWhatsappBg, sh: c.btnWhatsappShadow, ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" /><path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" /></svg> },
              { l: "Cita", bg: c.btnCitaBg, sh: c.btnCitaShadow, ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg> },
              { l: "Email", bg: c.btnEmailBg || '#b45309', sh: c.btnEmailShadow || '0 2px 6px rgba(180,83,9,0.25)', ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 6L2 7" /></svg> },
              { l: "Nota", bg: c.btnNotaBg, sh: c.btnNotaShadow, ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg> },
              { l: "Imprimir", bg: "linear-gradient(135deg,#475569,#334155)", sh: "0 2px 6px rgba(71,85,105,0.3)", ic: <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg> },
            ].map(a => (
              <button key={a.l} onClick={
                a.l === "Cita" ? () => { void iniciarFlujoCitaDesdeFicha(); } :
                a.l === "WhatsApp" ? () => setModalWhatsApp(true) :
                a.l === "Email" ? () => setModalEmail(true) :
                a.l === "Nota" ? () => setModalNota(true) :
                a.l === "Imprimir" ? () => setModalPrint(true) :
                undefined
              } style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
                padding: '6px 0', borderRadius: 6, cursor: 'pointer', transition: 'all 0.15s',
                border: `1px solid ${c.btnActionBorder}`, background: c.btnActionBg,
                fontSize: 10, fontWeight: 500, color: c.btnActionText,
              }}>
                <div style={{ width: 30, height: 30, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', background: a.bg, boxShadow: a.sh }}>{a.ic}</div>
                {a.l}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ========== PANEL DERECHO ========== */}
      <div style={{ width: '50%', display: 'flex', flexDirection: 'column', background: c.bgPanel, minHeight: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px', borderBottom: `1px solid ${c.sectionBorder}` }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: c.textSecondary, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            {propsExternasLoading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#0369a1' }}>
                <span style={{ width: 14, height: 14, border: '2px solid #0369a1', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} />
                Buscando...
              </span>
            ) : (
              <>
                <span style={{ color: c.accentGreen }}>{nPropsCabeza}</span>
                {propsExternas !== null && propsExternasTotal > propsExternas.length && (
                  <span style={{ fontSize: 11, color: c.textMuted }}>de {propsExternasTotal.toLocaleString('es-ES')}</span>
                )}
                {' '}propiedades
                {propsExternas === null && descartadasEfectivasIds.size > 0 ? (
                  <span style={{ fontSize: 11, fontWeight: 500, color: c.textMuted }}>
                    ({descartadasEfectivasIds.size} descartada{descartadasEfectivasIds.size !== 1 ? "s" : ""} al final)
                  </span>
                ) : null}
              </>
            )}
            {propsExternas !== null && (
              <span style={{ fontSize: 11, fontWeight: 500, color: '#0369a1', background: 'rgba(3,105,161,0.1)', padding: '2px 8px', borderRadius: 10 }}>
                🕷️ {propsExternasTipo === 'todos' ? 'Todos' : propsExternasTipo === 'agencia' ? 'Agencias' : 'Particulares'}
              </span>
            )}
          </div>
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            {propsExternas !== null && (
              <button
                onClick={() => { setPropsExternas(null); setPropsExternasTipo(null); }}
                title="Volver a propiedades del CRM"
                style={{ background: 'rgba(3,105,161,0.15)', border: '1px solid rgba(3,105,161,0.3)', borderRadius: 6, cursor: 'pointer', padding: '3px 10px', fontSize: 11, fontWeight: 600, color: '#0369a1', display: 'flex', alignItems: 'center', gap: 4 }}
              >
                ← CRM
              </button>
            )}
            <button onClick={() => setModalPortales(true)} title="Buscar en portales externos" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: propsExternas !== null ? 1 : 0.7, transition: 'opacity 0.15s' }} onMouseEnter={e => e.currentTarget.style.opacity = 1} onMouseLeave={e => e.currentTarget.style.opacity = propsExternas !== null ? 1 : 0.7}>
              <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke={propsExternas !== null ? "#0ea5e9" : "#ffffff"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </button>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 500, color: c.liveColor }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: c.liveColor, animation: 'pulse 2s infinite' }} />En vivo
          </div>
        </div>

        {citaModalActivo && (
          <div style={{
            padding: '8px 12px',
            background: 'rgba(124,58,237,0.12)',
            borderBottom: `1px solid ${c.sectionBorder}`,
            fontSize: 12,
            color: c.textSecondary,
            lineHeight: 1.45,
          }}>
            Visita abierta encima: ajusta criterios aquí y pulsa <b style={{ color: '#7c3aed' }}>+ Visita</b> en una propiedad (o selecciónala y «Añadir a visita»).
          </div>
        )}

        {/* Barra de acciones cuando hay propiedades seleccionadas */}
        {seleccionadas.length > 0 && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px',
            background: c.accentGreenLight || 'rgba(34,197,94,0.1)',
            borderBottom: `1px solid ${c.sectionBorder}`,
          }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: c.accentGreen, flex: 1 }}>
              {seleccionadas.length} seleccionada{seleccionadas.length !== 1 ? 's' : ''}
            </span>
            {citaModalActivo && (
              <button
                type="button"
                onClick={() => { void anadirSeleccionadasAVisitaOverlay(); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 5,
                  padding: '5px 12px', borderRadius: 7, border: 'none',
                  background: '#7c3aed', color: '#fff',
                  fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                + Añadir a visita
              </button>
            )}
            <button
              type="button"
              onClick={() => setModalPrint(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: 5,
                padding: '5px 12px', borderRadius: 7, border: 'none',
                background: c.accentBlue, color: '#fff',
                fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 6 2 18 2 18 9"/>
                <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/>
                <rect x="6" y="14" width="12" height="8"/>
              </svg>
              Imprimir
            </button>
            <button
              type="button"
              onClick={() => setModalWhatsApp(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: 5,
                padding: '5px 10px', borderRadius: 7,
                border: `1px solid ${c.sectionBorder}`,
                background: 'transparent', color: c.textSecondary,
                fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >💬 WA</button>
            <button
              type="button"
              onClick={() => setSeleccionadas([])}
              style={{
                padding: '4px 8px', borderRadius: 6,
                border: `1px solid ${c.sectionBorder}`,
                background: 'transparent', color: c.textMuted,
                fontSize: 11, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >✕</button>
          </div>
        )}

        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {/* ── PROPIEDADES EXTERNAS (scraping portales) ── */}
        {propsExternas !== null ? (
          <div style={{ padding: 12, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, alignContent: 'start' }}>
            {propsExternas.length === 0 ? (
              <div style={{ gridColumn: 'span 2', textAlign: 'center', padding: '40px 0', color: c.textMuted }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🔍</div>
                <p style={{ fontWeight: 500, fontSize: 14, color: c.textSecondary }}>Sin resultados en portales</p>
                <p style={{ fontSize: 12, marginTop: 4 }}>Prueba a cambiar los criterios de búsqueda</p>
              </div>
            ) : propsExternas.map((p, idx) => {
              const car = p.caracteristicas || {};
              const hab = car.habitaciones ?? p.habitaciones;
              const ban = car.banos ?? p.banos;
              const m2  = car.superficie_m2 ?? p.superficie_m2;
              const piscinaExt = car.piscina || p.piscina;
              const garajeExt  = car.garaje  || p.garaje;
              const terrazaExt = car.terraza || p.terraza;
              const precioNum  = p.precio_numerico || p.precio;
              const foto0      = Array.isArray(p.fotos) && p.fotos.length > 0 ? p.fotos[0] : null;
              const PORTAL_COLORS = { fotocasa: '#e53e3e', idealista: '#92400e', pisos: '#166534', habitaclia: '#6d28d9' };
              const portalColor = PORTAL_COLORS[p.portal] || '#475569';
              return (
                <div key={p.id || idx} style={{
                  background: c.propCardBg, borderRadius: 10, border: `1px solid ${c.propCardBorder}`,
                  overflow: 'hidden', boxShadow: c.propCardShadow, cursor: 'pointer',
                  transition: 'box-shadow 0.2s, transform 0.2s',
                }}
                  onClick={() => setModalPropExt(p)}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = c.propCardHoverShadow; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = c.propCardShadow; e.currentTarget.style.transform = 'none'; }}
                >
                  {/* Foto */}
                  <div style={{ position: 'relative', aspectRatio: '16/9', background: c.bgCard }}>
                    {foto0 ? (
                      <img src={foto0} alt={p.titulo} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                    ) : (
                      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: c.textPlaceholder }}>
                        <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>
                      </div>
                    )}
                    {/* Badge precio */}
                    <div style={{ position: 'absolute', bottom: 8, left: 8, background: c.propBadgeBg, color: c.propBadgeText, padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                      {precioNum ? `${Number(precioNum).toLocaleString('es-ES')} €` : 'Sin precio'}
                    </div>
                    {/* Badge portal */}
                    <div style={{ position: 'absolute', top: 8, right: 8, padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 700, color: '#fff', background: portalColor }}>
                      {p.portal}
                    </div>
                    {/* Badge operación */}
                    {p.operacion && (
                      <div style={{ position: 'absolute', top: 8, left: 8, padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 700, color: '#fff', background: p.operacion === 'alquiler' ? c.accentPink : c.accentGreen }}>
                        {p.operacion.charAt(0).toUpperCase() + p.operacion.slice(1)}
                      </div>
                    )}
                  </div>
                  {/* Info */}
                  <div style={{ padding: 10 }}>
                    <h3 style={{ fontSize: 12, fontWeight: 700, color: c.textPrimary, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {p.titulo || 'Sin título'}
                    </h3>
                    <p style={{ fontSize: 11, color: c.textMuted, margin: '2px 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {p.municipio || p.direccion || '—'}
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6, fontSize: 11, color: c.textSecondary }}>
                      {hab > 0 && <span>🛏 {hab} hab</span>}
                      {ban > 0 && <span>🚿 {ban}</span>}
                      {m2 > 0  && <span>📐 {Math.round(m2)} m²</span>}
                    </div>
                    {(piscinaExt || garajeExt || terrazaExt) && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                        {piscinaExt && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🏊 Piscina</span>}
                        {garajeExt  && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🚗 Garaje</span>}
                        {terrazaExt && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🌿 Terraza</span>}
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8, paddingTop: 6, borderTop: `1px solid ${c.borderLight}`, fontSize: 10, color: c.textMuted }}>
                      <span>{p.tipo_anunciante === 'particular' ? '👤 Particular' : p.tipo_anunciante === 'agencia' ? '🏢 ' + (p.alias_agencia || 'Agencia') : (p.alias_agencia || p.nombre_contacto || '—')}</span>
                      {p.fecha_publicacion && <span>{new Date(p.fecha_publicacion).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}</span>}
                    </div>
                  </div>
                </div>
              );
            })}
            {/* Botón cargar más */}
            {propsExternas !== null && propsExternasTotal > propsExternas.length && (
              <div style={{ gridColumn: 'span 2', padding: '12px 0', display: 'flex', justifyContent: 'center' }}>
                <button
                  onClick={() => buscarPropsExternas(propsExternasTipo, cr, propsExternasPage + 1)}
                  disabled={propsExternasLoading}
                  style={{
                    padding: '8px 24px', borderRadius: 8, border: `1px solid ${c.sectionBorder}`,
                    background: 'transparent', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                    color: '#0369a1', fontFamily: 'inherit',
                    opacity: propsExternasLoading ? 0.5 : 1,
                  }}>
                  {propsExternasLoading ? 'Cargando...' : `Cargar más (${propsExternas.length} / ${propsExternasTotal.toLocaleString('es-ES')})`}
                </button>
              </div>
            )}
          </div>
        ) : (
        <div style={{
          padding: 12,
          display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, alignContent: 'start',
        }}>
          {props.length === 0 ? (
            <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: c.textMuted }}>
              <div style={{ textAlign: 'center' }}>
                <svg style={{ margin: '0 auto 12px', opacity: 0.3 }} width={48} height={48} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>
                <p style={{ fontWeight: 500, fontSize: 14, color: c.textSecondary }}>No hay propiedades</p>
                <p style={{ fontSize: 12, marginTop: 4 }}>Ajusta los criterios de búsqueda</p>
              </div>
            </div>
          ) : propsOrdenadas.map(p => {
            const descartadaCliente =
              descartadasPorCliente.includes(p.id) ||
              propDescartadaPorClienteEnVisitas(p.id, visitadasInfo);
            const estaDescartada = descartadas.includes(p.id) || descartadaCliente;
            const etiquetaDescarte = descartadaCliente
              ? "✕ Descartada por cliente"
              : "✕ Descartada";
            const estaSeleccionada = seleccionadas.includes(p.id);
            const enVisitaOverlay = citaModalActivo && propiedadEnCitaModalActivo(p.id);
            const noDisponible = esNoDisponibleTemporal(p);
            const esPropiedadLead = esPropiedadEntradaLead(p, propiedadEntradaLead);
            return (
            <div key={p.id} style={{
              background: c.propCardBg, borderRadius: 10, border: `1px solid ${estaSeleccionada ? c.accentBlue : c.propCardBorder}`,
              overflow: 'hidden', boxShadow: c.propCardShadow, transition: 'box-shadow 0.2s, transform 0.2s, opacity 0.3s',
              cursor: 'pointer', position: 'relative',
              opacity: estaDescartada ? 0.45 : 1,
              filter: estaDescartada ? 'grayscale(0.5)' : 'none',
            }}
              onMouseEnter={e => { if (!estaDescartada) { e.currentTarget.style.boxShadow = c.propCardHoverShadow; e.currentTarget.style.transform = 'translateY(-2px)'; }}}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = c.propCardShadow; e.currentTarget.style.transform = 'none'; }}
            >
              {/* Overlay descartada (agente o cliente) */}
              {estaDescartada && (
                <div style={{
                  position: 'absolute', inset: 0, zIndex: 5, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  pointerEvents: 'none',
                }}>
                  <span style={{
                    background: 'rgba(239,68,68,0.85)', color: '#fff', padding: '6px 18px', borderRadius: 8,
                    fontSize: 13, fontWeight: 700, letterSpacing: '0.03em',
                    transform: 'rotate(-12deg)',
                    boxShadow: '0 2px 12px rgba(239,68,68,0.3)',
                  }}>{etiquetaDescarte}</span>
                </div>
              )}

              {/* Foto 16:9 */}
              <div style={{ position: 'relative', aspectRatio: '16/9', background: c.bgCard }}
                onClick={() => abrirFichaResumen(p.id)}>
                {p.fotos && p.fotos.length > 0 ? (
                  <img src={p.fotos[0]?.startsWith('http') ? p.fotos[0] : `http://localhost:4000${p.fotos[0]}`} alt={p.titulo} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: c.textPlaceholder }}>
                    <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>
                  </div>
                )}

                {/* Checkbox selección (arriba-izquierda) */}
                <div onClick={e => { e.stopPropagation(); if (!estaDescartada) toggleSeleccion(p.id); }}
                  style={{
                    position: 'absolute', top: 8, left: 8, zIndex: 6,
                    width: 22, height: 22, borderRadius: 5,
                    border: `2px solid ${estaSeleccionada ? '#fff' : 'rgba(255,255,255,0.8)'}`,
                    background: estaSeleccionada ? c.accentBlue : 'rgba(0,0,0,0.25)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: estaDescartada ? 'not-allowed' : 'pointer',
                    transition: 'all 0.15s',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                  }}>
                  {estaSeleccionada && (
                    <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </div>

                {/* Botón descarte (debajo del checkbox) */}
                <div onClick={e => { e.stopPropagation(); toggleDescarte(p.id); }}
                  title={estaDescartada ? "Restaurar" : "Descartar"}
                  style={{
                    position: 'absolute', top: 36, left: 8, zIndex: 6,
                    width: 22, height: 22, borderRadius: 5,
                    border: `2px solid ${estaDescartada ? '#fff' : 'rgba(255,255,255,0.8)'}`,
                    background: estaDescartada ? '#ef4444' : 'rgba(0,0,0,0.25)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                  }}>
                  <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </div>

                {/* Vista cliente en TV (debajo del descarte) */}
                <div
                  onClick={e => {
                    e.stopPropagation();
                    abrirVistaClientePresentacion(p.id);
                  }}
                  title="Vista cliente (TV): presentación en segunda pantalla"
                  role="button"
                  style={{
                    position: 'absolute', top: 64, left: 8, zIndex: 6,
                    width: 22, height: 22, borderRadius: 5,
                    border: '2px solid rgba(255,255,255,0.85)',
                    background: 'rgba(0,0,0,0.35)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                  }}>
                  <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <rect x="2" y="5" width="16" height="11" rx="1.5" />
                    <path d="M8 21h8" />
                    <path d="M12 16v5" />
                  </svg>
                </div>

                {!estaDescartada && citaModalActivo && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      void anadirPropiedadAVisitaDesdeFicha(p.id);
                    }}
                    title={enVisitaOverlay ? "Ya está en la visita" : "Añadir a la visita"}
                    style={{
                      position: 'absolute', bottom: 8, right: 8, zIndex: 6,
                      padding: '4px 10px', borderRadius: 6,
                      background: enVisitaOverlay ? 'rgba(22,163,74,0.92)' : '#7c3aed',
                      color: '#fff',
                      fontSize: 11, fontWeight: 700, cursor: enVisitaOverlay ? 'default' : 'pointer',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                      pointerEvents: enVisitaOverlay ? 'none' : 'auto',
                    }}
                  >
                    {enVisitaOverlay ? '✓ En visita' : '+ Visita'}
                  </div>
                )}

                {/* Badge "No disponible" (centro-arriba, solo si fecha futura) */}
                {noDisponible && (
                  <BadgeNoDisponible
                    disponibleDesde={p.disponible_desde}
                    motivo={p.motivo_no_disponible}
                  />
                )}

{/* Badges Lead / Enviada / En Cita / Visitada / Pasa Oferta / Vendida */}
                {(esPropiedadLead || enviadasInfo[String(p.id)] || visitadasInfo[String(p.id)] || enCitaInfo[String(p.id)] || ofertasInfo[String(p.id)] || vendidasInfo[String(p.id)]) && (
                  <div
                    style={{
                      position: "absolute",
                      top: topDebajoBadgeNoDisponible(p),
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 7,
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      maxWidth: "calc(100% - 16px)",
                    }}
                  >
                    {esPropiedadLead && (
                      <div
                        title="Propiedad por la que entró el lead"
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgeLead(),
                        }}
                      >
                        ✓ Lead
                      </div>
                    )}
                    {enviadasInfo[String(p.id)] && (
                      <div
                        title={buildEnviadaTooltip(enviadasInfo[String(p.id)])}
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgeEnviada(enviadasInfo[String(p.id)]),
                        }}
                      >
                        ✓ Enviada
                      </div>
                    )}
                    {enCitaInfo[String(p.id)] && (
                      <div
                        title={buildEnCitaTooltip(enCitaInfo[String(p.id)], visitadasInfo[String(p.id)])}
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgeEnCita(),
                        }}
                      >
                        ✓ {labelBadgeEnCita(enCitaInfo[String(p.id)]?.numero_cita)}
                      </div>
                    )}
                    {visitadasInfo[String(p.id)] && !enCitaInfo[String(p.id)] && (
                      <div
                        title={buildVisitadaTooltip(visitadasInfo[String(p.id)])}
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgeVisitada(),
                        }}
                      >
                        ✓ Visitada
                      </div>
                    )}
                    {ofertasInfo[String(p.id)] && (
                      <div
                        title={buildPasaOfertaTooltip(ofertasInfo[String(p.id)])}
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgePasaOferta(),
                        }}
                      >
                        € Pasa Oferta
                      </div>
                    )}
                    {vendidasInfo[String(p.id)] && (
                      <div
                        title={buildVendidaTooltip(vendidasInfo[String(p.id)])}
                        style={{
                          ...estiloBadgePropiedadBase,
                          ...estiloBadgeVendida(),
                        }}
                      >
                        ✓ Vendida
                      </div>
                    )}
                  </div>
                )}

                {/* Badge precio */}
                <div style={{ position: 'absolute', bottom: 8, left: 8, background: c.propBadgeBg, color: c.propBadgeText, padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                  {p.precio_web_consultar ? "A consultar" : (p.precio_venta || p.precio) ? `${Number(p.precio_venta || p.precio).toLocaleString("es-ES")} €` : "Sin precio"}
                </div>
                {/* Badge operación */}
                <div style={{
                  position: 'absolute', top: 8, right: 8, padding: '2px 8px', borderRadius: 6,
                  fontSize: 10, fontWeight: 700, color: '#fff',
                  background: p.operacion?.toLowerCase() === "alquiler" ? c.accentPink : c.accentGreen,
                }}>{p.operacion || "Venta"}</div>
              </div>

              {/* Info */}
              <div style={{ padding: 12 }} onClick={() => abrirFichaResumen(p.id)}>
                <h3 style={{ fontSize: 13, fontWeight: 700, color: c.textPrimary, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.titulo || "Sin título"}</h3>
                <p style={{ fontSize: 11, color: c.textMuted, margin: '2px 0 0' }}>{p.tipo_nombre || p.tipo || ""} · {p.poblacion_nombre || p.poblacion || ""}{p.zona_nombre ? ` · ${p.zona_nombre}` : ""}</p>

                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8, fontSize: 11, color: c.textSecondary }}>
                  {p.m2_construidos > 0 && <span>📐 {Math.round(p.m2_construidos)} m²</span>}
                  {p.num_dormitorios > 0 && <span>🛏 {p.num_dormitorios} hab</span>}
                  {p.num_banos > 0 && <span>🚿 {p.num_banos} {p.num_banos === 1 ? "baño" : "baños"}</span>}
                  {p.num_aseos > 0 && <span>🚽 {p.num_aseos} {p.num_aseos === 1 ? "aseo" : "aseos"}</span>}
                  {p.planta !== null && p.planta !== undefined && <span>🏢 P.{p.planta}</span>}
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
                  {p.eq_piscina_priv && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🏊 Piscina</span>}
                  {p.eq_piscina_comun && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🏊 Piscina com.</span>}
                  {p.eq_garaje && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🚗 Garaje</span>}
                  {p.eq_ascensor && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🛗 Ascensor</span>}
                  {p.amueblado && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🪑 Amueblado</span>}
                  {p.ub_primera_linea && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 500, background: c.propExtraBg, color: c.propExtraText }}>🏖️ 1ª línea</span>}
                  {p.tenemos_llaves && <span style={{ padding: '1px 6px', borderRadius: 4, fontSize: 9, fontWeight: 700, background: 'rgba(34,197,94,0.15)', color: '#16a34a', border: '1px solid rgba(34,197,94,0.3)' }}>🔑 Llaves</span>}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8, paddingTop: 8, borderTop: `1px solid ${c.borderLight}` }}>
                  <span style={{ fontSize: 10, color: c.textMuted }}>Ref: <b style={{ color: c.textSecondary }}>{p.referencia || "—"}</b></span>
                  {p.agente_nombre && <span style={{ fontSize: 10, color: c.textMuted }}>{p.agente_nombre}</span>}
                </div>
              </div>
            </div>
            );
          })}
        </div>
        )}
        </div>
      </div>

      {/* ========== MODAL PROPIEDAD EXTERNA (scraping portales) ========== */}
      {modalPropExt && (
        <ModalDetallePropiedad p={modalPropExt} theme={theme} onClose={() => setModalPropExt(null)} />
      )}

      {/* ========== FICHA RESUMEN PANEL (idéntica a Propiedades.jsx) ========== */}
      {fichaResumen.abierta && fichaResumen.datos && (() => {
        const fr = fichaResumen.datos;
        const fp = fichaResumen.propiedad;
        const fotos = fr.fotos || [];
        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10050, display: 'flex', justifyContent: 'flex-end' }}
            onClick={() => setFichaResumen({ abierta: false, propiedad: null, datos: null })}>
            <div
              className={FICHA_RESUMEN_ROOT_CLASS}
              style={{
              width: 720,
              height: '100%',
              background: c.bgCard,
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '-8px 0 40px rgba(0,0,0,0.30)',
              transform: `translate(${previewPanelPos.x}px, 0px)`,
              flexShrink: 0,
            }}
              onClick={e => e.stopPropagation()}>
              {/* Header sticky — arrastrable */}
              <div
                onMouseDown={startPreviewPanelDrag}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '8px 12px',
                  borderBottom: `1px solid ${c.border}`,
                  position: 'sticky',
                  top: 0,
                  background: c.bgCard,
                  zIndex: 10,
                  cursor: 'grab',
                  userSelect: 'none',
                }}
                title="Arrastrar para mover el panel"
              >
                <VistaPreviaRefPrecio prop={fp} fontSize={fichaResumenFontSize(12)} />
                <button type="button" onMouseDown={(e) => e.stopPropagation()} onClick={() => setFichaResumen({ abierta: false, propiedad: null, datos: null })} style={{ background: 'none', border: 'none', fontSize: fichaResumenFontSize(18), lineHeight: 1, color: c.textMuted, cursor: 'pointer', padding: '0 4px' }}>✕</button>
              </div>

              <div style={{ padding: "12px 12px 0", flex: 1, minHeight: 0, overflowY: "auto" }}>
                <FichaResumenGaleria fotos={fotos} videos={fr.videos || []} theme={theme} />
                <FichaResumenVistaSecciones p={fp} d={fr} theme={theme} />
              </div>
            </div>
          </div>
        );
      })()}

{/* ========== MODAL CITA ========== */}
      <ModalEleccionCitaExistente
        isOpen={Boolean(eleccionCitaPendiente)}
        cita={eleccionCitaPendiente}
        theme={theme}
        onClose={() => {
          setEleccionCitaPendiente(null);
          pendingCitaPropIdsRef.current = [];
        }}
        onAnadirExistente={() => {
          const cita = eleccionCitaPendiente;
          setEleccionCitaPendiente(null);
          if (cita?.id) void abrirModalCitaExistenteConSeleccion(String(cita.id));
        }}
        onNuevaCita={() => {
          setCitaPropsPendientesNueva([...pendingCitaPropIdsRef.current]);
          pendingCitaPropIdsRef.current = [];
          setEleccionCitaPendiente(null);
          abrirModalCitaNueva();
        }}
      />
      {modalCita && (
        <ModalCita
          isOpen={modalCita}
          onClose={cerrarModalCita}
          onConfirm={handleCitaConfirm}
          modoEdicion={!!citaEdicionAgendaId}
          initialValues={citaEdicionInitial}
          contact={{
            nombre: nom,
            telefono: tel,
            email: eml,
            iniciales: nom.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase(),
            clienteId: cliente?.id || null,
          }}
          onAbrirFichaCliente={(clienteId) => {
            if (clienteId && String(clienteId) === String(cliente?.id)) {
              window.scrollTo({ top: 0, behavior: "smooth" });
              return;
            }
            if (clienteId) transferCitaModalAFicha(`/clientes/${clienteId}`);
          }}
          onAbrirFichaContacto={(contactoId) => {
            if (contactoId) transferCitaModalAFicha(`/contactos/${contactoId}`);
          }}
          properties={
            citaEdicionAgendaId && citaEdicionProperties.length
              ? citaEdicionProperties
              : [...new Set([...seleccionadas, ...citaPropsPendientesNueva])].map((sid) => {
                const p = props.find((x) => String(x.id) === String(sid));
                if (!p) return null;
                let propietarios = [];
                if (Array.isArray(p.propietarios)) propietarios = p.propietarios;
                else if (typeof p.propietarios === "string") {
                  try { propietarios = JSON.parse(p.propietarios); } catch { propietarios = []; }
                }
                return mapPropiedadParaModalCita(p, propietarios);
              }).filter(Boolean)
          }
          agentName={lead?.agente_nombre || ''}
          onLlamarTelefono={(telefono) => llamarCliente(telefono, { vincularCitaPendiente: true })}
          onAbrirVistaPrevia={abrirFichaResumen}
          onBuscarPropiedadPorRef={(ref) => fetchPropiedadPorRef(api, ref)}
        />
      )}

      {modalCualificacionOpen && leadFlowId && leadEmbudoActivo && taskIsM1Type(tareaVigente) && (
        <ModalResultadoCualificacion
          isOpen={modalCualificacionOpen}
          onClose={() => {
            setModalCualificacionOpen(false);
            setTareaModalDescartado(true);
            if (tareaVigente?.id) dismissedTaskIdsRef.current.add(tareaVigente.id);
          }}
          lead={leadEmbudoActivo}
          tarea={tareaVigente}
          theme={theme}
          onCompleted={async () => {
            // Marca la tarea actual como descartada ANTES de recargar: en "ahora no"
            // el modal sigue siendo M1 (taskIsM1Type ignora el snooze) y, sin esto,
            // la recarga lo reabriría al instante ("cierro y vuelve").
            if (tareaVigente?.id) dismissedTaskIdsRef.current.add(tareaVigente.id);
            setModalCualificacionOpen(false);
            setModalResultadoVisitaOpen(false);
            await recargarTareaHistorialFlow();
            const cid = cliente?.id || lead?.cliente_id || null;
            if (cid) {
              await cargarMarcadoresVisitaCliente(cid);
              const dmId = demActIdRef.current || demAct?.id;
              if (dmId) await cargarEstados(dmId, cid);
            }
            if (esRutaCliente && cliente?.id) {
              try {
                const rl = await api.get(`/leads?cliente_id=${cliente.id}`);
                setLeadsV(rl.data?.data || []);
              } catch { /* ignore */ }
            }
          }}
          onLlamarTelefono={(telefono) => llamarCliente(telefono, { vincularCitaPendiente: false })}
        />
      )}

      {modalResultadoVisitaOpen && taskIsM2Type(tareaVigente) && (
        <ModalResultadoVisita
          isOpen={modalResultadoVisitaOpen}
          tarea={tareaVigente}
          theme={theme}
          onClose={() => {
            manualM2T4b1TaskIdRef.current = null;
            setModalResultadoVisitaOpen(false);
            setTareaModalDescartado(true);
            if (tareaVigente?.id) dismissedTaskIdsRef.current.add(tareaVigente.id);
          }}
          onCompleted={async () => {
            manualM2T4b1TaskIdRef.current = null;
            if (tareaVigente?.id) dismissedTaskIdsRef.current.add(tareaVigente.id);
            setModalResultadoVisitaOpen(false);
            await recargarTareaHistorialFlow();
            const cid = cliente?.id || lead?.cliente_id || null;
            if (cid) {
              await cargarMarcadoresVisitaCliente(cid);
              const dmId = demActIdRef.current || demAct?.id;
              if (dmId) await cargarEstados(dmId, cid);
            }
          }}
          onSegundaVisita={async (tarea, ctx) => {
            setModalResultadoVisitaOpen(false);
            await abrirSegundaVisita(tarea, ctx);
          }}
        />
      )}

      {segundaVisitaTarea && (
        <ModalCita
          isOpen={true}
          onClose={cerrarSegundaVisita}
          onConfirm={handleSegundaVisitaConfirm}
          modoEdicion={false}
          cerrarAlClicFuera={false}
          contact={{
            nombre: nom,
            telefono: tel,
            email: eml,
            iniciales: nom.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase(),
            clienteId: cliente?.id || null,
          }}
          onAbrirFichaCliente={(clienteId) => {
            if (clienteId && String(clienteId) === String(cliente?.id)) {
              window.scrollTo({ top: 0, behavior: "smooth" });
              return;
            }
            if (clienteId) transferCitaModalAFicha(`/clientes/${clienteId}`);
          }}
          onAbrirFichaContacto={(contactoId) => {
            if (contactoId) transferCitaModalAFicha(`/contactos/${contactoId}`);
          }}
          properties={segundaVisitaProps}
          agentName={lead?.agente_nombre || ''}
          onLlamarTelefono={(telefono) => llamarCliente(telefono, { vincularCitaPendiente: true })}
          onAbrirVistaPrevia={abrirFichaResumen}
          onBuscarPropiedadPorRef={(ref) => fetchPropiedadPorRef(api, ref)}
        />
      )}

      {modalResultadoAgenteOpen && isAgenteResultTask(tareaVigente) && (
        <ModalResultadoTareaAgente
          isOpen={modalResultadoAgenteOpen}
          tarea={tareaVigente}
          theme={theme}
          onClose={() => setModalResultadoAgenteOpen(false)}
          onCompleted={async () => {
            setModalResultadoAgenteOpen(false);
            await recargarTareaHistorialFlow();
          }}
        />
      )}

{/* ========== MODAL WHATSAPP ========== */}
       {modalWhatsApp && (
        <ModalWhatsApp
          isOpen={modalWhatsApp}
          idioma={lead?.idioma || cliente?.idioma || 'ES'}
          crmContext={{
            cliente_id: cliente?.id || lead?.cliente_id || null,
            lead_id:
              tareaVigente?.lead_id ||
              leadFlowId ||
              (!esRutaCliente && id && id !== "nuevo" ? id : null),
          }}
          onClose={() => setModalWhatsApp(false)}
          onSend={(data) => {
            handleWhatsAppSend(data);
          }}
          contact={{
            nombre: nom,
            telefono: tel,
            iniciales: nom.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase(),
          }}
          properties={seleccionadas.map(sid => {
            const p = props.find(x => x.id === sid);
            return p ? {
              id: p.id,
              titulo: p.titulo || 'Sin título',
              detalle: `${p.tipo_nombre || p.tipo || ''} · ${p.poblacion_nombre || p.poblacion || ''}`,
              precio: p.precio ? `${Number(p.precio).toLocaleString('es-ES')} €` : 'Consultar',
              icono: '🏠',
              tipo: p.tipo_nombre || p.tipo || '',
              poblacion: p.poblacion_nombre || p.poblacion || '',
              zona: p.zona_nombre || '',
              habitaciones: p.num_dormitorios || null,
              banos: p.num_banos || null,
              m2: p.m2_construidos || null,
              referencia: p.referencia || '',
              tenemos_llaves: p.tenemos_llaves || false,
              num_llave: p.num_llave || null,
              recoger_llaves_en: p.recoger_llaves_en || null,
            } : null;
          }).filter(Boolean)}
        />
      )}

{/* ========== MODAL NOTA ========== */}
      {modalNota && (
        <ModalNota
          isOpen={modalNota}
          onClose={() => setModalNota(false)}
          onSave={(data) => {
            handleNotaSave(data);
          }}
          contact={{
            nombre: nom,
            iniciales: nom.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase(),
          }}
        />
      )}

      {modalPortales && (
  <ModalPortales
    onClose={() => setModalPortales(false)}
    criterios={cr}
    onSeleccionar={(tipo) => {
      setPropsExternasTipo(tipo);
      buscarPropsExternas(tipo, cr, 1);
    }}
  />
)}

      <ModalDemandaZonaMapa
        open={modalZonaMapa}
        onClose={() => setModalZonaMapa(false)}
        poblacion={poblacionParaMapa}
        geoLat={cr.geoLat}
        geoLng={cr.geoLng}
        geoRadioM={cr.geoRadioM}
        theme={theme}
        onApply={({ geoLat, geoLng, geoRadioM }) => {
          userModified.current = true;
          let la = geoLat;
          let ln = geoLng;
          let r = geoRadioM;
          if (la != null && ln != null && !coordsEnMarinaAlta(la, ln)) {
            la = null;
            ln = null;
            r = null;
          }
          setCr((p) => ({ ...p, geoLat: la, geoLng: ln, geoRadioM: r }));
          setModalZonaMapa(false);
        }}
      />

      {modalPrint && (
        <ModalImprimirPropiedades
          isOpen={modalPrint}
          onClose={() => setModalPrint(false)}
          propiedades={seleccionadas.map(sid => props.find(x => x.id === sid)).filter(Boolean)}
        />
      )}

{/* ========== MODAL EMAIL ========== */}
      {modalEmail && (
        <ModalEmail
          isOpen={modalEmail}
          idioma={lead?.idioma || cliente?.idioma || 'ES'}
          onClose={() => setModalEmail(false)}
          crmContext={{
            cliente_id: cliente?.id || lead?.cliente_id || null,
            lead_id:
              tareaVigente?.lead_id ||
              leadFlowId ||
              (!esRutaCliente && id && id !== "nuevo" ? id : null),
          }}
          onSend={(data) => {
            void handleEmailSend(data);
          }}
          contact={{
            nombre: nom,
            email: eml,
            iniciales: nom.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase(),
          }}
          properties={seleccionadas.map(sid => {
            const p = props.find(x => String(x.id) === String(sid));
            return p ? {
              id: p.id,
              titulo: p.titulo || 'Sin título',
              detalle: `${p.tipo_nombre || p.tipo || ''} · ${p.poblacion_nombre || p.poblacion || ''}`,
              precio: p.precio ? `${Number(p.precio).toLocaleString('es-ES')} €` : 'Consultar',
              icono: '🏠',
              tipo: p.tipo_nombre || p.tipo || '',
              poblacion: p.poblacion_nombre || p.poblacion || '',
              zona: p.zona_nombre || '',
              habitaciones: p.num_dormitorios || null,
              banos: p.num_banos || null,
              m2: p.m2_construidos || null,
              referencia: p.referencia || '',
              tenemos_llaves: p.tenemos_llaves || false,
              num_llave: p.num_llave || null,
              recoger_llaves_en: p.recoger_llaves_en || null,
            } : null;
          }).filter(Boolean)}
        />
      )}

      {/* Animación pulse para el indicador "En vivo" */}
      <style>{`
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
      {/* ── Modal Duplicado ── */}
      {modalDuplicado && (() => {
        const otro = modalDuplicado.clienteExistente;
        const nombreOtro = otro ? `${otro.nombre || ''} ${otro.apellido || ''}`.trim() : 'otro cliente';
        const agenteOtro = modalDuplicado.agente_nombre || otro?.agente_nombre || '';
        const tipoCampo = modalDuplicado.campo === 'email' ? 'email' : 'teléfono';
        const isDarkM = theme.name === 'dark';
        return (
          <div style={{
            position: 'fixed', inset: 0, background: 'transparent',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start',
            paddingTop: 140, paddingLeft: 20,
            zIndex: 2000, fontFamily: "'DM Sans', sans-serif",
            pointerEvents: 'none',
          }}>
            <div style={{ pointerEvents: 'all',
              width: 340, background: c.bgCard, borderRadius: 14, overflow: 'hidden',
              border: `1px solid ${c.border}`,
              boxShadow: isDarkM
                ? '0 0 60px 15px rgba(255,255,255,0.18), 0 0 120px 40px rgba(255,255,255,0.10)'
                : '0 0 60px 15px rgba(0,0,0,0.07), 0 0 120px 40px rgba(0,0,0,0.04)',
            }}>
              {/* Barra naranja superior */}
              <div style={{ height: 3, background: 'linear-gradient(90deg, #f59e0b, #ef4444, #f59e0b)' }} />
              {/* Header */}
              <div style={{ padding: '18px 20px 0', display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 9,
                  background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 16, boxShadow: '0 4px 12px rgba(239,68,68,0.35)',
                }}>⚠️</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: c.textPrimary }}>
                    {modalDuplicado.duplicate_type === 'exact' ? 'Duplicado detectado' : 'Muy posible duplicado'}
                  </div>
                  <div style={{ fontSize: 11, color: c.textMuted, marginTop: 1 }}>
                    {modalDuplicado.duplicate_type === 'exact'
                      ? `Ya existe un cliente con ese ${tipoCampo}`
                      : `Es muy posible que ese ${tipoCampo} sea de este cliente`}
                  </div>
                </div>
                <button onClick={() => setModalDuplicado(null)} style={{
                  marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 18, color: c.textMuted, lineHeight: 1,
                }}>×</button>
              </div>
              {/* Cliente existente */}
              <div style={{ padding: '14px 20px' }}>
                <div style={{
                  background: isDarkM ? 'rgba(245,158,11,0.08)' : 'rgba(245,158,11,0.06)',
                  border: `1px solid rgba(245,158,11,0.2)`,
                  borderRadius: 8, padding: '10px 14px',
                }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: c.textPrimary }}>{nombreOtro}</div>
                  {agenteOtro && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 3 }}>🧑‍💼 {agenteOtro}</div>}
                </div>
                <div style={{ fontSize: 11, color: c.textMuted, marginTop: 10, marginBottom: 14 }}>
                  {modalDuplicado.mensaje || 'Comprueba si realmente es la misma persona antes de guardar.'}
                  {modalDuplicado.reason ? ` Motivo: ${modalDuplicado.reason}.` : ''}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => { const d = modalDuplicado; setModalDuplicado(null); setCliente(prev => ({ ...(prev || {}), [d.campo]: '' })); setLead(prev => ({ ...(prev || {}), [d.campo]: '' })); }} style={{
                    flex: 1, padding: '8px 0', borderRadius: 8, border: `1px solid ${c.border}`,
                    background: c.bgApp, color: c.textPrimary, fontSize: 12, fontWeight: 500, cursor: 'pointer',
                  }}>Cancelar</button>
                  {modalDuplicado.duplicate_type !== 'exact' && (
                    <button onClick={() => { const d = modalDuplicado; setModalDuplicado(null); guardarCampoCliente(d.campo, d.valor, true); }} style={{
                      flex: 1, padding: '8px 0', borderRadius: 8, border: 'none',
                      background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                      color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    }}>Guardar igualmente</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {modalClienteCreacion && (() => {
        const d = modalClienteCreacion.response || {};
        const otro = d.cliente_existente || {};
        const nombreOtro = `${otro.nombre || ''} ${otro.apellido || ''}`.trim() || 'otro cliente';
        const isDarkM = theme.name === 'dark';
        return (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 2200, fontFamily: "'DM Sans', sans-serif",
          }}>
            <div style={{
              width: 430, maxWidth: '92vw', background: c.bgCard, borderRadius: 14, overflow: 'hidden',
              border: `1px solid ${c.border}`,
              boxShadow: isDarkM ? '0 0 40px rgba(0,0,0,0.5)' : '0 20px 50px rgba(0,0,0,0.2)',
            }}>
              <div style={{ height: 3, background: 'linear-gradient(90deg, #f59e0b, #ef4444)' }} />
              <div style={{ padding: '18px 20px 0', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 9,
                  background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                }}>⚠️</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: c.textPrimary }}>
                    {d.duplicate_type === 'exact' ? 'Cliente duplicado' : 'Muy posible cliente duplicado'}
                  </div>
                  <p style={{ fontSize: 12, color: c.textMuted, margin: '8px 0 0', lineHeight: 1.5 }}>
                    {d.mensaje || 'Es muy posible que este teléfono o email sea de este otro cliente. Compruébalo antes de crear uno nuevo.'}
                    {d.reason ? ` Motivo: ${d.reason}.` : ''}
                  </p>
                  <div style={{
                    marginTop: 12, padding: '10px 12px', borderRadius: 8,
                    background: isDarkM ? 'rgba(245,158,11,0.08)' : '#fffbeb',
                    border: `1px solid ${isDarkM ? '#f59e0b60' : '#fde68a'}`,
                  }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: c.textPrimary }}>{nombreOtro}</div>
                    {otro.email && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 4 }}>{otro.email}</div>}
                    {otro.telefono && <div style={{ fontSize: 11, color: c.textMuted }}>{otro.telefono}</div>}
                    {d.agente_nombre && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 4 }}>Agente actual: {d.agente_nombre}</div>}
                  </div>
                </div>
                <button type="button" onClick={() => setModalClienteCreacion(null)} style={{
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: c.textMuted, lineHeight: 1,
                }}>×</button>
              </div>
              <div style={{ padding: '16px 20px 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <button
                  type="button"
                  onClick={() => { setModalClienteCreacion(null); if (otro.id) nav(`/clientes/${otro.id}`); }}
                  style={{
                    width: '100%', padding: '10px 0', borderRadius: 8, border: 'none',
                    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  Abrir cliente existente
                </button>
                {d.duplicate_type !== 'exact' && (
                  <button
                    type="button"
                    onClick={() => { const retryOpts = modalClienteCreacion.retryOpts || {}; setModalClienteCreacion(null); crearClienteNuevo({ ...retryOpts, forzar_duplicado: true }); }}
                    disabled={guardando}
                    style={{
                      width: '100%', padding: '9px 0', borderRadius: 8, border: `1px solid ${c.border}`,
                      background: c.bgApp, color: c.textPrimary, fontSize: 12, fontWeight: 500, cursor: guardando ? 'wait' : 'pointer',
                    }}
                  >
                    Crear cliente igualmente
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setModalClienteCreacion(null)}
                  style={{
                    width: '100%', padding: '8px 0', borderRadius: 8, border: 'none',
                    background: 'transparent', color: c.accentBlue, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Modal lead suelto (crear cliente nuevo) ── */}
      {modalLeadSuelto && (() => {
        const le = modalLeadSuelto.lead_existente || {};
        const nombreLead = `${le.nombre || ''} ${le.apellido || ''}`.trim() || `Lead #${le.id}`;
        const isDarkM = theme.name === 'dark';
        return (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 2100, fontFamily: "'DM Sans', sans-serif",
          }}>
            <div style={{
              width: 400, maxWidth: '92vw', background: c.bgCard, borderRadius: 14, overflow: 'hidden',
              border: `1px solid ${c.border}`,
              boxShadow: isDarkM ? '0 0 40px rgba(0,0,0,0.5)' : '0 20px 50px rgba(0,0,0,0.2)',
            }}>
              <div style={{ height: 3, background: 'linear-gradient(90deg, #3b82f6, #2563eb)' }} />
              <div style={{ padding: '18px 20px 0', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 9,
                  background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                }}>🔗</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: c.textPrimary }}>Lead sin cliente vinculado</div>
                  <p style={{ fontSize: 12, color: c.textMuted, margin: '8px 0 0', lineHeight: 1.5 }}>
                    {modalLeadSuelto.mensaje || 'Hay un lead activo con el mismo teléfono o email.'}
                  </p>
                  <div style={{
                    marginTop: 12, padding: '10px 12px', borderRadius: 8,
                    background: isDarkM ? 'rgba(59,130,246,0.1)' : '#eff6ff',
                    border: `1px solid ${isDarkM ? '#1e40af60' : '#bfdbfe'}`,
                  }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: c.textPrimary }}>{nombreLead}</div>
                    {le.email && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 4 }}>{le.email}</div>}
                    {(le.telefono || le.whatsapp) && (
                      <div style={{ fontSize: 11, color: c.textMuted }}>{le.telefono || le.whatsapp}</div>
                    )}
                    {le.etapa && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 4 }}>Etapa: {le.etapa}</div>}
                  </div>
                </div>
                <button type="button" onClick={() => setModalLeadSuelto(null)} style={{
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: c.textMuted, lineHeight: 1,
                }}>×</button>
              </div>
              <div style={{ padding: '16px 20px 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <button
                  type="button"
                  onClick={() => { const id = le.id; setModalLeadSuelto(null); crearClienteNuevo({ asociar_lead_id: id }); }}
                  disabled={guardando}
                  style={{
                    width: '100%', padding: '10px 0', borderRadius: 8, border: 'none', cursor: guardando ? 'wait' : 'pointer',
                    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: '#fff', fontSize: 13, fontWeight: 600,
                  }}
                >
                  Vincular este lead y crear el cliente
                </button>
                <button
                  type="button"
                  onClick={() => { setModalLeadSuelto(null); crearClienteNuevo({ ignorar_lead_suelto: true }); }}
                  disabled={guardando}
                  style={{
                    width: '100%', padding: '9px 0', borderRadius: 8, border: `1px solid ${c.border}`,
                    background: c.bgApp, color: c.textPrimary, fontSize: 12, fontWeight: 500, cursor: guardando ? 'wait' : 'pointer',
                  }}
                >
                  Crear cliente sin vincular el lead
                </button>
                <button
                  type="button"
                  onClick={() => { setModalLeadSuelto(null); if (le.id) nav(`/pipeline?openLead=${le.id}`); }}
                  style={{
                    width: '100%', padding: '8px 0', borderRadius: 8, border: 'none',
                    background: 'transparent', color: c.accentBlue, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  Abrir ficha del lead
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Modal visor de conversación completa ── */}
      {leadModalHistorial && (
        <ModalNuevoLead
          isOpen={true}
          lead={leadModalHistorial}
          onClose={() => {
            setLeadModalHistorial(null);
            recargarTareaHistorialFlow();
            cargar();
          }}
          onLeadUpdated={(actualizado) => {
            setLeadModalHistorial((prev) => (prev ? { ...prev, ...actualizado } : null));
          }}
        />
      )}
      {visorHistorial && (() => {
        const isDarkM = theme.name === 'dark';
        const esLlamadaAna = visorHistorial.tipo === 'llamada_ana';
        const esDialogo = esLlamadaAna || visorHistorial.tipo === 'llamada';
        const fecha = visorHistorial.fecha
          ? new Date(visorHistorial.fecha).toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
          : '';
        const refsModal = refsVisorHistorial(visorHistorial, props);
        const textoMensaje = contenidoHistorialSinLineaFichas(visorHistorial.contenido);
        const tituloModal = visorHistorial.tipo === 'whatsapp_enviado'
          ? etiquetaWhatsAppEnviadoHistorial(visorHistorial)
          : (VISOR_HISTORIAL_TITULOS[visorHistorial.tipo]
            || visorHistorial.asunto
            || 'Detalle');

        // Formatear conversación: soporta [Ana]: / [Lead]:, agent: / user:, Agente: / Cliente:
        const renderContenido = () => {
          const txt = esDialogo ? (visorHistorial.contenido || '') : textoMensaje;

          if (!esDialogo) {
            return (
              <div style={{ fontSize: 13, color: c.textSecondary, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                {txt || '—'}
              </div>
            );
          }

          const lineas = txt.split('\n');
          // Detectar líneas de diálogo (todos los formatos)
          const parseLínea = (l) => {
            if (l.startsWith('[Ana]:'))       return { rol: 'ana',    msg: l.replace(/^\[Ana\]:\s*/, '') };
            if (l.startsWith('[Lead]:'))      return { rol: 'lead',   msg: l.replace(/^\[Lead\]:\s*/, '') };
            if (/^agent:\s*/i.test(l))        return { rol: 'ana',    msg: l.replace(/^agent:\s*/i, '') };
            if (/^user:\s*/i.test(l))         return { rol: 'lead',   msg: l.replace(/^user:\s*/i, '') };
            if (/^Agente:\s*/i.test(l))       return { rol: 'agente', msg: l.replace(/^Agente:\s*/i, '') };
            if (/^Cliente:\s*/i.test(l))      return { rol: 'lead',   msg: l.replace(/^Cliente:\s*/i, '') };
            return null;
          };
          // Intentar parsear con etiquetas de hablante
          const lineasConEtiqueta = lineas
            .map(l => parseLínea(l))
            .filter(p => p && p.msg.trim().length > 0);

          // Si no hay etiquetas (transcripción antigua o Engine B sin speaker diarization),
          // usar alternancia: par = agente (izquierda), impar = cliente (derecha)
          const lineasDialogo = lineasConEtiqueta.length > 0
            ? lineasConEtiqueta
            : lineas
                .map(l => l.trim())
                .filter(l => l.length > 0)
                .map((msg, i) => ({ rol: i % 2 === 0 ? 'agente' : 'lead', msg }));

          if (lineasDialogo.length === 0) {
            return (
              <div style={{ fontSize: 13, color: c.textSecondary, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                {txt}
              </div>
            );
          }

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {lineasDialogo.map((parsed, i) => {
                const esIzquierda = parsed.rol === 'ana' || parsed.rol === 'agente';
                const inicial = parsed.rol === 'ana' ? 'A' : parsed.rol === 'agente' ? 'AG' : 'C';
                const colorAvatar = parsed.rol === 'ana'
                  ? 'linear-gradient(135deg, #7c3aed, #6d28d9)'
                  : parsed.rol === 'agente'
                    ? 'linear-gradient(135deg, #0ea5e9, #0284c7)'
                    : (isDarkM ? '#334155' : '#e2e8f0');
                const colorBurbuja = parsed.rol === 'ana'
                  ? (isDarkM ? 'rgba(109,40,217,0.18)' : 'rgba(109,40,217,0.08)')
                  : parsed.rol === 'agente'
                    ? (isDarkM ? 'rgba(14,165,233,0.18)' : 'rgba(14,165,233,0.08)')
                    : (isDarkM ? '#1e293b' : '#f1f5f9');
                return (
                  <div key={i} style={{ display: 'flex', flexDirection: esIzquierda ? 'row' : 'row-reverse', gap: 8, alignItems: 'flex-start' }}>
                    <div style={{
                      flexShrink: 0, width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: colorAvatar, fontSize: 9, fontWeight: 700,
                      color: parsed.rol === 'lead' ? c.textPrimary : '#fff',
                    }}>{inicial}</div>
                    <div style={{
                      maxWidth: '75%', padding: '8px 12px',
                      borderRadius: esIzquierda ? '4px 12px 12px 12px' : '12px 4px 12px 12px',
                      background: colorBurbuja,
                      fontSize: 13, color: c.textPrimary, lineHeight: 1.5,
                    }}>{parsed.msg}</div>
                  </div>
                );
              })}
            </div>
          );
        };

        return (
          <div onClick={() => setVisorHistorial(null)} style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background: isDarkM ? '#1e293b' : '#fff',
              borderRadius: 16, padding: '24px 24px 20px', width: '90%', maxWidth: 560,
              maxHeight: '80vh', display: 'flex', flexDirection: 'column', gap: 16,
              boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
            }}>
              {/* Cabecera */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: c.textPrimary }}>
                    {tituloModal}
                    {esDialogo && visorHistorial.asunto && visorHistorial.asunto !== tituloModal
                      ? ` — ${visorHistorial.asunto}`
                      : ''}
                  </div>
                  {fecha && <div style={{ fontSize: 11, color: c.textMuted, marginTop: 2 }}>{fecha}</div>}
                </div>
                <button onClick={() => setVisorHistorial(null)} style={{
                  background: 'none', border: 'none', cursor: 'pointer', color: c.textMuted, padding: 4, borderRadius: 6,
                }}>
                  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>

              {/* Conversación / mensaje */}
              <div style={{ flex: 1, overflowY: 'auto', paddingRight: 4 }}>
                {renderContenido()}
              </div>

              {/* Fichas enviadas — clic abre vista previa sin cerrar este modal */}
              {refsModal.length > 0 && (
                <div style={{ borderTop: `1px solid ${c.border}`, paddingTop: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: c.textMuted, marginBottom: 8 }}>
                    Fichas enviadas ({refsModal.length})
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {refsModal.map((pe, i) => (
                      <button
                        key={`${pe.ref || pe.id || i}`}
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (pe.id) abrirFichaResumen(pe.id);
                          else if (pe.ref) abrirFichaPorRef(pe.ref);
                        }}
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          padding: '6px 12px',
                          borderRadius: 8,
                          background: c.accentBlueLight,
                          color: theme.name === 'dark' ? '#ffffff' : c.accentBlue,
                          border: `1px solid ${c.accentBlueBorder}`,
                          cursor: 'pointer',
                          fontFamily: 'inherit',
                        }}
                        title="Ver vista previa de la propiedad"
                      >
                        {pe.ref || pe.titulo || (pe.id ? String(pe.id).substring(0, 8) : "—")}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}
      {softWarnCliente.modal}
    </div>
  );
}
